var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _ellipse, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse2, _path9, _ellipse3, _path10, _ellipse4, _polygon22, _polygon23, _polygon24, _path11, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _g, _g2, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _path12, _polygon42, _polygon43, _polygon44, _polygon45, _g3, _polygon46, _polygon47, _polygon48, _path13, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _path14, _ellipse5, _path15, _ellipse6, _path16, _ellipse7, _polygon70, _polygon71, _polygon72, _path17, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _g4, _g5, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _g6, _g7, _polygon102, _polygon103, _polygon104, _path18, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _g8, _g9, _polygon136, _polygon137, _polygon138, _path19, _ellipse8, _path20, _ellipse9, _path21, _ellipse10, _polygon139, _polygon140, _polygon141, _polygon142, _path22, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _g10, _g11, _polygon150, _polygon151, _polygon152, _path23, _ellipse11, _path24, _ellipse12, _path25, _ellipse13, _polygon153, _polygon154, _path26, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283, _polygon284, _polygon285, _polygon286, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _polygon325, _polygon326, _polygon327, _polygon328, _polygon329, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337, _polygon338, _polygon339, _polygon340, _polygon341, _polygon342, _polygon343, _polygon344, _polygon345, _polygon346, _polygon347, _polygon348, _polygon349, _polygon350, _path27, _polygon351, _polygon352, _polygon353, _polygon354, _polygon355, _polygon356, _polygon357, _polygon358, _polygon359, _polygon360, _polygon361, _polygon362, _polygon363, _polygon364, _polygon365, _path28, _polygon366, _polygon367, _polygon368, _polygon369, _polygon370, _polygon371, _polygon372, _polygon373, _polygon374, _polygon375, _polygon376, _polygon377, _polygon378, _polygon379, _polygon380, _polygon381, _polygon382, _polygon383, _polygon384, _polygon385, _polygon386, _polygon387, _polygon388, _polygon389, _polygon390, _g12, _polygon391, _polygon392, _polygon393, _polygon394, _g13, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon395, _polygon396, _polygon397, _polygon398, _polygon399, _polygon400, _polygon401, _polygon402, _polygon403, _polygon404, _polygon405, _polygon406, _polygon407, _polygon408, _polygon409, _polygon410, _ellipse14, _polygon411, _polygon412, _polygon413, _path44, _polygon414, _polygon415, _polygon416, _path45, _polygon417, _polygon418, _polygon419, _polygon420, _polygon421, _polygon422, _polygon423, _polygon424, _polygon425, _polygon426, _ellipse15, _polygon427, _polygon428, _polygon429, _polygon430, _polygon431, _polygon432, _polygon433, _polygon434, _polygon435, _g14, _g15, _polygon436, _polygon437, _polygon438, _polygon439, _polygon440, _polygon441, _polygon442, _polygon443, _polygon444, _polygon445, _polygon446, _polygon447, _polygon448, _polygon449, _polygon450, _polygon451, _polygon452, _polygon453, _polygon454, _polygon455, _polygon456, _polygon457, _path46, _path47, _polygon458, _path48, _path49, _polygon459, _path50, _path51, _path52, _path53, _polygon460, _path54, _polygon461, _polygon462, _rect, _path55, _polygon463, _polygon464, _path56, _polygon465, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _polygon466, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon467, _path83, _path84, _path85, _path86, _path87, _path88, _polygon468, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchainNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2600 1700",
    id: "Blockchainnetwork",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 940.93,
    x2: 1268.06,
    y1: 1527.27,
    y2: 1200.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddfcff",
    className: "stopColordde8ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4fdff",
    className: "stopColore4f1ff svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 723.24,
    x2: 1001.99,
    y1: 1503.08,
    y2: 1224.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2fafd",
    className: "stopColord2e1fd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c1f1f5",
    className: "stopColorc1d1f5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1e1e6",
    className: "stopColora1b3e6 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 790.06,
    x2: 1177.05,
    y1: 1109.16,
    y2: 1109.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddfcff",
    className: "stopColordde8ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#eefeff",
    className: "stopColoreef4ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 1826.19,
    x2: 2125.07,
    y1: 1541.4,
    y2: 1242.52,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1608.5,
    x2: 1859,
    y1: 1517.21,
    y2: 1266.71,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 1661.2,
    x2: 2048.18,
    y1: 1165.64,
    y2: 1165.64,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 1643.45,
    x2: 1835.02,
    y1: 1551.86,
    y2: 1360.28,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1503.48,
    x2: 1663.98,
    y1: 1536.32,
    y2: 1375.82,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 1537.05,
    x2: 1785.88,
    y1: 1311.12,
    y2: 1311.12,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 1349.43,
    x2: 1507.74,
    y1: 1550.63,
    y2: 1392.32,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 1241.63,
    x2: 1376.01,
    y1: 1538.66,
    y2: 1404.28,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 1272.87,
    x2: 1464.53,
    y1: 1349.08,
    y2: 1349.08,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 1291.93,
    x2: 1373.59,
    y1: 1588.96,
    y2: 1507.3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 1184.13,
    x2: 1241.85,
    y1: 1576.99,
    y2: 1519.27,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 1177.05,
    x2: 1368.7,
    y1: 1502.39,
    y2: 1502.39,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 988.28,
    x2: 988.28,
    y1: 836.5,
    y2: 785.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99ebf2",
    className: "stopColor99bcf2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65dce6",
    className: "stopColor6597e6 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 996.32,
    x2: 1054.07,
    y1: 821.35,
    y2: 821.35,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 982.84,
    x2: 982.84,
    y1: 840.55,
    y2: 806.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77dfe7",
    className: "stopColor77a3e7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39c9d4",
    className: "stopColor3975d4 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 1004.36,
    x2: 1040.27,
    y1: 844.61,
    y2: 808.69,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 1017.67,
    x2: 1017.67,
    y1: 761.32,
    y2: 658.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5feff",
    className: "stopColorfffdf5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5edf3",
    className: "stopColorf3e5a5 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 969.55,
    x2: 1055.07,
    y1: 712.6,
    y2: 712.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5be9f4",
    className: "stopColorf49d5b svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5be9f4",
    className: "stopColorf4c15b svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1254.38,
    x2: 1370.74,
    y1: 1358.24,
    y2: 1358.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1e1e6",
    className: "stopColora1c3e6 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 1370.74,
    x2: 1370.74,
    y1: 1231.43,
    y2: 1162.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5f9fd",
    className: "stopColorc5dcfd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86e8f0",
    className: "stopColor86aff0 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 1405.39,
    x2: 1405.39,
    y1: 1300.74,
    y2: 1196.77,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 1336.09,
    x2: 1336.09,
    y1: 1310,
    y2: 1232.59,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1428.87,
    x2: 1394.87,
    y1: 1151.23,
    y2: 1167.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5beaf5",
    className: "stopColorf59e5b svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5beaf5",
    className: "stopColorf5c25b svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 1155.31,
    x2: 1271.67,
    y1: 1518.36,
    y2: 1518.36,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 1329.8,
    x2: 1295.8,
    y1: 1472.09,
    y2: 1488.37,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 1271.67,
    x2: 1271.67,
    y1: 1255.41,
    y2: 1322.16,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1271.67,
    x2: 1297,
    y1: 1293.51,
    y2: 1293.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5edf3",
    className: "stopColorf3e5a5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5be9f4",
    className: "stopColorf4c15b svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 1246.94,
    x2: 1271.87,
    y1: 1293.51,
    y2: 1293.51,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 1108.3,
    x2: 1224.66,
    y1: 785.68,
    y2: 785.68,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 1185.09,
    x2: 1185.09,
    y1: 662.78,
    y2: 632.93,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 1185.09,
    x2: 1214.94,
    y1: 670.24,
    y2: 670.24,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 1155.95,
    x2: 1185.32,
    y1: 670.24,
    y2: 670.24,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 1266.81,
    x2: 1266.81,
    y1: 662.78,
    y2: 632.93,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 1266.81,
    x2: 1296.66,
    y1: 670.24,
    y2: 670.24,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 1237.68,
    x2: 1267.05,
    y1: 670.24,
    y2: 670.24,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 1224.66,
    x2: 1224.66,
    y1: 683.86,
    y2: 654.01,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 1224.66,
    x2: 1254.51,
    y1: 691.32,
    y2: 691.32,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 1195.53,
    x2: 1224.9,
    y1: 691.32,
    y2: 691.32,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 1224.66,
    x2: 1224.66,
    y1: 599.89,
    y2: 570.04,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 1224.66,
    x2: 1254.51,
    y1: 607.35,
    y2: 607.35,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 1195.53,
    x2: 1224.9,
    y1: 607.35,
    y2: 607.35,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 1266.81,
    x2: 1266.81,
    y1: 620.8,
    y2: 590.95,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 1266.81,
    x2: 1296.66,
    y1: 628.26,
    y2: 628.26,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 1237.68,
    x2: 1267.05,
    y1: 628.26,
    y2: 628.26,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 1185.09,
    x2: 1185.09,
    y1: 620.8,
    y2: 590.95,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 1185.09,
    x2: 1214.94,
    y1: 628.26,
    y2: 628.26,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 1155.95,
    x2: 1185.32,
    y1: 628.26,
    y2: 628.26,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 1224.66,
    x2: 1224.66,
    y1: 641.88,
    y2: 612.03,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1224.66,
    x2: 1254.51,
    y1: 649.34,
    y2: 649.34,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1195.53,
    x2: 1224.9,
    y1: 649.34,
    y2: 649.34,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 1197.61,
    x2: 1313.97,
    y1: 815.87,
    y2: 815.87,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 1374,
    x2: 1257.14,
    y1: 770.88,
    y2: 826.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5beaf5",
    className: "stopColorf5c25b svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5beaf5",
    className: "stopColorf59e5b svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 1374,
    x2: 1257.14,
    y1: 743.54,
    y2: 799.47,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 1374,
    x2: 1257.14,
    y1: 716.2,
    y2: 772.13,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 1313.97,
    x2: 1313.97,
    y1: 689.06,
    y2: 619.74,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 1348.62,
    x2: 1348.62,
    y1: 758.37,
    y2: 654.4,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 1279.32,
    x2: 1279.32,
    y1: 767.63,
    y2: 690.22,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 1372.1,
    x2: 1338.1,
    y1: 608.86,
    y2: 625.13,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 1286.92,
    x2: 1403.28,
    y1: 875.01,
    y2: 875.01,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 1368.62,
    x2: 1368.62,
    y1: 803.03,
    y2: 699.06,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 1437.94,
    x2: 1437.94,
    y1: 759.71,
    y2: 725.06,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 1420.66,
    x2: 1420.66,
    y1: 764.03,
    y2: 738.09,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 1119.73,
    x2: 1119.73,
    y1: 764.03,
    y2: 738.09,
    gradientTransform: "matrix(-1 0 0 1 2488.34 0)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 1363.63,
    x2: 1363.63,
    y1: 574.33,
    y2: 544.47,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 1378.55,
    x2: 1378.55,
    y1: 604.17,
    y2: 559.4,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 1348.7,
    x2: 1348.7,
    y1: 608.16,
    y2: 574.82,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 1445.35,
    x2: 1445.35,
    y1: 574.33,
    y2: 544.47,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 1460.28,
    x2: 1460.28,
    y1: 604.17,
    y2: 559.4,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 1430.43,
    x2: 1430.43,
    y1: 608.16,
    y2: 574.82,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 1403.2,
    x2: 1403.2,
    y1: 595.41,
    y2: 565.55,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 1418.12,
    x2: 1418.12,
    y1: 625.25,
    y2: 580.48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 1388.28,
    x2: 1388.28,
    y1: 629.24,
    y2: 595.9,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 1403.2,
    x2: 1403.2,
    y1: 511.44,
    y2: 481.59,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 1418.12,
    x2: 1418.12,
    y1: 541.29,
    y2: 496.51,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 1388.28,
    x2: 1388.28,
    y1: 545.27,
    y2: 511.94,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 1445.35,
    x2: 1445.35,
    y1: 532.35,
    y2: 502.49,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 1460.28,
    x2: 1460.28,
    y1: 562.19,
    y2: 517.42,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 1430.43,
    x2: 1430.43,
    y1: 566.18,
    y2: 532.84,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 1363.63,
    x2: 1363.63,
    y1: 532.35,
    y2: 502.49,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 1378.55,
    x2: 1378.55,
    y1: 562.19,
    y2: 517.42,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 1348.7,
    x2: 1348.7,
    y1: 566.18,
    y2: 532.84,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 1403.2,
    x2: 1403.2,
    y1: 553.43,
    y2: 523.58,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 1418.12,
    x2: 1418.12,
    y1: 583.27,
    y2: 538.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 1388.28,
    x2: 1388.28,
    y1: 587.26,
    y2: 553.93,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 1376.22,
    x2: 1492.59,
    y1: 919.67,
    y2: 919.67,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 1492.59,
    x2: 1492.59,
    y1: 693.03,
    y2: 623.71,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 1527.24,
    x2: 1527.24,
    y1: 762.34,
    y2: 658.37,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 1457.93,
    x2: 1457.93,
    y1: 771.6,
    y2: 694.19,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 1552.66,
    x2: 1426.18,
    y1: 640.34,
    y2: 640.34,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 1492.59,
    x2: 1492.59,
    y1: 659.4,
    y2: 620.26,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 1552.66,
    x2: 1426.18,
    y1: 613,
    y2: 613,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 1492.59,
    x2: 1492.59,
    y1: 630.67,
    y2: 583.83,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 1552.66,
    x2: 1426.18,
    y1: 585.66,
    y2: 585.66,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 1492.59,
    x2: 1492.59,
    y1: 603.85,
    y2: 535.93,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 1491.68,
    x2: 1423.67,
    y1: 519.54,
    y2: 552.09,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 1460.9,
    x2: 1494.48,
    y1: 553.01,
    y2: 553.01,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 1465.53,
    x2: 1581.89,
    y1: 964.34,
    y2: 964.34,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 1581.89,
    x2: 1581.89,
    y1: 825.03,
    y2: 755.7,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 1616.55,
    x2: 1616.55,
    y1: 894.33,
    y2: 790.37,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 1547.24,
    x2: 1547.24,
    y1: 903.59,
    y2: 826.18,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 1547.24,
    x2: 1547.24,
    y1: 719.67,
    y2: 615.7,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 1581.97,
    x2: 1581.97,
    y1: 475.86,
    y2: 406.53,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 1616.62,
    x2: 1616.62,
    y1: 545.17,
    y2: 441.2,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 1547.32,
    x2: 1547.32,
    y1: 545.17,
    y2: 441.2,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 1570.73,
    x2: 1524.2,
    y1: 421.17,
    y2: 443.44,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 1570.73,
    x2: 1524.2,
    y1: 402.27,
    y2: 424.54,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 1570.73,
    x2: 1524.2,
    y1: 383.38,
    y2: 405.64,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 664,
    x2: 780.36,
    y1: 1381.21,
    y2: 1381.21,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 740.79,
    x2: 740.79,
    y1: 1258.31,
    y2: 1228.45,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 740.78,
    x2: 770.63,
    y1: 1265.77,
    y2: 1265.77,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 711.65,
    x2: 741.02,
    y1: 1265.77,
    y2: 1265.77,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 822.51,
    x2: 822.51,
    y1: 1258.31,
    y2: 1228.45,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 822.51,
    x2: 852.36,
    y1: 1265.77,
    y2: 1265.77,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 793.38,
    x2: 822.74,
    y1: 1265.77,
    y2: 1265.77,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 780.36,
    x2: 780.36,
    y1: 1279.39,
    y2: 1249.54,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 780.36,
    x2: 810.2,
    y1: 1286.85,
    y2: 1286.85,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 751.22,
    x2: 780.59,
    y1: 1286.85,
    y2: 1286.85,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 780.36,
    x2: 780.36,
    y1: 1195.42,
    y2: 1165.57,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 780.36,
    x2: 810.2,
    y1: 1202.88,
    y2: 1202.88,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 751.22,
    x2: 780.59,
    y1: 1202.88,
    y2: 1202.88,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 822.51,
    x2: 822.51,
    y1: 1216.33,
    y2: 1186.48,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 822.51,
    x2: 852.36,
    y1: 1223.79,
    y2: 1223.79,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 793.38,
    x2: 822.74,
    y1: 1223.79,
    y2: 1223.79,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 740.79,
    x2: 740.79,
    y1: 1216.33,
    y2: 1186.48,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 740.78,
    x2: 770.63,
    y1: 1223.79,
    y2: 1223.79,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 711.65,
    x2: 741.02,
    y1: 1223.79,
    y2: 1223.79,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 780.36,
    x2: 780.36,
    y1: 1237.41,
    y2: 1207.56,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 780.36,
    x2: 810.2,
    y1: 1244.87,
    y2: 1244.87,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 751.22,
    x2: 780.59,
    y1: 1244.87,
    y2: 1244.87,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 574.69,
    x2: 691.05,
    y1: 1425.88,
    y2: 1425.88,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 691.05,
    x2: 691.05,
    y1: 1337.59,
    y2: 1404.35,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 691.05,
    x2: 716.38,
    y1: 1375.69,
    y2: 1375.69,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 666.32,
    x2: 691.25,
    y1: 1375.69,
    y2: 1375.69,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 1765.35,
    x2: 1881.71,
    y1: 1449.67,
    y2: 1449.67,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 1881.71,
    x2: 1881.71,
    y1: 1361.39,
    y2: 1428.14,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 1881.71,
    x2: 1907.05,
    y1: 1399.48,
    y2: 1399.48,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 1856.98,
    x2: 1881.91,
    y1: 1399.48,
    y2: 1399.48,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 8737.91,
    x2: 8798.89,
    y1: 1126.77,
    y2: 1065.79,
    gradientTransform: "matrix(-1 0 0 1 10333.95 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 8756.03,
    x2: 8756.03,
    y1: 1168.83,
    y2: 1041.7,
    gradientTransform: "matrix(-1 0 0 1 10333.95 0)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 1969.57,
    x2: 2030.54,
    y1: 885.08,
    y2: 824.1,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 1248.03,
    x2: 1309,
    y1: 517.45,
    y2: 456.48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 1304.88,
    x2: 1226.82,
    y1: 477.41,
    y2: 514.77,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 750.12,
    x2: 811.1,
    y1: 1032.57,
    y2: 971.59,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 1555.95,
    x2: 1616.93,
    y1: 222.62,
    y2: 161.64,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 1574.07,
    x2: 1574.07,
    y1: 276,
    y2: 181.34,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 1702.72,
    x2: 1819.08,
    y1: 1166.08,
    y2: 1166.08,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 1749.78,
    x2: 1888.39,
    y1: 1079.44,
    y2: 1079.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86e8f0",
    className: "stopColor86aff0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5f9fd",
    className: "stopColorc5dcfd svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 1853.74,
    x2: 1853.74,
    y1: 1183.41,
    y2: 1079.44,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 1784.43,
    x2: 1784.43,
    y1: 1192.66,
    y2: 1115.25,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 1818.18,
    x2: 1750.16,
    y1: 853.27,
    y2: 885.82,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 1887.15,
    x2: 1887.15,
    y1: 731.01,
    y2: 704.76,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 1800.33,
    x2: 1800.33,
    y1: 793.54,
    y2: 745.31,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 1786.54,
    x2: 1902.91,
    y1: 1205.59,
    y2: 1205.59,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 1961.04,
    x2: 1927.04,
    y1: 1159.32,
    y2: 1175.6,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 1902,
    x2: 1833.99,
    y1: 1065.28,
    y2: 1097.83,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 1864.19,
    x2: 1864.19,
    y1: 993.31,
    y2: 964,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 1864.19,
    x2: 1893.49,
    y1: 1000.63,
    y2: 1000.63,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 1835.59,
    x2: 1864.42,
    y1: 1000.63,
    y2: 1000.63,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 1944.43,
    x2: 1944.43,
    y1: 993.31,
    y2: 964,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 1944.43,
    x2: 1973.73,
    y1: 1000.63,
    y2: 1000.63,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 1915.82,
    x2: 1944.66,
    y1: 1000.63,
    y2: 1000.63,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 1903.04,
    x2: 1903.04,
    y1: 1014,
    y2: 984.69,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 1903.04,
    x2: 1932.34,
    y1: 1021.33,
    y2: 1021.33,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 1874.44,
    x2: 1903.27,
    y1: 1021.33,
    y2: 1021.33,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 1903.04,
    x2: 1903.04,
    y1: 931.57,
    y2: 902.26,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 1903.04,
    x2: 1932.34,
    y1: 938.89,
    y2: 938.89,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 1874.44,
    x2: 1903.27,
    y1: 938.89,
    y2: 938.89,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 1864.19,
    x2: 1864.19,
    y1: 952.09,
    y2: 922.78,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 1864.19,
    x2: 1893.49,
    y1: 959.42,
    y2: 959.42,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 1835.59,
    x2: 1864.42,
    y1: 959.42,
    y2: 959.42,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 1903.04,
    x2: 1903.04,
    y1: 972.79,
    y2: 943.48,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 1903.04,
    x2: 1932.34,
    y1: 980.11,
    y2: 980.11,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 1874.44,
    x2: 1903.27,
    y1: 980.11,
    y2: 980.11,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 825.49,
    x2: 1003.55,
    y1: 1108.2,
    y2: 1108.2,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 1430.33,
    x2: 1539.91,
    y1: 1076.03,
    y2: 1076.03,
    gradientTransform: "matrix(-1 0 0 1 2485.3 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66c4cc",
    className: "stopColor6689cc svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#77ced5",
    className: "stopColor7796d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#a2e6eb",
    className: "stopColora2b8eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bef6fa",
    className: "stopColorbecefa svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 1029.26,
    x2: 1029.26,
    y1: 1100.24,
    y2: 1076.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89d8de",
    className: "stopColor89a5de svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 894.92,
    x2: 999.23,
    y1: 1079.49,
    y2: 1114.82,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 1080.5,
    x2: 924.74,
    y1: 906.93,
    y2: 1062.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#77dfe7",
    className: "stopColor77a3e7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39c9d4",
    className: "stopColor3975d4 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 792.16,
    x2: 1154.47,
    y1: 1012.33,
    y2: 950.49,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 1101.43,
    x2: 906.62,
    y1: 1077.26,
    y2: 861.95,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 807.85,
    x2: 1090.67,
    y1: 982.59,
    y2: 982.59,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 1816.81,
    x2: 1934.3,
    y1: 393.94,
    y2: 393.94,
    gradientTransform: "matrix(1 -.07 0 1 0 325.6)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 1850.13,
    x2: 1891.47,
    y1: 417.54,
    y2: 376.2,
    gradientTransform: "matrix(1 -.07 0 1 0 325.6)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 1015.18,
    x2: 1098.76,
    y1: 1487.27,
    y2: 1487.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddfcff",
    className: "stopColordde8ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c3f1f5",
    className: "stopColorc3d1f5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2eaee",
    className: "stopColorb2c3ee svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 1061.99,
    x2: 1061.99,
    y1: 1435.11,
    y2: 1399.3,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 947.17,
    x2: 1031.27,
    y1: 1535.2,
    y2: 1451.1,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 1088.77,
    x2: 1170.56,
    y1: 1543.23,
    y2: 1461.44,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 1075.38,
    x2: 1020.31,
    y1: 1510.18,
    y2: 1510.18,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 1046.88,
    x2: 1046.88,
    y1: 1463.42,
    y2: 1436.09,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 969.86,
    x2: 985.78,
    y1: 1498.82,
    y2: 1498.82,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 932.2,
    x2: 1001.38,
    y1: 1556.71,
    y2: 1487.53,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 982.23,
    x2: 982.23,
    y1: 1494.94,
    y2: 1417.07,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 1015.5,
    x2: 1015.5,
    y1: 1566.56,
    y2: 1483.81,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 1031.53,
    x2: 1147.53,
    y1: 1505.84,
    y2: 1505.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1e1e6",
    className: "stopColora1b3e6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c1f1f5",
    className: "stopColorc1d1f5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2fafd",
    className: "stopColord2e1fd svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 1088.94,
    x2: 1088.94,
    y1: 1498.86,
    y2: 1441.13,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 1604.34,
    x2: 1680.55,
    y1: 1321.08,
    y2: 1321.08,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 898.85,
    x2: 1028.49,
    y1: 1169.89,
    y2: 1169.89,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 1144.86,
    x2: 1232.64,
    y1: 898.12,
    y2: 898.12,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1422.72 1171.5 1388.07 1188.83 1388.07 1154.17 1422.72 1136.85 1422.72 1171.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1318.76 1171.5 1353.41 1188.83 1353.41 1154.17 1318.76 1136.85 1318.76 1171.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1271.67 1260.38 1246.34 1274.5 1271.67 1312.01 1297 1274.5 1271.67 1260.38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1365.95 629.13 1331.3 646.46 1331.3 611.8 1365.95 594.47 1365.95 629.13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1261.99 629.13 1296.64 646.46 1296.64 611.8 1261.99 594.47 1261.99 629.13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1455.26 759.71 1420.61 777.04 1420.61 742.39 1455.26 725.05 1455.26 759.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1351.3 759.71 1385.95 777.04 1385.95 742.39 1351.3 725.05 1351.3 759.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aR"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1544.57 806.35 1509.91 823.68 1509.91 789.02 1544.57 771.69 1544.57 806.35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aS"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1440.61 806.35 1475.26 823.68 1475.26 789.02 1440.61 771.69 1440.61 806.35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1633.87 938.34 1599.22 955.67 1599.22 921.02 1633.87 903.69 1633.87 938.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1529.91 938.34 1564.57 955.67 1564.57 921.02 1529.91 903.69 1529.91 938.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bP"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "691.05 1342.57 665.72 1356.69 691.05 1394.2 716.38 1356.69 691.05 1342.57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bU"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1881.71 1366.36 1856.38 1380.48 1881.71 1417.99 1907.05 1380.48 1881.71 1366.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1954.89 1179.59 1920.23 1196.92 1920.23 1162.27 1954.89 1144.94 1954.89 1179.59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1850.93 1179.59 1885.58 1196.92 1885.58 1162.27 1850.93 1144.94 1850.93 1179.59"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1901.14 896.68 1901.14 1569.9 1537.06 1569.9 1537.06 1078.73 1901.14 896.68",
    className: "colorffbe2e svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1537.06 1078.73 1537.06 1569.9 983.55 1569.9 983.55 801.99 1537.06 1078.73",
    className: "colore69729 svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1240.49 673.51 1429.85 768.2 1537.06 714.58 1901.14 896.68 1537.06 1078.73 983.55 801.99 1240.49 673.51",
    className: "colorfeeecc svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#a)",
    points: "1177.05 1109.13 1177.05 1569.9 983.55 1569.9 983.55 1205.9 1177.05 1109.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#b)",
    points: "983.55 1205.9 983.55 1569.9 790.06 1569.9 790.06 1109.13 983.55 1205.9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#c)",
    points: "983.55 1012.41 1177.05 1109.13 983.55 1205.9 790.06 1109.13 983.55 1012.41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M920.18,1384.52H903c-8.85-9.51-21.11-18.42-36.8-26.27-71.93-36-188.54-36-260.47,0-15.69,7.85-28,16.76-36.8,26.27H551.82V1569.9H920.18Z",
    className: "colore69729 svgShape"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736,
    cy: 1384.52,
    fill: "#ccfafe",
    rx: 184.18,
    ry: 92.11,
    className: "colorfeeecc svgShape"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#m)",
    points: "2048.18 1165.64 2048.18 1569.9 1854.69 1569.9 1854.69 1262.4 2048.18 1165.64"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#n)",
    points: "1854.69 1262.4 1854.69 1569.9 1661.2 1569.9 1661.2 1165.64 1854.69 1262.4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#o)",
    points: "1854.69 1068.87 2048.18 1165.64 1854.69 1262.4 1661.2 1165.64 1854.69 1068.87"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1977.54 1433.12 1977.54 1569.9 1881.71 1569.9 1881.71 1481 1977.54 1433.12",
    className: "colorffbe2e svgShape"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1881.71 1481 1881.71 1569.9 1785.88 1569.9 1785.88 1433.12 1881.71 1481",
    className: "colore69729 svgShape"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1881.71 1385.2 1977.54 1433.12 1881.71 1481 1785.88 1433.12 1881.71 1385.2",
    className: "colorfeeecc svgShape"
  }))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#p)",
    points: "1785.88 1311.14 1785.88 1569.9 1661.49 1569.9 1661.49 1373.33 1785.88 1311.14"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#q)",
    points: "1661.49 1373.33 1661.49 1569.9 1537.06 1569.9 1537.06 1311.14 1661.49 1373.33"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r)",
    points: "1661.49 1248.91 1785.88 1311.14 1661.49 1373.33 1537.06 1311.14 1661.49 1248.91"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#s)",
    points: "1464.53 1349.1 1464.53 1569.9 1368.7 1569.9 1368.7 1396.98 1464.53 1349.1"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#t)",
    points: "1368.7 1396.98 1368.7 1569.9 1272.87 1569.9 1272.87 1349.1 1368.7 1396.98"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#u)",
    points: "1368.7 1301.18 1464.53 1349.1 1368.7 1396.98 1272.87 1349.1 1368.7 1301.18"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#v)",
    points: "1368.7 1502.41 1368.7 1569.9 1272.87 1569.9 1272.87 1550.29 1368.7 1502.41"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#w)",
    points: "1272.87 1550.29 1272.87 1569.9 1177.05 1569.9 1177.05 1502.41 1272.87 1550.29"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#x)",
    points: "1272.87 1454.49 1368.7 1502.41 1272.87 1550.29 1177.05 1502.41 1272.87 1454.49"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1003.81,799.25l0-4.32-3.42-1.75-14.15-7.26a2,2,0,0,0-1.69-.16L973.7,791.1a1.37,1.37,0,0,0-.71,1.33l-.28,32.38a3.82,3.82,0,0,0,.68,2,4.53,4.53,0,0,0,1.67,1.56l15.2,7.79a1.85,1.85,0,0,0,1.68.16l4.39-2.15.28-31.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M1054,828.44c.53-3.39-1.88-7.51-5-9.58a4.36,4.36,0,0,0-.71-.47l-16.53-8.47c4.29-5.54,5.77-10.73,4.62-16.16a22.11,22.11,0,0,0-3.22-7.49,34.06,34.06,0,0,0-3.09-4c-.66-.73-1.95-1.56-2.88-1.11l-10.89,5.34a1,1,0,0,0-.45.4A67.15,67.15,0,0,1,1007,797.7l-3.16,1.55-7.2,3.53-.28,31.43v1.49a65.42,65.42,0,0,0,7.47,8.28,53.92,53.92,0,0,0,12.13,8.67l16.4,8.42a2.72,2.72,0,0,0,.81.26,5.21,5.21,0,0,0,3.95-.12l10.85-5.31a4,4,0,0,0,2.13-3.11,8.16,8.16,0,0,0-1-4.95l.13-.06a4,4,0,0,0,2.14-3.11,8.36,8.36,0,0,0-1-5l.12-.06a4,4,0,0,0,2.14-3.09,8.35,8.35,0,0,0-1-5l.12-.06A4,4,0,0,0,1054,828.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M973,792.43l-.28,32.38a3.82,3.82,0,0,0,.68,2,4.53,4.53,0,0,0,1.67,1.56l15.2,7.79c1.31.67,2.38.15,2.38-1.17l.32-34.76-3.42-1.76-14.16-7.25C974.07,790.59,973,791.11,973,792.43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M1002.38,801.65l-5.77,1.13-.29,32.92a65.42,65.42,0,0,0,7.47,8.28,53.92,53.92,0,0,0,12.13,8.67l16.4,8.42a2.72,2.72,0,0,0,.81.26c3.07,1,5.58-.31,6-3.21a8.14,8.14,0,0,0-1-4.94,4,4,0,0,0,2.27-3.17,8.39,8.39,0,0,0-1-5,4,4,0,0,0,2.27-3.14,8.47,8.47,0,0,0-1-5,4,4,0,0,0,2.26-3.14,8.67,8.67,0,0,0-1.22-5.46c-.13-.24-.28-.47-.43-.7a11.85,11.85,0,0,0-3.34-3.42,3.69,3.69,0,0,0-.71-.48l-16.52-8.47c4.28-5.53,5.76-10.72,4.61-16.15a21.83,21.83,0,0,0-3.22-7.49,32.9,32.9,0,0,0-3.08-4,3.72,3.72,0,0,0-1.89-1.19,1.29,1.29,0,0,0-1.44.48A59.54,59.54,0,0,1,1002.38,801.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M1053.22,691.67l-64.38-32.21c-3.11-1.56-5.93-1.71-8-.69l-10,5,6.73,42.74c0,6.22,5,13.79,11.26,16.9L1009,733.51l1.93,26.19,10.1-5.05,12-9.1,18.12,15.77,10-5c2-1,3.3-3.2,3.3-6.32V708.57C1064.48,702.35,1059.44,694.78,1053.22,691.67Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1043.13,696.72l-64.39-32.21c-6.22-3.11-11.26-.59-11.26,5.63v41.44c0,6.22,5,13.79,11.26,16.9l20.16,10.08,12,21.14,12-9.1,20.16,10.09c6.22,3.11,11.26.59,11.26-5.64V713.62C1054.39,707.4,1049.35,699.83,1043.13,696.72Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1254.38 1340.91 1255.89 1375.57 1370.74 1375.57 1370.74 1340.91 1254.38 1340.91",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#f)",
    opacity: 0.5
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1433.6,1327.36a48.21,48.21,0,0,0-13.85-9.88c-27.07-13.54-71-13.54-98,0a48.21,48.21,0,0,0-13.85,9.88h-6.45V1342c0,8.87,6.77,17.74,20.3,24.51,27.07,13.53,71,13.53,98,0,13.53-6.77,20.3-15.64,20.3-24.51v-14.63Z",
    className: "colore69729 svgShape"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1370.74,
    cy: 1327.36,
    fill: "#ccfafe",
    rx: 69.31,
    ry: 34.66,
    className: "colorfeeecc svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1433.6,1300a48.21,48.21,0,0,0-13.85-9.88c-27.07-13.54-71-13.54-98,0a48.21,48.21,0,0,0-13.85,9.88h-6.45v14.63c0,8.87,6.77,17.74,20.3,24.5,27.07,13.54,71,13.54,98,0,13.53-6.76,20.3-15.63,20.3-24.5V1300Z",
    className: "colore69729 svgShape"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1370.74,
    cy: 1300.02,
    fill: "#ccfafe",
    rx: 69.31,
    ry: 34.66,
    className: "colorfeeecc svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1433.6,1272.68a48.42,48.42,0,0,0-13.85-9.89c-27.07-13.53-71-13.53-98,0a48.42,48.42,0,0,0-13.85,9.89h-6.45v14.62c0,8.87,6.77,17.74,20.3,24.51,27.07,13.54,71,13.54,98,0,13.53-6.77,20.3-15.64,20.3-24.51v-14.62Z",
    className: "colore69729 svgShape"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1370.74,
    cy: 1272.68,
    fill: "#ccfafe",
    rx: 69.31,
    ry: 34.66,
    className: "colorfeeecc svgShape"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#l)",
    points: "1440.05 1196.77 1370.74 1231.43 1301.43 1196.77 1370.74 1162.11 1440.05 1196.77"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#A)",
    points: "1440.05 1266.08 1370.74 1300.74 1370.74 1231.43 1440.05 1196.77 1440.05 1266.08"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#B)",
    points: "1370.74 1300.74 1301.43 1266.08 1301.43 1196.77 1370.74 1231.43 1370.74 1300.74"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1385.86,1234.43c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1388.38,1233.17,1385.86,1234.43Zm0,13a8.56,8.56,0,0,0-4.56,6.83c0,2.52,2,3.54,4.56,2.28s4.56-4.32,4.56-6.84S1388.38,1246.2,1385.86,1247.46Zm0,26c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1388.38,1272.24,1385.86,1273.5Zm0-13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.27,4.56-4.32,4.56-6.83S1388.38,1259.22,1385.86,1260.48Zm13-19.54c-2.51,1.26-4.55,4.32-4.55,6.84s2,3.54,4.55,2.28,4.56-4.32,4.56-6.84S1401.4,1239.68,1398.88,1240.94Zm0,26c-2.51,1.26-4.55,4.32-4.55,6.84s2,3.53,4.55,2.27,4.56-4.32,4.56-6.83S1401.4,1265.73,1398.88,1267Zm0-13a8.57,8.57,0,0,0-4.55,6.83c0,2.52,2,3.54,4.55,2.28s4.56-4.32,4.56-6.84S1401.4,1252.71,1398.88,1254Zm0-26c-2.51,1.26-4.55,4.32-4.55,6.84s2,3.53,4.55,2.28,4.56-4.32,4.56-6.84S1401.4,1226.66,1398.88,1227.92Zm13-6.51c-2.52,1.26-4.56,4.32-4.56,6.83s2,3.54,4.56,2.28,4.55-4.32,4.55-6.83S1414.42,1220.15,1411.91,1221.41Zm0,13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.28,4.55-4.32,4.55-6.84S1414.42,1233.17,1411.91,1234.43Zm0,26a8.56,8.56,0,0,0-4.56,6.83c0,2.52,2,3.54,4.56,2.28s4.55-4.32,4.55-6.84S1414.42,1259.22,1411.91,1260.48Zm0-13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.55-4.32,4.55-6.84S1414.42,1246.19,1411.91,1247.45Zm13-19.53c-2.52,1.26-4.56,4.32-4.56,6.83s2,3.54,4.56,2.28,4.56-4.32,4.56-6.83S1427.45,1226.66,1424.93,1227.92Zm0-3.91c2.52-1.26,4.56-4.32,4.56-6.84s-2-3.53-4.56-2.28-4.56,4.32-4.56,6.84S1422.41,1225.27,1424.93,1224Zm0,16.93c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.28,4.56-4.32,4.56-6.84S1427.45,1239.68,1424.93,1240.94Zm0,13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1427.45,1252.7,1424.93,1254Z",
    className: "colorffffff svgShape"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1440.05 1110.85 1370.74 1145.51 1301.43 1110.85 1370.74 1076.19 1440.05 1110.85",
    className: "colorfeeecc svgShape"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1440.05 1180.16 1370.74 1214.82 1370.74 1145.51 1440.05 1110.85 1440.05 1180.16",
    className: "colorffbe2e svgShape"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1422.72 1171.5 1388.07 1188.83 1388.07 1154.17 1422.72 1136.85 1422.72 1171.5",
    className: "colorf5e48c svgShape"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1370.74 1214.82 1301.43 1180.16 1301.43 1110.85 1370.74 1145.51 1370.74 1214.82",
    className: "colore69729 svgShape"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#g)",
    points: "1422.72 1171.5 1422.72 1136.84 1388.08 1154.17 1422.72 1171.5"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1318.76 1171.5 1353.41 1188.83 1353.41 1154.17 1318.76 1136.85 1318.76 1171.5",
    className: "colorf5e48c svgShape"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1318.76 1171.5 1318.76 1136.84 1353.41 1154.17 1318.76 1171.5",
    className: "colorf5c25b svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1414.06 1149.88 1396.77 1158.52 1379.47 1149.88 1396.77 1141.23 1414.06 1149.88",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1414.06 1167.17 1396.77 1175.82 1396.77 1158.52 1414.06 1149.88 1414.06 1167.17",
    className: "colorffbe2e svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1396.77 1175.82 1379.47 1167.17 1379.47 1149.88 1396.77 1158.52 1396.77 1175.82",
    className: "colore69729 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1327.42 1149.88 1344.71 1158.52 1362.01 1149.88 1344.71 1141.23 1327.42 1149.88",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1327.42 1167.17 1344.71 1175.82 1344.71 1158.52 1327.42 1149.88 1327.42 1167.17",
    className: "colore69729 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1344.71 1175.82 1362.01 1167.17 1362.01 1149.88 1344.71 1158.52 1344.71 1175.82",
    className: "colorffbe2e svgShape"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "1155.31 1501.03 1156.82 1535.69 1271.67 1535.69 1271.67 1501.03 1155.31 1501.03",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#E)",
    opacity: 0.5
  }), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1340.98 1431.72 1271.67 1466.38 1202.36 1431.72 1271.67 1397.06 1340.98 1431.72",
    className: "colorfeeecc svgShape"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1340.98 1501.03 1271.67 1535.69 1271.67 1466.38 1340.98 1431.72 1340.98 1501.03",
    className: "colorffbe2e svgShape"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1323.65 1492.36 1289 1509.69 1289 1475.04 1323.65 1457.71 1323.65 1492.36",
    className: "colorf5e48c svgShape"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1271.67 1535.69 1202.36 1501.03 1202.36 1431.72 1271.67 1466.38 1271.67 1535.69",
    className: "colore69729 svgShape"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#F)",
    points: "1323.65 1492.36 1323.65 1457.71 1289 1475.04 1323.65 1492.36"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1219.69 1492.36 1254.34 1509.69 1254.34 1475.04 1219.69 1457.71 1219.69 1492.36",
    className: "colorf5e48c svgShape"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1219.69 1492.36 1219.69 1457.71 1254.33 1475.04 1219.69 1492.36",
    className: "colorf5c25b svgShape"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1340.98 1344.38 1271.67 1379.05 1202.36 1344.38 1271.67 1309.72 1340.98 1344.38",
    className: "colorfeeecc svgShape"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1340.98 1413.69 1271.67 1448.35 1271.67 1379.05 1340.98 1344.38 1340.98 1413.69",
    className: "colorffbe2e svgShape"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1271.67 1448.35 1202.36 1413.69 1202.36 1344.38 1271.67 1379.05 1271.67 1448.35",
    className: "colore69729 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cedf5",
    d: "M1271.67,1379.05l-69.31-34.67v3.56l69.31,34.66,69.31-34.66v-3.56Zm-69.31-23.71v3.56l69.31,34.66L1341,1358.9v-3.56L1271.67,1390Zm0,11v3.56l69.31,34.66,69.31-34.66v-3.56L1271.67,1401Zm0,11v3.56l69.31,34.66,69.31-34.66v-3.56l-69.31,34.66Zm0,11v3.55l69.31,34.67,69.31-34.67v-3.55l-69.31,34.66Zm0,11v3.55l69.31,34.66,69.31-34.66v-3.55l-69.31,34.66Zm0,11v3.55l69.31,34.66,69.31-34.66v-3.55l-69.31,34.66Z",
    className: "colorf5e48c svgShape"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1340.98 1257.05 1271.67 1291.71 1202.36 1257.05 1271.67 1222.39 1340.98 1257.05",
    className: "colorf5e48c svgShape"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1340.98 1326.36 1271.67 1361.02 1271.67 1291.71 1340.98 1257.05 1340.98 1326.36",
    className: "colorffbe2e svgShape"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1271.67 1361.02 1202.36 1326.36 1202.36 1257.05 1271.67 1291.71 1271.67 1361.02",
    className: "colore69729 svgShape"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#G)",
    points: "1271.67 1250 1232.04 1272.09 1271.67 1330.77 1311.3 1272.09 1271.67 1250"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1297 1274.5 1271.67 1287.17 1246.34 1274.5 1271.67 1261.83 1297 1274.5",
    className: "colorf5e48c svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#j)",
    points: "1297 1299.84 1271.67 1312.51 1271.67 1287.17 1297 1274.5 1297 1299.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#I)",
    points: "1271.67 1312.51 1246.34 1299.84 1246.34 1274.5 1271.67 1287.17 1271.67 1312.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "1108.3 768.36 1109.81 803.01 1224.66 803.01 1224.66 768.36 1108.3 768.36",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#J)",
    opacity: 0.5
  }), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1293.97 699.04 1224.66 733.71 1155.35 699.04 1224.66 664.38 1293.97 699.04",
    className: "colorfeeecc svgShape"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1293.97 768.35 1224.66 803.01 1224.66 733.71 1293.97 699.04 1293.97 768.35",
    className: "colorffbe2e svgShape"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1224.66 803.01 1155.35 768.35 1155.35 699.04 1224.66 733.71 1224.66 803.01",
    className: "colore69729 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1235.51 743.74a.52.52 0 01-.45-.28.5.5 0 01.23-.67l6.9-3.45a.5.5 0 11.44.89l-6.9 3.45A.46.46 0 011235.51 743.74zM1235.51 747.68a.52.52 0 01-.45-.28.5.5 0 01.22-.67l6.91-3.45a.5.5 0 01.67.22.5.5 0 01-.22.67l-6.91 3.45A.46.46 0 011235.51 747.68zM1235.51 751.62a.52.52 0 01-.45-.28.5.5 0 01.22-.67l6.91-3.45a.49.49 0 01.67.22.5.5 0 01-.22.67l-6.91 3.45A.46.46 0 011235.51 751.62zM1235.51 755.55a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.45a.5.5 0 11.44.89l-6.9 3.45A.44.44 0 011235.51 755.55zM1235.51 759.49a.51.51 0 01-.45-.27.5.5 0 01.22-.67l6.91-3.45a.5.5 0 01.67.22.5.5 0 01-.22.67l-6.91 3.45A.44.44 0 011235.51 759.49zM1235.51 763.43a.51.51 0 01-.45-.27.5.5 0 01.22-.67l6.91-3.45a.49.49 0 01.67.22.5.5 0 01-.22.67l-6.91 3.45A.44.44 0 011235.51 763.43zM1235.51 767.37a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.45a.5.5 0 11.44.89l-6.9 3.45A.44.44 0 011235.51 767.37zM1235.51 771.31a.51.51 0 01-.45-.27.5.5 0 01.22-.67l6.91-3.46a.5.5 0 01.45.9l-6.91 3.45A.44.44 0 011235.51 771.31zM1235.51 775.25a.51.51 0 01-.45-.27.5.5 0 01.22-.67l6.91-3.46a.5.5 0 01.45.9l-6.91 3.45A.44.44 0 011235.51 775.25zM1235.51 779.19a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.46a.5.5 0 01.44.9l-6.9 3.45A.44.44 0 011235.51 779.19zM1235.51 783.13a.51.51 0 01-.45-.27.5.5 0 01.22-.67l6.91-3.46a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.91 3.45A.44.44 0 011235.51 783.13zM1248.64 737.17a.5.5 0 01-.22-.95l9.53-4.77a.5.5 0 01.45.9l-9.53 4.77A.64.64 0 011248.64 737.17zM1248.64 741.11a.5.5 0 01-.22-1l9.53-4.76a.49.49 0 01.67.22.5.5 0 01-.23.67l-9.53 4.76A.43.43 0 011248.64 741.11zM1248.64 745.05a.5.5 0 01-.22-.95l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.49.49 0 011248.64 745.05zM1248.64 749a.5.5 0 01-.22-1l3-1.48a.51.51 0 01.67.22.5.5 0 01-.22.67l-3 1.48A.43.43 0 011248.64 749zM1248.64 752.93a.5.5 0 01-.22-.95l6.9-3.45a.5.5 0 11.45.89l-6.91 3.45A.43.43 0 011248.64 752.93zM1248.64 756.87a.5.5 0 01-.22-1l3-1.48a.5.5 0 11.45.89l-3 1.48A.43.43 0 011248.64 756.87zM1248.64 760.81a.52.52 0 01-.45-.28.5.5 0 01.23-.67l3-1.48a.51.51 0 01.67.22.5.5 0 01-.22.67l-3 1.48A.43.43 0 011248.64 760.81zM1248.64 764.75a.52.52 0 01-.45-.28.5.5 0 01.23-.67l12.16-6.08a.5.5 0 11.44.9l-12.16 6.07A.43.43 0 011248.64 764.75zM1248.64 768.69a.52.52 0 01-.45-.28.5.5 0 01.23-.67l12.15-6.08a.52.52 0 01.68.22.5.5 0 01-.23.67l-12.15 6.08A.49.49 0 011248.64 768.69zM1248.64 772.63a.52.52 0 01-.45-.28.5.5 0 01.23-.67l8.21-4.11a.5.5 0 01.67.22.49.49 0 01-.22.67l-8.21 4.11A.49.49 0 011248.64 772.63zM1248.64 776.57a.52.52 0 01-.45-.28.5.5 0 01.23-.67l16.09-8a.5.5 0 01.67.22.49.49 0 01-.22.67l-16.1 8A.43.43 0 011248.64 776.57zM1260.46 731.26a.5.5 0 01-.22-1l4.27-2.14a.5.5 0 01.67.23.49.49 0 01-.22.67l-4.28 2.13A.43.43 0 011260.46 731.26zM1260.46 735.2a.5.5 0 01-.22-1l4.27-2.14a.5.5 0 01.45.9l-4.27 2.13A.49.49 0 011260.46 735.2zM1257.83 740.45a.5.5 0 01-.22-1l10.84-5.42a.5.5 0 01.45.9l-10.84 5.42A.59.59 0 011257.83 740.45zM1253.9 746.36a.49.49 0 01-.45-.28.5.5 0 01.22-.67l9.53-4.76a.5.5 0 01.67.22.5.5 0 01-.22.67l-9.53 4.77A.59.59 0 011253.9 746.36zM1257.83 748.33a.5.5 0 01-.22-1l10.84-5.42a.5.5 0 01.67.22.49.49 0 01-.22.67l-10.84 5.43A.59.59 0 011257.83 748.33zM1253.9 754.24a.49.49 0 01-.45-.28.5.5 0 01.22-.67l10.84-5.42a.5.5 0 01.67.22.49.49 0 01-.22.67l-10.84 5.43A.59.59 0 011253.9 754.24zM1253.9 758.18a.49.49 0 01-.45-.28.5.5 0 01.22-.67l10.84-5.42a.5.5 0 01.67.22.49.49 0 01-.22.67l-10.84 5.43A.59.59 0 011253.9 758.18zM1263.09 757.52a.5.5 0 01-.45-.28.51.51 0 01.22-.67l6.9-3.45a.51.51 0 01.68.23.51.51 0 01-.23.67l-6.9 3.45A.54.54 0 011263.09 757.52zM1263.09 761.46a.51.51 0 01-.45-.27.52.52 0 01.22-.68l6.9-3.45a.51.51 0 01.68.23.51.51 0 01-.23.67l-6.9 3.45A.42.42 0 011263.09 761.46zM1259.15 767.37a.5.5 0 01-.45-.27.52.52 0 01.22-.68l10.84-5.42a.51.51 0 01.68.23.51.51 0 01-.23.67l-10.84 5.42A.44.44 0 011259.15 767.37zM1267 767.37a.49.49 0 01-.45-.28.51.51 0 01.22-.67l3-1.48a.51.51 0 01.68.23.51.51 0 01-.23.67l-3 1.48A.59.59 0 011267 767.37zM1267 728a.5.5 0 01-.23-.94l4.28-2.14a.5.5 0 11.45.89l-4.28 2.14A.44.44 0 011267 728zM1267 731.91a.5.5 0 01-.23-.94l4.28-2.14a.5.5 0 01.67.22.5.5 0 01-.22.67l-4.28 2.14A.44.44 0 011267 731.91zM1271 733.88a.5.5 0 01-.23-.94l6.91-3.46a.5.5 0 01.44.9l-6.9 3.45A.44.44 0 011271 733.88zM1265.71 740.45a.48.48 0 01-.44-.28.49.49 0 01.22-.67l12.16-6.08a.5.5 0 01.44.9l-12.15 6.08A.59.59 0 011265.71 740.45zM1271 741.76a.5.5 0 01-.45-.27.51.51 0 01.23-.68l6.9-3.45a.5.5 0 01.44.9l-6.9 3.45A.59.59 0 011271 741.76zM1267 747.67a.5.5 0 01-.45-.27.51.51 0 01.23-.68l6.9-3.45a.5.5 0 01.44.9l-6.9 3.45A.44.44 0 011267 747.67zM1267 751.61a.5.5 0 01-.45-.27.52.52 0 01.22-.68l6.91-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.91 3.45A.44.44 0 011267 751.61zM1272.28 752.92a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.45a.5.5 0 01.67.22.5.5 0 01-.22.67l-6.91 3.45A.42.42 0 011272.28 752.92zM1272.28 756.86a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.46a.5.5 0 01.45.9l-6.91 3.45A.42.42 0 011272.28 756.86zM1272.28 760.8a.51.51 0 01-.45-.27.5.5 0 01.23-.67l4.27-2.14a.5.5 0 01.67.22.49.49 0 01-.22.67l-4.28 2.14A.42.42 0 011272.28 760.8zM1272.28 764.74a.51.51 0 01-.45-.27.5.5 0 01.23-.67l4.27-2.14a.5.5 0 01.67.22.49.49 0 01-.22.67l-4.28 2.14A.42.42 0 011272.28 764.74zM1273.59 724.69a.5.5 0 01-.22-1l9.53-4.76a.49.49 0 01.67.22.5.5 0 01-.22.67l-9.53 4.77A.59.59 0 011273.59 724.69zM1273.59 728.63a.5.5 0 01-.22-1l9.53-4.76a.49.49 0 01.67.22.5.5 0 01-.22.67l-9.53 4.77A.59.59 0 011273.59 728.63zM1280.16 729.29a.52.52 0 01-.45-.28.5.5 0 01.23-.67l3-1.48a.49.49 0 01.67.22.5.5 0 01-.22.67l-3 1.48A.49.49 0 011280.16 729.29zM1280.16 733.22a.51.51 0 01-.45-.27.5.5 0 01.23-.67l3-1.48a.49.49 0 01.67.22.5.5 0 01-.22.67l-3 1.48A.48.48 0 011280.16 733.22zM1280.16 737.16a.51.51 0 01-.45-.27.5.5 0 01.23-.67l3-1.48a.49.49 0 01.67.22.5.5 0 01-.22.67l-3 1.48A.48.48 0 011280.16 737.16zM1276.22 743.07a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.45a.49.49 0 01.67.22.5.5 0 01-.23.67l-6.9 3.45A.42.42 0 011276.22 743.07zM1276.22 747a.51.51 0 01-.45-.27.5.5 0 01.23-.67l6.9-3.45a.49.49 0 01.67.22.5.5 0 01-.22.67l-6.91 3.45A.42.42 0 011276.22 747zM1281.47 748.33a.48.48 0 01-.44-.28.49.49 0 01.22-.67l1.65-.82a.49.49 0 01.67.22.5.5 0 01-.23.67l-1.64.82A.46.46 0 011281.47 748.33zM1281.47 752.27a.5.5 0 01-.44-.28.49.49 0 01.22-.67l1.65-.83a.5.5 0 01.44.9l-1.64.82A.46.46 0 011281.47 752.27zM1278.85 757.52a.49.49 0 01-.45-.28.51.51 0 01.22-.67l4.28-2.14a.5.5 0 01.67.23.51.51 0 01-.22.67l-4.28 2.14A.59.59 0 011278.85 757.52zM1278.85 761.46a.49.49 0 01-.45-.28.51.51 0 01.22-.67l4.28-2.14a.5.5 0 01.67.23.51.51 0 01-.22.67l-4.28 2.14A.59.59 0 011278.85 761.46z",
    className: "colorffffff svgShape"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#K)",
    points: "1214.93 647.85 1185.09 662.78 1155.24 647.85 1185.09 632.93 1214.93 647.85"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#L)",
    points: "1214.93 677.7 1185.09 692.62 1185.09 662.78 1214.93 647.85 1214.93 677.7"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#M)",
    points: "1185.09 692.62 1155.24 677.7 1155.24 647.85 1185.09 662.78 1185.09 692.62"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#N)",
    points: "1296.66 647.85 1266.82 662.78 1236.97 647.85 1266.82 632.93 1296.66 647.85"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#O)",
    points: "1296.66 677.7 1266.82 692.62 1266.82 662.78 1296.66 647.85 1296.66 677.7"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#P)",
    points: "1266.82 692.62 1236.97 677.7 1236.97 647.85 1266.82 662.78 1266.82 692.62"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Q)",
    points: "1254.51 668.93 1224.66 683.86 1194.82 668.93 1224.66 654.01 1254.51 668.93"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#R)",
    points: "1254.51 698.78 1224.66 713.71 1224.66 683.86 1254.51 668.93 1254.51 698.78"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#S)",
    points: "1224.66 713.71 1194.82 698.78 1194.82 668.93 1224.66 683.86 1224.66 713.71"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#T)",
    points: "1254.51 584.97 1224.66 599.89 1194.82 584.97 1224.66 570.04 1254.51 584.97"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#U)",
    points: "1254.51 614.81 1224.66 629.74 1224.66 599.89 1254.51 584.97 1254.51 614.81"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#V)",
    points: "1224.66 629.74 1194.82 614.81 1194.82 584.97 1224.66 599.89 1224.66 629.74"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#W)",
    points: "1296.66 605.87 1266.82 620.8 1236.97 605.87 1266.82 590.95 1296.66 605.87"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#X)",
    points: "1296.66 635.72 1266.82 650.64 1266.82 620.8 1296.66 605.87 1296.66 635.72"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Y)",
    points: "1266.82 650.64 1236.97 635.72 1236.97 605.87 1266.82 620.8 1266.82 650.64"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Z)",
    points: "1214.93 605.87 1185.09 620.8 1155.24 605.87 1185.09 590.95 1214.93 605.87"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aa)",
    points: "1214.93 635.72 1185.09 650.64 1185.09 620.8 1214.93 605.87 1214.93 635.72"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ab)",
    points: "1185.09 650.64 1155.24 635.72 1155.24 605.87 1185.09 620.8 1185.09 650.64"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ac)",
    points: "1254.51 626.95 1224.66 641.88 1194.82 626.95 1224.66 612.03 1254.51 626.95"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ad)",
    points: "1254.51 656.8 1224.66 671.73 1224.66 641.88 1254.51 626.95 1254.51 656.8"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ae)",
    points: "1224.66 671.73 1194.82 656.8 1194.82 626.95 1224.66 641.88 1224.66 671.73"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1197.61 798.54 1199.12 833.2 1313.97 833.2 1313.97 798.54 1197.61 798.54",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#af)",
    opacity: 0.5
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1376.83,785a48.21,48.21,0,0,0-13.85-9.88c-27.07-13.54-71-13.54-98,0a48.21,48.21,0,0,0-13.85,9.88h-6.45v14.63c0,8.87,6.77,17.74,20.3,24.5,27.07,13.54,71,13.54,98,0,13.53-6.76,20.3-15.63,20.3-24.5V785Z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1313.97,
    cy: 784.99,
    fill: "#8cedf5",
    rx: 69.31,
    ry: 34.66,
    className: "colorf5e48c svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M1376.83,757.65a48.42,48.42,0,0,0-13.85-9.89c-27.07-13.53-71-13.53-98,0a48.42,48.42,0,0,0-13.85,9.89h-6.45v14.62c0,8.87,6.77,17.75,20.3,24.51,27.07,13.54,71,13.54,98,0,13.53-6.76,20.3-15.64,20.3-24.51V757.65Z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1313.97,
    cy: 757.65,
    fill: "#8cedf5",
    rx: 69.31,
    ry: 34.66,
    className: "colorf5e48c svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M1376.83,730.31a48.42,48.42,0,0,0-13.85-9.89c-27.07-13.53-71-13.53-98,0a48.42,48.42,0,0,0-13.85,9.89h-6.45v14.62c0,8.87,6.77,17.74,20.3,24.51,27.07,13.54,71,13.54,98,0,13.53-6.77,20.3-15.64,20.3-24.51V730.31Z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1313.97,
    cy: 730.31,
    fill: "#8cedf5",
    rx: 69.31,
    ry: 34.66,
    className: "colorf5e48c svgShape"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ai)",
    points: "1383.28 654.4 1313.97 689.06 1244.66 654.4 1313.97 619.74 1383.28 654.4"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aj)",
    points: "1383.28 723.71 1313.97 758.37 1313.97 689.06 1383.28 654.4 1383.28 723.71"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ak)",
    points: "1313.97 758.37 1244.66 723.71 1244.66 654.4 1313.97 689.06 1313.97 758.37"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1329.09,692.06c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1331.61,690.8,1329.09,692.06Zm0,13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1331.61,703.83,1329.09,705.08Zm0,26c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.28,4.56-4.32,4.56-6.84S1331.61,729.87,1329.09,731.13Zm0-13c-2.52,1.26-4.56,4.32-4.56,6.83s2,3.54,4.56,2.28,4.56-4.32,4.56-6.83S1331.61,716.85,1329.09,718.11Zm13-19.54c-2.51,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1344.63,697.31,1342.11,698.57Zm0,26c-2.51,1.26-4.56,4.32-4.56,6.83s2,3.54,4.56,2.28,4.56-4.32,4.56-6.83S1344.63,723.36,1342.11,724.62Zm0-13c-2.51,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1344.63,710.34,1342.11,711.59Zm0-26c-2.51,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.27a8.56,8.56,0,0,0,4.56-6.83C1346.67,685.31,1344.63,684.29,1342.11,685.55Zm13-6.51c-2.52,1.26-4.56,4.32-4.56,6.83s2,3.54,4.56,2.28,4.55-4.32,4.55-6.84S1357.65,677.78,1355.14,679Zm0,13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.27a8.57,8.57,0,0,0,4.55-6.83C1359.69,691.82,1357.65,690.8,1355.14,692.06Zm0,26c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.55-4.32,4.55-6.84S1357.65,716.85,1355.14,718.1Zm0-13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.55-4.32,4.55-6.84S1357.65,703.82,1355.14,705.08Zm13-19.53c-2.52,1.26-4.56,4.32-4.56,6.83s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1370.68,684.29,1368.16,685.55Zm0-3.91c2.52-1.26,4.56-4.32,4.56-6.84s-2-3.54-4.56-2.28-4.56,4.32-4.56,6.84S1365.64,682.9,1368.16,681.64Zm0,16.93c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.53,4.56,2.27a8.56,8.56,0,0,0,4.56-6.83C1372.72,698.33,1370.68,697.31,1368.16,698.57Zm0,13c-2.52,1.26-4.56,4.32-4.56,6.84s2,3.54,4.56,2.28,4.56-4.32,4.56-6.84S1370.68,710.33,1368.16,711.59Z",
    className: "colorffffff svgShape"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1383.28 568.48 1313.97 603.14 1244.66 568.48 1313.97 533.82 1383.28 568.48",
    className: "colorfeeecc svgShape"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1383.28 637.79 1313.97 672.45 1313.97 603.14 1383.28 568.48 1383.28 637.79",
    className: "colorffbe2e svgShape"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1365.95 629.13 1331.3 646.46 1331.3 611.8 1365.95 594.47 1365.95 629.13",
    className: "colorf5e48c svgShape"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1313.97 672.45 1244.66 637.79 1244.66 568.48 1313.97 603.14 1313.97 672.45",
    className: "colore69729 svgShape"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#al)",
    points: "1365.95 629.13 1365.95 594.47 1331.3 611.8 1365.95 629.13"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1261.99 629.13 1296.64 646.46 1296.64 611.8 1261.99 594.47 1261.99 629.13",
    className: "colorf5e48c svgShape"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1261.99 629.13 1261.99 594.47 1296.64 611.8 1261.99 629.13",
    className: "colorf5c25b svgShape"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1357.29 607.5 1339.99 616.15 1322.7 607.5 1339.99 598.86 1357.29 607.5",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1357.29 624.8 1339.99 633.44 1339.99 616.15 1357.29 607.5 1357.29 624.8",
    className: "colorffbe2e svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1339.99 633.44 1322.7 624.8 1322.7 607.5 1339.99 616.15 1339.99 633.44",
    className: "colore69729 svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1270.65 607.5 1287.94 616.15 1305.24 607.5 1287.94 598.86 1270.65 607.5",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1270.65 624.8 1287.94 633.44 1287.94 616.15 1270.65 607.5 1270.65 624.8",
    className: "colore69729 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1287.94 633.44 1305.24 624.8 1305.24 607.5 1287.94 616.15 1287.94 633.44",
    className: "colorffbe2e svgShape"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "1286.91 857.68 1288.42 892.34 1403.28 892.34 1403.28 857.68 1286.91 857.68",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#ao)",
    opacity: 0.5
  }), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1472.59 788.37 1463.49 792.92 1394.18 758.26 1403.28 753.71 1472.59 788.37",
    className: "colorfeeecc svgShape"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1472.59 857.68 1463.49 862.23 1463.49 792.92 1472.59 788.37 1472.59 857.68",
    className: "colorffbe2e svgShape"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1463.49 862.23 1394.18 827.57 1394.18 758.26 1463.49 792.92 1463.49 862.23",
    className: "colore69729 svgShape"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1457.53 795.9 1448.44 800.45 1379.13 765.78 1388.22 761.24 1457.53 795.9",
    className: "colorfeeecc svgShape"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1457.53 865.2 1448.44 869.75 1448.44 800.45 1457.53 795.9 1457.53 865.2",
    className: "colorffbe2e svgShape"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1448.44 869.75 1379.13 835.09 1379.13 765.78 1448.44 800.45 1448.44 869.75",
    className: "colore69729 svgShape"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1442.48 803.42 1433.38 807.97 1364.08 773.31 1373.17 768.76 1442.48 803.42",
    className: "colorfeeecc svgShape"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1442.48 872.73 1433.38 877.28 1433.38 807.97 1442.48 803.42 1442.48 872.73",
    className: "colorffbe2e svgShape"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1433.38 877.28 1364.08 842.62 1364.08 773.31 1433.38 807.97 1433.38 877.28",
    className: "colore69729 svgShape"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1427.43 810.96 1418.33 815.5 1349.02 780.84 1358.12 776.29 1427.43 810.96",
    className: "colorfeeecc svgShape"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1427.43 880.26 1418.33 884.81 1418.33 815.5 1427.43 810.96 1427.43 880.26",
    className: "colorffbe2e svgShape"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1418.33 884.81 1349.02 850.15 1349.02 780.84 1418.33 815.5 1418.33 884.81",
    className: "colore69729 svgShape"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1412.38 818.48 1403.28 823.03 1333.97 788.37 1343.07 783.82 1412.38 818.48",
    className: "colorfeeecc svgShape"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1412.38 887.79 1403.28 892.34 1403.28 823.03 1412.38 818.48 1412.38 887.79",
    className: "colorffbe2e svgShape"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1403.28 892.34 1333.97 857.68 1333.97 788.37 1403.28 823.03 1403.28 892.34",
    className: "colore69729 svgShape"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1472.59 699.06 1403.28 733.73 1333.97 699.06 1403.28 664.4 1472.59 699.06",
    className: "colorf5e48c svgShape"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1472.59 768.37 1403.28 803.03 1403.28 733.73 1472.59 699.06 1472.59 768.37",
    className: "colorf5c25b svgShape"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1455.26 759.71 1420.61 777.04 1420.61 742.39 1455.26 725.05 1455.26 759.71",
    className: "colorf5e48c svgShape"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ap)",
    points: "1403.28 803.03 1333.97 768.37 1333.97 699.06 1403.28 733.73 1403.28 803.03"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aq)",
    points: "1455.26 759.71 1455.26 725.05 1420.61 742.38 1455.26 759.71"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1351.3 759.71 1385.95 777.04 1385.95 742.39 1351.3 725.05 1351.3 759.71",
    className: "colorf5e48c svgShape"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1351.3 759.71 1351.3 725.05 1385.94 742.38 1351.3 759.71",
    className: "colorf5c25b svgShape"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1446.6 738.09 1429.3 746.73 1412.01 738.09 1429.3 729.44 1446.6 738.09",
    className: "colorf5e48c svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1446.6 755.38 1429.3 764.03 1429.3 746.73 1446.6 738.09 1446.6 755.38",
    className: "colorf5c25b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#as)",
    points: "1429.3 764.03 1412.01 755.38 1412.01 738.09 1429.3 746.73 1429.3 764.03"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1359.96 738.09 1377.25 746.73 1394.55 738.09 1377.25 729.44 1359.96 738.09",
    className: "colorf5e48c svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#au)",
    points: "1359.96 755.38 1377.25 764.03 1377.25 746.73 1359.96 738.09 1359.96 755.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1377.25 764.03 1394.55 755.38 1394.55 738.09 1377.25 746.73 1377.25 764.03",
    className: "colorf5c25b svgShape"
  }))), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1472.51 610.59 1403.2 645.25 1333.89 610.59 1403.2 575.93 1472.51 610.59",
    className: "colorfeeecc svgShape"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1472.51 679.9 1403.2 714.56 1403.2 645.25 1472.51 610.59 1472.51 679.9",
    className: "colorffbe2e svgShape"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1403.2 714.56 1333.89 679.9 1333.89 610.59 1403.2 645.25 1403.2 714.56",
    className: "colore69729 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1344.67,630.14a.5.5,0,0,0-.44.9l7,3.49a.42.42,0,0,0,.22.05.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.66.22.49.49,0,0,0,.22.67l7,3.5a.54.54,0,0,0,.22.05.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.44.89l7,3.5a.54.54,0,0,0,.22,0,.5.5,0,0,0,.22-.95Zm0,4a.49.49,0,0,0-.66.23.49.49,0,0,0,.22.67l7,3.49a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.44.9l7,3.49a.42.42,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.66.22.49.49,0,0,0,.22.67l7,3.5a.54.54,0,0,0,.22,0,.5.5,0,0,0,.22-.95Zm0,4a.48.48,0,0,0-.66.22.49.49,0,0,0,.22.67l7,3.49a.43.43,0,0,0,.22.06.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.44.9l7,3.49a.42.42,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.44.9l7,3.49a.42.42,0,0,0,.22.05.5.5,0,0,0,.22-1Zm0,4a.48.48,0,0,0-.66.22.49.49,0,0,0,.22.67l7,3.5a.54.54,0,0,0,.22.05.5.5,0,0,0,.22-1Zm0,4a.48.48,0,0,0-.66.22.49.49,0,0,0,.22.67l7,3.49a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm22.49-27.51a.64.64,0,0,0,.23,0,.5.5,0,0,0,.22-.95l-9.64-4.82a.5.5,0,0,0-.67.22.49.49,0,0,0,.22.67Zm0,4a.49.49,0,0,0,.23.06.5.5,0,0,0,.22-.95l-9.64-4.82a.5.5,0,0,0-.45.89Zm-2.65,2.66a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67l-7-3.5a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67Zm-4,2a.59.59,0,0,0,.22.05.5.5,0,0,0,.22-1l-3-1.5a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67Zm-3,2.48,7,3.5a.54.54,0,0,0,.22,0,.5.5,0,0,0,.22-.95l-7-3.49a.51.51,0,0,0-.67.22A.49.49,0,0,0,1357.52,653.63Zm0,4,3,1.5a.44.44,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67l-3-1.5a.5.5,0,0,0-.45.89Zm0,4,3,1.5a.59.59,0,0,0,.22,0,.5.5,0,0,0,.22-.95l-3-1.5a.5.5,0,0,0-.67.23A.49.49,0,0,0,1357.52,661.61Zm12.75,9.24L1358,664.7a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l12.3,6.15a.59.59,0,0,0,.23,0,.48.48,0,0,0,.44-.28A.49.49,0,0,0,1370.27,670.85Zm-12.3-2.16a.5.5,0,0,0-.67.22.49.49,0,0,0,.22.67l12.3,6.15a.46.46,0,0,0,.23.06.48.48,0,0,0,.44-.28.49.49,0,0,0-.22-.67Zm7.86,9a.48.48,0,0,0,.23,0,.5.5,0,0,0,.22-.95l-8.31-4.15a.5.5,0,1,0-.45.89Zm-7.86-1.07a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l16.29,8.14a.46.46,0,0,0,.22.06.51.51,0,0,0,.45-.28.5.5,0,0,0-.22-.67Zm15.84-30.83a.44.44,0,0,0,.22,0,.5.5,0,0,0,.23-.94l-4.33-2.17a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67Zm0,4a.59.59,0,0,0,.22,0,.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-4.33-2.16a.5.5,0,0,0-.67.22.5.5,0,0,0,.22.67Zm4.21,6a.5.5,0,0,0,.22-1l-11-5.48a.5.5,0,1,0-.44.89l11,5.49A.42.42,0,0,0,1378,655.85Zm-15.41-4.22a.51.51,0,0,0,.23.68l9.64,4.82a.59.59,0,0,0,.22,0,.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-9.65-4.82A.51.51,0,0,0,1362.61,651.63Zm15.41,12.2a.5.5,0,0,0,.22-1l-11-5.49a.5.5,0,0,0-.44.9l11,5.48A.43.43,0,0,0,1378,663.83Zm-3.76,1-11-5.48a.49.49,0,0,0-.67.22.5.5,0,0,0,.23.67l11,5.49a.59.59,0,0,0,.22.05.49.49,0,0,0,.45-.28A.51.51,0,0,0,1374.26,664.87Zm-.23,4.94a.49.49,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-11-5.49a.5.5,0,0,0-.44.9l11,5.48A.46.46,0,0,0,1374,669.81Zm-1.44,2.2a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l7,3.49a.48.48,0,0,0,.23.05.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.67.22.49.49,0,0,0,.22.67l7,3.5a.64.64,0,0,0,.23.05.5.5,0,0,0,.22-1Zm-4,2a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67l11,5.49a.64.64,0,0,0,.23,0,.5.5,0,0,0,.22-.95Zm8,8a.51.51,0,0,0-.67.22.5.5,0,0,0,.23.67l3,1.5a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm3.89-36.82a.43.43,0,0,0,.22.06.5.5,0,0,0,.22-1l-4.33-2.16a.5.5,0,1,0-.44.89Zm0,4a.42.42,0,0,0,.22.05.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67l-4.33-2.17a.5.5,0,0,0-.44.9Zm7.09,6.42-7-3.5a.5.5,0,0,0-.45.9l7,3.49a.46.46,0,0,0,.22.06.51.51,0,0,0,.45-.28A.5.5,0,0,0,1387.55,659.56Zm0,4-12.3-6.16a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l12.3,6.15a.44.44,0,0,0,.22,0,.5.5,0,0,0,.23-.94Zm-.23,4.93a.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-7-3.49a.5.5,0,1,0-.45.89l7,3.5A.59.59,0,0,0,1387.32,668.48ZM1376.57,666a.5.5,0,0,0-.44.9l7,3.49a.46.46,0,0,0,.23.05.5.5,0,0,0,.22-.94Zm6.77,8.43a.48.48,0,0,0,.44-.28.49.49,0,0,0-.22-.67l-7-3.49a.51.51,0,0,0-.67.22.5.5,0,0,0,.23.67l7,3.5A.59.59,0,0,0,1383.34,674.46Zm5.09,6.59a.46.46,0,0,0,.22.06.49.49,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-7-3.49a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67Zm0,4a.44.44,0,0,0,.22.05.5.5,0,0,0,.23-.94l-7-3.5a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67Zm-6.54-.4a.5.5,0,0,0-.45.89l4.33,2.17a.59.59,0,0,0,.23,0,.5.5,0,0,0,.22-1Zm0,4a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67l4.33,2.17a.59.59,0,0,0,.23,0,.5.5,0,0,0,.22-1Zm10.53-33.49a.54.54,0,0,0,.22.05.5.5,0,0,0,.22-1l-9.64-4.82a.5.5,0,0,0-.45.89Zm-9.2-1.73a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67l9.65,4.82a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm9.2,9.7a.42.42,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67l-3-1.5a.5.5,0,1,0-.44.89Zm-3,2.49,3,1.5a.54.54,0,0,0,.22,0,.5.5,0,0,0,.22-.95l-3-1.5a.51.51,0,0,0-.67.23A.5.5,0,0,0,1389.42,665.6Zm0,4,3,1.5a.54.54,0,0,0,.22,0,.5.5,0,0,0,.22-.95l-3-1.5a.5.5,0,0,0-.44.9Zm-3.54,1.1a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67l7,3.49a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.45.9l7,3.49a.42.42,0,0,0,.22.05.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm6.54,8.38a.54.54,0,0,0,.22.05.5.5,0,0,0,.22-1l-1.67-.83a.5.5,0,1,0-.44.89Zm-1.67,3.15,1.67.83a.43.43,0,0,0,.22.06.5.5,0,0,0,.22-1l-1.67-.83a.5.5,0,1,0-.44.89Zm-2.21,1.76a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l4.33,2.16a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l4.33,2.16a.42.42,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Z",
    className: "colorffffff svgShape"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#av)",
    points: "1393.47 559.4 1363.63 574.33 1333.78 559.4 1363.63 544.47 1393.47 559.4"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aw)",
    points: "1393.47 589.25 1363.63 604.17 1363.63 574.33 1393.47 559.4 1393.47 589.25"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ax)",
    points: "1363.63 604.17 1333.78 589.25 1333.78 559.4 1363.63 574.33 1363.63 604.17"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ay)",
    points: "1475.2 559.4 1445.35 574.33 1415.51 559.4 1445.35 544.47 1475.2 559.4"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#az)",
    points: "1475.2 589.25 1445.35 604.17 1445.35 574.33 1475.2 559.4 1475.2 589.25"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aA)",
    points: "1445.35 604.17 1415.51 589.25 1415.51 559.4 1445.35 574.33 1445.35 604.17"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aB)",
    points: "1433.05 580.48 1403.2 595.41 1373.36 580.48 1403.2 565.55 1433.05 580.48"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aC)",
    points: "1433.05 610.33 1403.2 625.25 1403.2 595.41 1433.05 580.48 1433.05 610.33"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aD)",
    points: "1403.2 625.25 1373.36 610.33 1373.36 580.48 1403.2 595.41 1403.2 625.25"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aE)",
    points: "1433.05 496.51 1403.2 511.44 1373.36 496.51 1403.2 481.59 1433.05 496.51"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aF)",
    points: "1433.05 526.36 1403.2 541.29 1403.2 511.44 1433.05 496.51 1433.05 526.36"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aG)",
    points: "1403.2 541.29 1373.36 526.36 1373.36 496.51 1403.2 511.44 1403.2 541.29"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aH)",
    points: "1475.2 517.42 1445.35 532.35 1415.51 517.42 1445.35 502.49 1475.2 517.42"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aI)",
    points: "1475.2 547.27 1445.35 562.19 1445.35 532.35 1475.2 517.42 1475.2 547.27"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aJ)",
    points: "1445.35 562.19 1415.51 547.27 1415.51 517.42 1445.35 532.35 1445.35 562.19"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aK)",
    points: "1393.47 517.42 1363.63 532.35 1333.78 517.42 1363.63 502.49 1393.47 517.42"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aL)",
    points: "1393.47 547.27 1363.63 562.19 1363.63 532.35 1393.47 517.42 1393.47 547.27"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aM)",
    points: "1363.63 562.19 1333.78 547.27 1333.78 517.42 1363.63 532.35 1363.63 562.19"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aN)",
    points: "1433.05 538.5 1403.2 553.43 1373.36 538.5 1403.2 523.58 1433.05 538.5"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aO)",
    points: "1433.05 568.35 1403.2 583.27 1403.2 553.43 1433.05 538.5 1433.05 568.35"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aP)",
    points: "1403.2 583.27 1373.36 568.35 1373.36 538.5 1403.2 553.43 1403.2 583.27"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1376.22 902.35 1377.73 937 1492.59 937 1492.59 902.35 1376.22 902.35",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#aQ)",
    opacity: 0.5
  }), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1561.89 833.03 1492.59 867.7 1423.28 833.03 1492.59 798.37 1561.89 833.03",
    className: "colorfeeecc svgShape"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1561.89 902.34 1492.59 937 1492.59 867.7 1561.89 833.03 1561.89 902.34",
    className: "colorffbe2e svgShape"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1492.59 937 1423.28 902.34 1423.28 833.03 1492.59 867.7 1492.59 937",
    className: "colore69729 svgShape"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1561.89 745.7 1492.59 780.36 1423.28 745.7 1492.59 711.04 1561.89 745.7",
    className: "colorf5e48c svgShape"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1561.89 815.01 1492.59 849.67 1492.59 780.36 1561.89 745.7 1561.89 815.01",
    className: "colorffbe2e svgShape"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1544.57 806.35 1509.91 823.68 1509.91 789.02 1544.57 771.69 1544.57 806.35",
    className: "colorfeeecc svgShape"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1492.59 849.67 1423.28 815.01 1423.28 745.7 1492.59 780.36 1492.59 849.67",
    className: "colore69729 svgShape"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.57 806.35 1544.57 771.69 1509.92 789.02 1544.57 806.35",
    className: "colore69729 svgShape"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1440.61 806.35 1475.26 823.68 1475.26 789.02 1440.61 771.69 1440.61 806.35",
    className: "colorfeeecc svgShape"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1440.61 806.35 1440.61 771.69 1475.25 789.02 1440.61 806.35",
    className: "colorffbe2e svgShape"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aR)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1535.9 784.73 1518.61 793.37 1501.32 784.73 1518.61 776.08 1535.9 784.73",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1535.9 802.02 1518.61 810.66 1518.61 793.37 1535.9 784.73 1535.9 802.02",
    className: "colorffbe2e svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1518.61 810.66 1501.32 802.02 1501.32 784.73 1518.61 793.37 1518.61 810.66",
    className: "colore69729 svgShape"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aS)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1449.27 784.73 1466.56 793.37 1483.85 784.73 1466.56 776.08 1449.27 784.73",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1449.27 802.02 1466.56 810.66 1466.56 793.37 1449.27 784.73 1449.27 802.02",
    className: "colore69729 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1466.56 810.66 1483.85 802.02 1483.85 784.73 1466.56 793.37 1466.56 810.66",
    className: "colorffbe2e svgShape"
  }))), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aT)",
    points: "1561.89 658.37 1492.59 693.03 1423.28 658.37 1492.59 623.71 1561.89 658.37"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aU)",
    points: "1561.89 727.68 1492.59 762.34 1492.59 693.03 1561.89 658.37 1561.89 727.68"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aV)",
    points: "1492.59 762.34 1423.28 727.68 1423.28 658.37 1492.59 693.03 1492.59 762.34"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M1555.44,625.72a48.28,48.28,0,0,0-13.85-9.89c-27.06-13.53-70.95-13.53-98,0a48.28,48.28,0,0,0-13.85,9.89h-6.45v14.62c0,8.87,6.76,17.75,20.3,24.51,27.06,13.54,71,13.54,98,0,13.54-6.76,20.3-15.64,20.3-24.51V625.72Z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1492.59,
    cy: 625.72,
    fill: "url(#aX)",
    rx: 69.31,
    ry: 34.66
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M1555.44,598.38a48.28,48.28,0,0,0-13.85-9.89c-27.06-13.53-70.95-13.53-98,0a48.28,48.28,0,0,0-13.85,9.89h-6.45V613c0,8.87,6.76,17.74,20.3,24.51,27.06,13.54,71,13.54,98,0,13.54-6.77,20.3-15.64,20.3-24.51V598.38Z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1492.59,
    cy: 598.38,
    fill: "url(#aZ)",
    rx: 69.31,
    ry: 34.66
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M1555.44,571a48.09,48.09,0,0,0-13.85-9.89c-27.06-13.53-70.95-13.53-98,0a48.09,48.09,0,0,0-13.85,9.89h-6.45v14.62c0,8.87,6.76,17.74,20.3,24.51,27.06,13.54,71,13.54,98,0,13.54-6.77,20.3-15.64,20.3-24.51V571Z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1492.59,
    cy: 571.04,
    fill: "url(#bb)",
    rx: 69.31,
    ry: 34.66
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1561.89 483.7 1492.59 518.37 1423.28 483.7 1492.59 449.04 1561.89 483.7",
    className: "colorf5e48c svgShape"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1561.89 553.01 1492.59 587.67 1492.59 518.37 1561.89 483.7 1561.89 553.01",
    className: "colorf5c25b svgShape"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bc)",
    points: "1492.59 587.67 1423.28 553.01 1423.28 483.7 1492.59 518.37 1492.59 587.67"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bd)",
    points: "1492.57 518.36 1423.28 553.01 1492.59 587.67 1492.59 518.37 1492.57 518.36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1503.43 528.4a.5.5 0 01-.44-.28.49.49 0 01.22-.67l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.46.46 0 011503.43 528.4zM1503.43 532.33a.5.5 0 01-.22-.94l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.46.46 0 011503.43 532.33zM1503.43 536.27a.5.5 0 01-.22-.94l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.46.46 0 011503.43 536.27zM1503.43 540.21a.5.5 0 01-.22-.94l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.46.46 0 011503.43 540.21zM1503.43 544.15a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 544.15zM1503.43 548.09a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 548.09zM1503.43 552a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 552zM1503.43 556a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 556zM1503.43 559.91a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 559.91zM1503.43 563.85a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 563.85zM1503.43 567.79a.5.5 0 01-.22-.94l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011503.43 567.79zM1516.57 521.83a.49.49 0 01-.45-.28.5.5 0 01.22-.67l9.53-4.77a.5.5 0 01.45.9l-9.53 4.76A.46.46 0 011516.57 521.83zM1516.57 525.77a.49.49 0 01-.45-.28.5.5 0 01.22-.67l9.53-4.77a.5.5 0 01.67.23.51.51 0 01-.22.67l-9.53 4.76A.46.46 0 011516.57 525.77zM1516.57 529.71a.49.49 0 01-.45-.28.5.5 0 01.22-.67l6.9-3.45a.5.5 0 01.67.22.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011516.57 529.71zM1516.57 533.65a.51.51 0 01-.45-.28.5.5 0 01.22-.67l3-1.48a.5.5 0 11.45.89l-3 1.48A.46.46 0 011516.57 533.65zM1516.57 537.59a.51.51 0 01-.45-.28.5.5 0 01.22-.67l6.9-3.45a.5.5 0 01.67.22.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011516.57 537.59zM1516.57 541.53a.51.51 0 01-.45-.28.5.5 0 01.22-.67l3-1.48a.5.5 0 11.45.89l-3 1.48A.46.46 0 011516.57 541.53zM1516.57 545.47a.51.51 0 01-.45-.28.5.5 0 01.22-.67l3-1.48a.5.5 0 11.45.89l-3 1.48A.46.46 0 011516.57 545.47zM1516.57 549.41a.51.51 0 01-.45-.28.5.5 0 01.22-.67l12.16-6.08a.51.51 0 01.67.22.5.5 0 01-.22.67l-12.16 6.08A.46.46 0 011516.57 549.41zM1516.57 553.35a.51.51 0 01-.45-.28.5.5 0 01.22-.67l12.16-6.08a.51.51 0 01.67.22.5.5 0 01-.22.67l-12.16 6.08A.46.46 0 011516.57 553.35zM1516.57 557.28a.5.5 0 01-.23-.94l8.22-4.11a.51.51 0 01.67.22.5.5 0 01-.22.67l-8.22 4.11A.44.44 0 011516.57 557.28zM1516.57 561.23a.51.51 0 01-.45-.28.5.5 0 01.22-.67l16.1-8a.5.5 0 11.44.89l-16.09 8A.46.46 0 011516.57 561.23zM1528.38 515.92a.5.5 0 01-.22-.95l4.28-2.14a.5.5 0 11.44.9l-4.27 2.13A.46.46 0 011528.38 515.92zM1528.38 519.86a.51.51 0 01-.44-.28.49.49 0 01.22-.67l4.28-2.14a.51.51 0 01.67.22.5.5 0 01-.23.67l-4.27 2.14A.46.46 0 011528.38 519.86zM1525.76 525.11a.49.49 0 01-.45-.28.51.51 0 01.22-.67l10.84-5.42a.52.52 0 01.68.22.5.5 0 01-.23.67L1526 525.06A.59.59 0 011525.76 525.11zM1521.82 531a.49.49 0 01-.45-.28.51.51 0 01.23-.67l9.52-4.76a.5.5 0 01.67.22.49.49 0 01-.22.67L1522 531A.59.59 0 011521.82 531zM1525.76 533a.49.49 0 01-.45-.28.51.51 0 01.22-.67l10.84-5.42a.52.52 0 01.68.22.5.5 0 01-.23.67L1526 532.94A.59.59 0 011525.76 533zM1521.82 538.9a.49.49 0 01-.45-.28.51.51 0 01.22-.67l10.85-5.42a.51.51 0 01.67.22.5.5 0 01-.23.67L1522 538.85A.59.59 0 011521.82 538.9zM1521.82 542.84a.49.49 0 01-.45-.28.51.51 0 01.22-.67l10.85-5.42a.51.51 0 01.67.22.5.5 0 01-.23.67L1522 542.79A.59.59 0 011521.82 542.84zM1531 542.18a.5.5 0 01-.22-.95l6.9-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.9 3.45A.64.64 0 011531 542.18zM1531 546.12a.5.5 0 01-.22-1l6.9-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.91 3.45A.54.54 0 011531 546.12zM1527.07 552a.5.5 0 01-.22-.95l10.84-5.42a.5.5 0 01.67.23.51.51 0 01-.22.67L1527.3 552A.64.64 0 011527.07 552zM1535 552a.5.5 0 01-.22-.95l3-1.48a.51.51 0 01.67.22.52.52 0 01-.22.68l-3 1.48A.54.54 0 011535 552zM1535 512.63a.51.51 0 01-.45-.27.5.5 0 01.23-.67l4.27-2.14a.5.5 0 11.45.89l-4.27 2.14A.48.48 0 011535 512.63zM1535 516.57a.5.5 0 01-.22-1l4.27-2.13a.5.5 0 11.45.89l-4.28 2.14A.42.42 0 011535 516.57zM1538.89 518.54a.5.5 0 01-.22-.95l6.9-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.9 3.45A.48.48 0 011538.89 518.54zM1533.64 525.11a.49.49 0 01-.45-.28.51.51 0 01.22-.67l12.16-6.08a.5.5 0 01.67.23.51.51 0 01-.22.67l-12.16 6.08A.59.59 0 011533.64 525.11zM1538.89 526.42a.5.5 0 01-.22-.95l6.9-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.9 3.45A.64.64 0 011538.89 526.42zM1535 532.33a.5.5 0 01-.22-1l6.9-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.9 3.45A.48.48 0 011535 532.33zM1535 536.27a.5.5 0 01-.22-.95l6.9-3.45a.5.5 0 01.67.23.51.51 0 01-.22.67l-6.9 3.45A.64.64 0 011535 536.27zM1540.2 537.58a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.46.46 0 011540.2 537.58zM1540.2 541.52a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011540.2 541.52zM1540.2 545.46a.5.5 0 01-.44-.27.49.49 0 01.22-.67l4.28-2.14a.49.49 0 01.67.22.5.5 0 01-.23.67l-4.27 2.14A.46.46 0 011540.2 545.46zM1540.2 549.4a.5.5 0 01-.44-.27.49.49 0 01.22-.67l4.28-2.14a.51.51 0 01.67.22.5.5 0 01-.23.67l-4.27 2.14A.46.46 0 011540.2 549.4zM1541.52 509.35a.49.49 0 01-.45-.28.51.51 0 01.22-.67l9.53-4.76a.5.5 0 01.67.22.49.49 0 01-.22.67l-9.53 4.77A.59.59 0 011541.52 509.35zM1541.52 513.29a.49.49 0 01-.45-.28.51.51 0 01.22-.67l9.53-4.76a.5.5 0 11.45.89l-9.53 4.77A.59.59 0 011541.52 513.29zM1548.08 513.94a.5.5 0 01-.22-.94l3-1.48a.5.5 0 11.45.89l-3 1.48A.46.46 0 011548.08 513.94zM1548.08 517.88a.5.5 0 01-.22-.94l3-1.48a.5.5 0 01.67.22.49.49 0 01-.22.67l-3 1.48A.46.46 0 011548.08 517.88zM1548.08 521.82a.5.5 0 01-.22-.94l3-1.48a.5.5 0 11.45.89l-3 1.48A.46.46 0 011548.08 521.82zM1544.14 527.73a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 011544.14 527.73zM1544.14 531.67a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.45a.5.5 0 11.45.89l-6.9 3.45A.46.46 0 011544.14 531.67zM1549.4 533a.51.51 0 01-.45-.28.5.5 0 01.22-.67l1.65-.83a.5.5 0 01.67.23.49.49 0 01-.22.67l-1.65.82A.46.46 0 011549.4 533zM1549.4 536.93a.51.51 0 01-.45-.28.5.5 0 01.22-.67l1.65-.83a.5.5 0 01.67.23.49.49 0 01-.22.67l-1.65.82A.46.46 0 011549.4 536.93zM1546.77 542.18a.5.5 0 01-.22-.95l4.27-2.14a.5.5 0 01.67.23.49.49 0 01-.22.67l-4.28 2.14A.54.54 0 011546.77 542.18zM1546.77 546.12a.5.5 0 01-.22-1l4.27-2.14a.5.5 0 01.67.23.49.49 0 01-.22.67l-4.28 2.14A.54.54 0 011546.77 546.12z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1465.53 947.01 1467.04 981.67 1581.89 981.67 1581.89 947.01 1465.53 947.01",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#be)",
    opacity: 0.5
  }), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1651.2 877.7 1581.89 912.36 1512.59 877.7 1581.89 843.04 1651.2 877.7",
    className: "colorfeeecc svgShape"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1651.2 947.01 1581.89 981.67 1581.89 912.36 1651.2 877.7 1651.2 947.01",
    className: "colorffbe2e svgShape"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1633.87 938.34 1599.22 955.67 1599.22 921.02 1633.87 903.69 1633.87 938.34",
    className: "colorfeeecc svgShape"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.89 981.67 1512.59 947.01 1512.59 877.7 1581.89 912.36 1581.89 981.67",
    className: "colore69729 svgShape"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1633.87 938.34 1633.87 903.69 1599.23 921.02 1633.87 938.34",
    className: "colore69729 svgShape"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1529.91 938.34 1564.57 955.67 1564.57 921.02 1529.91 903.69 1529.91 938.34",
    className: "colorfeeecc svgShape"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1529.91 938.34 1529.91 903.69 1564.56 921.02 1529.91 938.34",
    className: "colorffbe2e svgShape"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1625.21 916.72 1607.92 925.37 1590.63 916.72 1607.92 908.07 1625.21 916.72",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1625.21 934.01 1607.92 942.66 1607.92 925.37 1625.21 916.72 1625.21 934.01",
    className: "colorffbe2e svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1607.92 942.66 1590.63 934.01 1590.63 916.72 1607.92 925.37 1607.92 942.66",
    className: "colore69729 svgShape"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1538.58 916.72 1555.87 925.37 1573.16 916.72 1555.87 908.07 1538.58 916.72",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1538.58 934.01 1555.87 942.66 1555.87 925.37 1538.58 916.72 1538.58 934.01",
    className: "colore69729 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1555.87 942.66 1573.16 934.01 1573.16 916.72 1555.87 925.37 1555.87 942.66",
    className: "colorffbe2e svgShape"
  }))), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bh)",
    points: "1651.2 790.37 1581.89 825.03 1512.59 790.37 1581.89 755.7 1651.2 790.37"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bi)",
    points: "1651.2 859.67 1581.89 894.33 1581.89 825.03 1651.2 790.37 1651.2 859.67"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bj)",
    points: "1581.89 894.33 1512.59 859.67 1512.59 790.37 1581.89 825.03 1581.89 894.33"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1644.75,757.72a48.09,48.09,0,0,0-13.85-9.89c-27.07-13.54-71-13.54-98,0a48.09,48.09,0,0,0-13.85,9.89h-6.45v14.62c0,8.87,6.76,17.74,20.3,24.51,27.06,13.54,70.94,13.54,98,0,13.53-6.77,20.3-15.64,20.3-24.51V757.72Z",
    className: "colore69729 svgShape"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1581.89,
    cy: 757.72,
    fill: "#ccfafe",
    rx: 69.31,
    ry: 34.66,
    className: "colorfeeecc svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1644.75,730.37a48.26,48.26,0,0,0-13.85-9.88c-27.07-13.54-71-13.54-98,0a48.26,48.26,0,0,0-13.85,9.88h-6.45V745c0,8.87,6.76,17.74,20.3,24.51,27.06,13.53,70.94,13.53,98,0,13.53-6.77,20.3-15.64,20.3-24.51V730.37Z",
    className: "colore69729 svgShape"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1581.89,
    cy: 730.37,
    fill: "#ccfafe",
    rx: 69.31,
    ry: 34.66,
    className: "colorfeeecc svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1644.75,703a48.07,48.07,0,0,0-13.85-9.88c-27.07-13.54-71-13.54-98,0A48.07,48.07,0,0,0,1519,703h-6.45v14.63c0,8.87,6.76,17.74,20.3,24.51,27.06,13.53,70.94,13.53,98,0,13.53-6.77,20.3-15.64,20.3-24.51V703Z",
    className: "colore69729 svgShape"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1581.89,
    cy: 703.03,
    fill: "#ccfafe",
    rx: 69.31,
    ry: 34.66,
    className: "colorfeeecc svgShape"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1651.2 615.7 1581.89 650.36 1512.59 615.7 1581.89 581.04 1651.2 615.7",
    className: "colorf5e48c svgShape"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1651.2 685.01 1581.89 719.67 1581.89 650.36 1651.2 615.7 1651.2 685.01",
    className: "colorf5c25b svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1595.43,652.37c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.63S1598.24,651,1595.43,652.37Zm0,14.55c-2.81,1.41-5.09,4.82-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.64S1598.24,665.51,1595.43,666.92Zm0,29.09c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.55,5.09-4.83,5.09-7.64S1598.24,694.61,1595.43,696Zm0-14.54c-2.81,1.4-5.09,4.82-5.09,7.63s2.28,3.95,5.09,2.55,5.09-4.83,5.09-7.64S1598.24,680.06,1595.43,681.47ZM1610,659.64c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.55,5.1-4.83,5.1-7.64S1612.79,658.24,1610,659.64Zm0,29.1c-2.81,1.4-5.09,4.82-5.09,7.64s2.28,4,5.09,2.54,5.1-4.83,5.1-7.64S1612.79,687.33,1610,688.74Zm0-14.55c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,3.95,5.09,2.54,5.1-4.82,5.1-7.63S1612.79,672.78,1610,674.19Zm0-29.09c-2.81,1.4-5.09,4.82-5.09,7.63s2.28,4,5.09,2.55,5.1-4.83,5.1-7.64S1612.79,643.69,1610,645.1Zm14.55-7.28c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,3.95,5.09,2.54,5.09-4.82,5.09-7.63S1627.33,636.42,1624.52,637.82Zm0,14.55c-2.81,1.41-5.09,4.82-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.64S1627.33,651,1624.52,652.37Zm0,29.09c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,3.95,5.09,2.55,5.09-4.83,5.09-7.64S1627.33,680.06,1624.52,681.46Zm0-14.54c-2.81,1.4-5.09,4.82-5.09,7.63s2.28,4,5.09,2.55,5.09-4.83,5.09-7.64S1627.33,665.51,1624.52,666.92Zm14.55-21.83c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,3.95,5.09,2.55,5.09-4.83,5.09-7.64S1641.88,643.69,1639.07,645.09Zm0-4.36c2.81-1.41,5.09-4.83,5.09-7.64s-2.28-4-5.09-2.54-5.09,4.82-5.09,7.63S1636.26,642.14,1639.07,640.73Zm0,18.91c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.63S1641.88,658.23,1639.07,659.64Zm0,14.55c-2.81,1.4-5.09,4.82-5.09,7.64s2.28,3.95,5.09,2.54,5.09-4.83,5.09-7.64S1641.88,672.78,1639.07,674.19Z",
    className: "colorffffff svgShape"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bk)",
    points: "1581.89 719.67 1512.59 685.01 1512.59 615.7 1581.89 650.36 1581.89 719.67"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.47 554.49 1582.2 561.12 1568.94 554.49 1582.2 547.85 1595.47 554.49",
    className: "colorfeeecc svgShape"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.47 567.75 1582.2 574.38 1582.2 561.12 1595.47 554.49 1595.47 567.75",
    className: "colorffbe2e svgShape"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.2 574.38 1568.94 567.75 1568.94 554.49 1582.2 561.12 1582.2 574.38",
    className: "colore69729 svgShape"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.73 563.85 1563.47 570.49 1550.21 563.85 1563.47 557.22 1576.73 563.85",
    className: "colorfeeecc svgShape"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.73 577.12 1563.47 583.75 1563.47 570.49 1576.73 563.85 1576.73 577.12",
    className: "colorffbe2e svgShape"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.47 583.75 1550.21 577.12 1550.21 563.85 1563.47 570.49 1563.47 583.75",
    className: "colore69729 svgShape"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1558 573.22 1544.74 579.86 1531.47 573.22 1544.74 566.59 1558 573.22",
    className: "colorfeeecc svgShape"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1558 586.49 1544.74 593.12 1544.74 579.86 1558 573.22 1558 586.49",
    className: "colorffbe2e svgShape"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.74 593.12 1531.47 586.49 1531.47 573.22 1544.74 579.86 1544.74 593.12",
    className: "colore69729 svgShape"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1539.27 582.59 1526 589.22 1512.74 582.59 1526 575.96 1539.27 582.59",
    className: "colorfeeecc svgShape"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1539.27 595.85 1526 602.49 1526 589.22 1539.27 582.59 1539.27 595.85",
    className: "colorffbe2e svgShape"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1526 602.49 1512.74 595.85 1512.74 582.59 1526 589.22 1526 602.49",
    className: "colore69729 svgShape"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.47 535.83 1582.2 542.46 1568.94 535.83 1582.2 529.2 1595.47 535.83",
    className: "colorfeeecc svgShape"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.47 549.09 1582.2 555.73 1582.2 542.46 1595.47 535.83 1595.47 549.09",
    className: "colorffbe2e svgShape"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.2 555.73 1568.94 549.09 1568.94 535.83 1582.2 542.46 1582.2 555.73",
    className: "colore69729 svgShape"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.73 545.2 1563.47 551.83 1550.21 545.2 1563.47 538.57 1576.73 545.2",
    className: "colorfeeecc svgShape"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.73 558.46 1563.47 565.1 1563.47 551.83 1576.73 545.2 1576.73 558.46",
    className: "colorffbe2e svgShape"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.47 565.1 1550.21 558.46 1550.21 545.2 1563.47 551.83 1563.47 565.1",
    className: "colore69729 svgShape"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1558 554.57 1544.74 561.2 1531.47 554.57 1544.74 547.93 1558 554.57",
    className: "colorfeeecc svgShape"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1558 567.83 1544.74 574.46 1544.74 561.2 1558 554.57 1558 567.83",
    className: "colorffbe2e svgShape"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.74 574.46 1531.47 567.83 1531.47 554.57 1544.74 561.2 1544.74 574.46",
    className: "colore69729 svgShape"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1539.27 563.93 1526 570.57 1512.74 563.93 1526 557.3 1539.27 563.93",
    className: "colorfeeecc svgShape"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1539.27 577.2 1526 583.83 1526 570.57 1539.27 563.93 1539.27 577.2",
    className: "colorffbe2e svgShape"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1526 583.83 1512.74 577.2 1512.74 563.93 1526 570.57 1526 583.83",
    className: "colore69729 svgShape"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.47 517.17 1582.2 523.81 1568.94 517.17 1582.2 510.54 1595.47 517.17",
    className: "colorfeeecc svgShape"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.47 530.44 1582.2 537.07 1582.2 523.81 1595.47 517.17 1595.47 530.44",
    className: "colorffbe2e svgShape"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.2 537.07 1568.94 530.44 1568.94 517.17 1582.2 523.81 1582.2 537.07",
    className: "colore69729 svgShape"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.73 526.54 1563.47 533.18 1550.21 526.54 1563.47 519.91 1576.73 526.54",
    className: "colorfeeecc svgShape"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.73 539.81 1563.47 546.44 1563.47 533.18 1576.73 526.54 1576.73 539.81",
    className: "colorffbe2e svgShape"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.47 546.44 1550.21 539.81 1550.21 526.54 1563.47 533.18 1563.47 546.44",
    className: "colore69729 svgShape"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1558 535.91 1544.74 542.54 1531.47 535.91 1544.74 529.28 1558 535.91",
    className: "colorfeeecc svgShape"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1558 549.17 1544.74 555.81 1544.74 542.54 1558 535.91 1558 549.17",
    className: "colorffbe2e svgShape"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.74 555.81 1531.47 549.17 1531.47 535.91 1544.74 542.54 1544.74 555.81",
    className: "colore69729 svgShape"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1539.27 545.28 1526 551.91 1512.74 545.28 1526 538.65 1539.27 545.28",
    className: "colorfeeecc svgShape"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1539.27 558.54 1526 565.18 1526 551.91 1539.27 545.28 1539.27 558.54",
    className: "colorffbe2e svgShape"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1526 565.18 1512.74 558.54 1512.74 545.28 1526 551.91 1526 565.18",
    className: "colore69729 svgShape"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.31 498.52 1582.05 505.15 1568.78 498.52 1582.05 491.88 1595.31 498.52",
    className: "colorfeeecc svgShape"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.31 511.78 1582.05 518.41 1582.05 505.15 1595.31 498.52 1595.31 511.78",
    className: "colorffbe2e svgShape"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.05 518.41 1568.78 511.78 1568.78 498.52 1582.05 505.15 1582.05 518.41",
    className: "colore69729 svgShape"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.58 507.89 1563.32 514.52 1550.05 507.89 1563.32 501.25 1576.58 507.89",
    className: "colorfeeecc svgShape"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.58 521.15 1563.32 527.78 1563.32 514.52 1576.58 507.89 1576.58 521.15",
    className: "colorffbe2e svgShape"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.32 527.78 1550.05 521.15 1550.05 507.89 1563.32 514.52 1563.32 527.78",
    className: "colore69729 svgShape"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1557.85 517.25 1544.58 523.89 1531.32 517.25 1544.58 510.62 1557.85 517.25",
    className: "colorfeeecc svgShape"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1557.85 530.52 1544.58 537.15 1544.58 523.89 1557.85 517.25 1557.85 530.52",
    className: "colorffbe2e svgShape"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.58 537.15 1531.32 530.52 1531.32 517.25 1544.58 523.89 1544.58 537.15",
    className: "colore69729 svgShape"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1539.11 526.62 1525.85 533.26 1512.59 526.62 1525.85 519.99 1539.11 526.62",
    className: "colorfeeecc svgShape"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1539.11 539.89 1525.85 546.52 1525.85 533.26 1539.11 526.62 1539.11 539.89",
    className: "colorffbe2e svgShape"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1525.85 546.52 1512.59 539.89 1512.59 526.62 1525.85 533.26 1525.85 546.52",
    className: "colore69729 svgShape"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1614.1 563.78 1600.83 570.41 1587.57 563.78 1600.83 557.14 1614.1 563.78",
    className: "colorfeeecc svgShape"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1614.1 577.04 1600.83 583.67 1600.83 570.41 1614.1 563.78 1614.1 577.04",
    className: "colorffbe2e svgShape"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.83 583.67 1587.57 577.04 1587.57 563.78 1600.83 570.41 1600.83 583.67",
    className: "colore69729 svgShape"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.36 573.14 1582.1 579.78 1568.84 573.14 1582.1 566.51 1595.36 573.14",
    className: "colorfeeecc svgShape"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.36 586.41 1582.1 593.04 1582.1 579.78 1595.36 573.14 1595.36 586.41",
    className: "colorffbe2e svgShape"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.1 593.04 1568.84 586.41 1568.84 573.14 1582.1 579.78 1582.1 593.04",
    className: "colore69729 svgShape"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.63 582.51 1563.37 589.15 1550.1 582.51 1563.37 575.88 1576.63 582.51",
    className: "colorfeeecc svgShape"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.63 595.78 1563.37 602.41 1563.37 589.15 1576.63 582.51 1576.63 595.78",
    className: "colorffbe2e svgShape"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.37 602.41 1550.1 595.78 1550.1 582.51 1563.37 589.15 1563.37 602.41",
    className: "colore69729 svgShape"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1557.9 591.88 1544.63 598.51 1531.37 591.88 1544.63 585.25 1557.9 591.88",
    className: "colorfeeecc svgShape"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1557.9 605.14 1544.63 611.78 1544.63 598.51 1557.9 591.88 1557.9 605.14",
    className: "colorffbe2e svgShape"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.63 611.78 1531.37 605.14 1531.37 591.88 1544.63 598.51 1544.63 611.78",
    className: "colore69729 svgShape"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1614.1 545.12 1600.83 551.75 1587.57 545.12 1600.83 538.49 1614.1 545.12",
    className: "colorfeeecc svgShape"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1614.1 558.38 1600.83 565.02 1600.83 551.75 1614.1 545.12 1614.1 558.38",
    className: "colorffbe2e svgShape"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.83 565.02 1587.57 558.38 1587.57 545.12 1600.83 551.75 1600.83 565.02",
    className: "colore69729 svgShape"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.36 554.49 1582.1 561.12 1568.84 554.49 1582.1 547.86 1595.36 554.49",
    className: "colorfeeecc svgShape"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.36 567.75 1582.1 574.39 1582.1 561.12 1595.36 554.49 1595.36 567.75",
    className: "colorffbe2e svgShape"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.1 574.39 1568.84 567.75 1568.84 554.49 1582.1 561.12 1582.1 574.39",
    className: "colore69729 svgShape"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.63 563.86 1563.37 570.49 1550.1 563.86 1563.37 557.22 1576.63 563.86",
    className: "colorfeeecc svgShape"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.63 577.12 1563.37 583.75 1563.37 570.49 1576.63 563.86 1576.63 577.12",
    className: "colorffbe2e svgShape"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.37 583.75 1550.1 577.12 1550.1 563.86 1563.37 570.49 1563.37 583.75",
    className: "colore69729 svgShape"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1557.9 573.23 1544.63 579.86 1531.37 573.23 1544.63 566.59 1557.9 573.23",
    className: "colorfeeecc svgShape"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1557.9 586.49 1544.63 593.12 1544.63 579.86 1557.9 573.23 1557.9 586.49",
    className: "colorffbe2e svgShape"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.63 593.12 1531.37 586.49 1531.37 573.23 1544.63 579.86 1544.63 593.12",
    className: "colore69729 svgShape"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1614.1 526.47 1600.83 533.1 1587.57 526.47 1600.83 519.83 1614.1 526.47",
    className: "colorfeeecc svgShape"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1614.1 539.73 1600.83 546.36 1600.83 533.1 1614.1 526.47 1614.1 539.73",
    className: "colorffbe2e svgShape"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.83 546.36 1587.57 539.73 1587.57 526.47 1600.83 533.1 1600.83 546.36",
    className: "colore69729 svgShape"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.36 535.83 1582.1 542.47 1568.84 535.83 1582.1 529.2 1595.36 535.83",
    className: "colorfeeecc svgShape"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.36 549.1 1582.1 555.73 1582.1 542.47 1595.36 535.83 1595.36 549.1",
    className: "colorffbe2e svgShape"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.1 555.73 1568.84 549.1 1568.84 535.83 1582.1 542.47 1582.1 555.73",
    className: "colore69729 svgShape"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.63 545.2 1563.37 551.84 1550.1 545.2 1563.37 538.57 1576.63 545.2",
    className: "colorfeeecc svgShape"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.63 558.47 1563.37 565.1 1563.37 551.84 1576.63 545.2 1576.63 558.47",
    className: "colorffbe2e svgShape"
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.37 565.1 1550.1 558.47 1550.1 545.2 1563.37 551.84 1563.37 565.1",
    className: "colore69729 svgShape"
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1557.9 554.57 1544.63 561.2 1531.37 554.57 1544.63 547.94 1557.9 554.57",
    className: "colorfeeecc svgShape"
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1557.9 567.83 1544.63 574.47 1544.63 561.2 1557.9 554.57 1557.9 567.83",
    className: "colorffbe2e svgShape"
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.63 574.47 1531.37 567.83 1531.37 554.57 1544.63 561.2 1544.63 574.47",
    className: "colore69729 svgShape"
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.94 507.81 1600.68 514.44 1587.41 507.81 1600.68 501.18 1613.94 507.81",
    className: "colorfeeecc svgShape"
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.94 521.07 1600.68 527.71 1600.68 514.44 1613.94 507.81 1613.94 521.07",
    className: "colorffbe2e svgShape"
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.68 527.71 1587.41 521.07 1587.41 507.81 1600.68 514.44 1600.68 527.71",
    className: "colore69729 svgShape"
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.21 517.18 1581.94 523.81 1568.68 517.18 1581.94 510.55 1595.21 517.18",
    className: "colorfeeecc svgShape"
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.21 530.44 1581.94 537.08 1581.94 523.81 1595.21 517.18 1595.21 530.44",
    className: "colorffbe2e svgShape"
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.94 537.08 1568.68 530.44 1568.68 517.18 1581.94 523.81 1581.94 537.08",
    className: "colore69729 svgShape"
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.48 526.55 1563.21 533.18 1549.95 526.55 1563.21 519.91 1576.48 526.55",
    className: "colorfeeecc svgShape"
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.48 539.81 1563.21 546.44 1563.21 533.18 1576.48 526.55 1576.48 539.81",
    className: "colorffbe2e svgShape"
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.21 546.44 1549.95 539.81 1549.95 526.55 1563.21 533.18 1563.21 546.44",
    className: "colore69729 svgShape"
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1557.74 535.91 1544.48 542.55 1531.21 535.91 1544.48 529.28 1557.74 535.91",
    className: "colorfeeecc svgShape"
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1557.74 549.18 1544.48 555.81 1544.48 542.55 1557.74 535.91 1557.74 549.18",
    className: "colorffbe2e svgShape"
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1544.48 555.81 1531.21 549.18 1531.21 535.91 1544.48 542.55 1544.48 555.81",
    className: "colore69729 svgShape"
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.73 573.07 1619.46 579.7 1606.2 573.07 1619.46 566.43 1632.73 573.07",
    className: "colorfeeecc svgShape"
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.73 586.33 1619.46 592.96 1619.46 579.7 1632.73 573.07 1632.73 586.33",
    className: "colorffbe2e svgShape"
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.46 592.96 1606.2 586.33 1606.2 573.07 1619.46 579.7 1619.46 592.96",
    className: "colore69729 svgShape"
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.99 582.44 1600.73 589.07 1587.47 582.44 1600.73 575.8 1613.99 582.44",
    className: "colorfeeecc svgShape"
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.99 595.7 1600.73 602.33 1600.73 589.07 1613.99 582.44 1613.99 595.7",
    className: "colorffbe2e svgShape"
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.73 602.33 1587.47 595.7 1587.47 582.44 1600.73 589.07 1600.73 602.33",
    className: "colore69729 svgShape"
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.26 591.8 1582 598.44 1568.73 591.8 1582 585.17 1595.26 591.8",
    className: "colorfeeecc svgShape"
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.26 605.07 1582 611.7 1582 598.44 1595.26 591.8 1595.26 605.07",
    className: "colorffbe2e svgShape"
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582 611.7 1568.73 605.07 1568.73 591.8 1582 598.44 1582 611.7",
    className: "colore69729 svgShape"
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.53 601.17 1563.26 607.81 1550 601.17 1563.26 594.54 1576.53 601.17",
    className: "colorfeeecc svgShape"
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.53 614.44 1563.26 621.07 1563.26 607.81 1576.53 601.17 1576.53 614.44",
    className: "colorffbe2e svgShape"
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.26 621.07 1550 614.44 1550 601.17 1563.26 607.81 1563.26 621.07",
    className: "colore69729 svgShape"
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.73 554.41 1619.46 561.04 1606.2 554.41 1619.46 547.78 1632.73 554.41",
    className: "colorfeeecc svgShape"
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.73 567.68 1619.46 574.31 1619.46 561.04 1632.73 554.41 1632.73 567.68",
    className: "colorffbe2e svgShape"
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.46 574.31 1606.2 567.68 1606.2 554.41 1619.46 561.04 1619.46 574.31",
    className: "colore69729 svgShape"
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.99 563.78 1600.73 570.41 1587.47 563.78 1600.73 557.15 1613.99 563.78",
    className: "colorfeeecc svgShape"
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.99 577.04 1600.73 583.68 1600.73 570.41 1613.99 563.78 1613.99 577.04",
    className: "colorffbe2e svgShape"
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.73 583.68 1587.47 577.04 1587.47 563.78 1600.73 570.41 1600.73 583.68",
    className: "colore69729 svgShape"
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.26 573.15 1582 579.78 1568.73 573.15 1582 566.51 1595.26 573.15",
    className: "colorfeeecc svgShape"
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.26 586.41 1582 593.05 1582 579.78 1595.26 573.15 1595.26 586.41",
    className: "colorffbe2e svgShape"
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582 593.05 1568.73 586.41 1568.73 573.15 1582 579.78 1582 593.05",
    className: "colore69729 svgShape"
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.53 582.52 1563.26 589.15 1550 582.52 1563.26 575.88 1576.53 582.52",
    className: "colorfeeecc svgShape"
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.53 595.78 1563.26 602.41 1563.26 589.15 1576.53 582.52 1576.53 595.78",
    className: "colorffbe2e svgShape"
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.26 602.41 1550 595.78 1550 582.52 1563.26 589.15 1563.26 602.41",
    className: "colore69729 svgShape"
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.73 535.76 1619.46 542.39 1606.2 535.76 1619.46 529.12 1632.73 535.76",
    className: "colorfeeecc svgShape"
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.73 549.02 1619.46 555.65 1619.46 542.39 1632.73 535.76 1632.73 549.02",
    className: "colorffbe2e svgShape"
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.46 555.65 1606.2 549.02 1606.2 535.76 1619.46 542.39 1619.46 555.65",
    className: "colore69729 svgShape"
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.99 545.13 1600.73 551.76 1587.47 545.13 1600.73 538.49 1613.99 545.13",
    className: "colorfeeecc svgShape"
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.99 558.39 1600.73 565.02 1600.73 551.76 1613.99 545.13 1613.99 558.39",
    className: "colorffbe2e svgShape"
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.73 565.02 1587.47 558.39 1587.47 545.13 1600.73 551.76 1600.73 565.02",
    className: "colore69729 svgShape"
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.26 554.49 1582 561.13 1568.73 554.49 1582 547.86 1595.26 554.49",
    className: "colorfeeecc svgShape"
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.26 567.76 1582 574.39 1582 561.13 1595.26 554.49 1595.26 567.76",
    className: "colorffbe2e svgShape"
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582 574.39 1568.73 567.76 1568.73 554.49 1582 561.13 1582 574.39",
    className: "colore69729 svgShape"
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.53 563.86 1563.26 570.5 1550 563.86 1563.26 557.23 1576.53 563.86",
    className: "colorfeeecc svgShape"
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.53 577.13 1563.26 583.76 1563.26 570.5 1576.53 563.86 1576.53 577.13",
    className: "colorffbe2e svgShape"
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.26 583.76 1550 577.13 1550 563.86 1563.26 570.5 1563.26 583.76",
    className: "colore69729 svgShape"
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.57 517.1 1619.31 523.73 1606.04 517.1 1619.31 510.47 1632.57 517.1",
    className: "colorfeeecc svgShape"
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.57 530.36 1619.31 537 1619.31 523.73 1632.57 517.1 1632.57 530.36",
    className: "colorffbe2e svgShape"
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.31 537 1606.04 530.36 1606.04 517.1 1619.31 523.73 1619.31 537",
    className: "colore69729 svgShape"
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.84 526.47 1600.58 533.1 1587.31 526.47 1600.58 519.84 1613.84 526.47",
    className: "colorfeeecc svgShape"
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.84 539.73 1600.58 546.37 1600.58 533.1 1613.84 526.47 1613.84 539.73",
    className: "colorffbe2e svgShape"
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.58 546.37 1587.31 539.73 1587.31 526.47 1600.58 533.1 1600.58 546.37",
    className: "colore69729 svgShape"
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.11 535.84 1581.84 542.47 1568.58 535.84 1581.84 529.2 1595.11 535.84",
    className: "colorfeeecc svgShape"
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.11 549.1 1581.84 555.74 1581.84 542.47 1595.11 535.84 1595.11 549.1",
    className: "colorffbe2e svgShape"
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.84 555.74 1568.58 549.1 1568.58 535.84 1581.84 542.47 1581.84 555.74",
    className: "colore69729 svgShape"
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1576.37 545.21 1563.11 551.84 1549.85 545.21 1563.11 538.57 1576.37 545.21",
    className: "colorfeeecc svgShape"
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1576.37 558.47 1563.11 565.1 1563.11 551.84 1576.37 545.21 1576.37 558.47",
    className: "colorffbe2e svgShape"
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1563.11 565.1 1549.85 558.47 1549.85 545.21 1563.11 551.84 1563.11 565.1",
    className: "colore69729 svgShape"
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1651.36 582.36 1638.09 588.99 1624.83 582.36 1638.09 575.73 1651.36 582.36",
    className: "colorfeeecc svgShape"
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1651.36 595.62 1638.09 602.26 1638.09 588.99 1651.36 582.36 1651.36 595.62",
    className: "colorffbe2e svgShape"
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1638.09 602.26 1624.83 595.62 1624.83 582.36 1638.09 588.99 1638.09 602.26",
    className: "colore69729 svgShape"
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.62 591.73 1619.36 598.36 1606.1 591.73 1619.36 585.09 1632.62 591.73",
    className: "colorfeeecc svgShape"
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.62 604.99 1619.36 611.62 1619.36 598.36 1632.62 591.73 1632.62 604.99",
    className: "colorffbe2e svgShape"
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.36 611.62 1606.1 604.99 1606.1 591.73 1619.36 598.36 1619.36 611.62",
    className: "colore69729 svgShape"
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.89 601.1 1600.63 607.73 1587.36 601.1 1600.63 594.46 1613.89 601.1",
    className: "colorfeeecc svgShape"
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.89 614.36 1600.63 620.99 1600.63 607.73 1613.89 601.1 1613.89 614.36",
    className: "colorffbe2e svgShape"
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.63 620.99 1587.36 614.36 1587.36 601.1 1600.63 607.73 1600.63 620.99",
    className: "colore69729 svgShape"
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.16 610.46 1581.89 617.1 1568.63 610.46 1581.89 603.83 1595.16 610.46",
    className: "colorfeeecc svgShape"
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.16 623.73 1581.89 630.36 1581.89 617.1 1595.16 610.46 1595.16 623.73",
    className: "colorffbe2e svgShape"
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.89 630.36 1568.63 623.73 1568.63 610.46 1581.89 617.1 1581.89 630.36",
    className: "colore69729 svgShape"
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1651.36 563.7 1638.09 570.34 1624.83 563.7 1638.09 557.07 1651.36 563.7",
    className: "colorfeeecc svgShape"
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1651.36 576.97 1638.09 583.6 1638.09 570.34 1651.36 563.7 1651.36 576.97",
    className: "colorffbe2e svgShape"
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1638.09 583.6 1624.83 576.97 1624.83 563.7 1638.09 570.34 1638.09 583.6",
    className: "colore69729 svgShape"
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.62 573.07 1619.36 579.71 1606.1 573.07 1619.36 566.44 1632.62 573.07",
    className: "colorfeeecc svgShape"
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.62 586.34 1619.36 592.97 1619.36 579.71 1632.62 573.07 1632.62 586.34",
    className: "colorffbe2e svgShape"
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.36 592.97 1606.1 586.34 1606.1 573.07 1619.36 579.71 1619.36 592.97",
    className: "colore69729 svgShape"
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.89 582.44 1600.63 589.07 1587.36 582.44 1600.63 575.81 1613.89 582.44",
    className: "colorfeeecc svgShape"
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.89 595.7 1600.63 602.34 1600.63 589.07 1613.89 582.44 1613.89 595.7",
    className: "colorffbe2e svgShape"
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.63 602.34 1587.36 595.7 1587.36 582.44 1600.63 589.07 1600.63 602.34",
    className: "colore69729 svgShape"
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.16 591.81 1581.89 598.44 1568.63 591.81 1581.89 585.17 1595.16 591.81",
    className: "colorfeeecc svgShape"
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.16 605.07 1581.89 611.71 1581.89 598.44 1595.16 591.81 1595.16 605.07",
    className: "colorffbe2e svgShape"
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.89 611.71 1568.63 605.07 1568.63 591.81 1581.89 598.44 1581.89 611.71",
    className: "colore69729 svgShape"
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1651.36 545.05 1638.09 551.68 1624.83 545.05 1638.09 538.41 1651.36 545.05",
    className: "colorfeeecc svgShape"
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1651.36 558.31 1638.09 564.94 1638.09 551.68 1651.36 545.05 1651.36 558.31",
    className: "colorffbe2e svgShape"
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1638.09 564.94 1624.83 558.31 1624.83 545.05 1638.09 551.68 1638.09 564.94",
    className: "colore69729 svgShape"
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.62 554.42 1619.36 561.05 1606.1 554.42 1619.36 547.78 1632.62 554.42",
    className: "colorfeeecc svgShape"
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.62 567.68 1619.36 574.31 1619.36 561.05 1632.62 554.42 1632.62 567.68",
    className: "colorffbe2e svgShape"
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.36 574.31 1606.1 567.68 1606.1 554.42 1619.36 561.05 1619.36 574.31",
    className: "colore69729 svgShape"
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.89 563.78 1600.63 570.42 1587.36 563.78 1600.63 557.15 1613.89 563.78",
    className: "colorfeeecc svgShape"
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.89 577.05 1600.63 583.68 1600.63 570.42 1613.89 563.78 1613.89 577.05",
    className: "colorffbe2e svgShape"
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.63 583.68 1587.36 577.05 1587.36 563.78 1600.63 570.42 1600.63 583.68",
    className: "colore69729 svgShape"
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595.16 573.15 1581.89 579.79 1568.63 573.15 1581.89 566.52 1595.16 573.15",
    className: "colorfeeecc svgShape"
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595.16 586.42 1581.89 593.05 1581.89 579.79 1595.16 573.15 1595.16 586.42",
    className: "colorffbe2e svgShape"
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.89 593.05 1568.63 586.42 1568.63 573.15 1581.89 579.79 1581.89 593.05",
    className: "colore69729 svgShape"
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1651.2 526.39 1637.94 533.02 1624.67 526.39 1637.94 519.76 1651.2 526.39",
    className: "colorfeeecc svgShape"
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1651.2 539.66 1637.94 546.29 1637.94 533.02 1651.2 526.39 1651.2 539.66",
    className: "colorffbe2e svgShape"
  })), _polygon338 || (_polygon338 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1637.94 546.29 1624.67 539.66 1624.67 526.39 1637.94 533.02 1637.94 546.29",
    className: "colore69729 svgShape"
  })), _polygon339 || (_polygon339 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1632.47 535.76 1619.2 542.39 1605.94 535.76 1619.2 529.13 1632.47 535.76",
    className: "colorfeeecc svgShape"
  })), _polygon340 || (_polygon340 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1632.47 549.02 1619.2 555.66 1619.2 542.39 1632.47 535.76 1632.47 549.02",
    className: "colorffbe2e svgShape"
  })), _polygon341 || (_polygon341 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1619.2 555.66 1605.94 549.02 1605.94 535.76 1619.2 542.39 1619.2 555.66",
    className: "colore69729 svgShape"
  })), _polygon342 || (_polygon342 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1613.74 545.13 1600.47 551.76 1587.21 545.13 1600.47 538.5 1613.74 545.13",
    className: "colorfeeecc svgShape"
  })), _polygon343 || (_polygon343 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1613.74 558.39 1600.47 565.03 1600.47 551.76 1613.74 545.13 1613.74 558.39",
    className: "colorffbe2e svgShape"
  })), _polygon344 || (_polygon344 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1600.47 565.03 1587.21 558.39 1587.21 545.13 1600.47 551.76 1600.47 565.03",
    className: "colore69729 svgShape"
  })), _polygon345 || (_polygon345 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1595 554.5 1581.74 561.13 1568.47 554.5 1581.74 547.86 1595 554.5",
    className: "colorfeeecc svgShape"
  })), _polygon346 || (_polygon346 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1595 567.76 1581.74 574.39 1581.74 561.13 1595 554.5 1595 567.76",
    className: "colorffbe2e svgShape"
  })), _polygon347 || (_polygon347 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1581.74 574.39 1568.47 567.76 1568.47 554.5 1581.74 561.13 1581.74 574.39",
    className: "colore69729 svgShape"
  })), _polygon348 || (_polygon348 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bl)",
    points: "1651.28 441.2 1581.97 475.86 1512.66 441.2 1581.97 406.54 1651.28 441.2"
  })), _polygon349 || (_polygon349 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bm)",
    points: "1651.28 510.5 1581.97 545.16 1581.97 475.86 1651.28 441.2 1651.28 510.5"
  })), _polygon350 || (_polygon350 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bn)",
    points: "1581.97 545.16 1512.66 510.5 1512.66 441.2 1581.97 475.86 1581.97 545.16"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1596.1,482.92c-4.26,6.4-4.26,13.31,0,15.44s11.18-1.32,15.44-7.72,4.27-13.31,0-15.44S1600.37,476.53,1596.1,482.92Zm25.6,12.8c-4.26,6.4-4.26,13.31,0,15.44s11.18-1.32,15.45-7.72,4.26-13.31,0-15.44S1626,489.32,1621.7,495.72Zm15.45-17.88c4.26-6.4,4.26-13.31,0-15.44s-11.18,1.32-15.45,7.72-4.26,13.31,0,15.44S1632.88,484.23,1637.15,477.84Zm-41.05,30.68c-4.26,6.4-4.26,13.31,0,15.44s11.18-1.32,15.44-7.72,4.27-13.31,0-15.44S1600.37,502.13,1596.1,508.52Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1552.4,475.2c-4.27,2.13-4.27,9.05,0,15.44s11.17,9.86,15.44,7.72,4.26-9,0-15.44S1556.66,473.07,1552.4,475.2ZM1526.8,488c-4.27,2.13-4.27,9,0,15.44s11.17,9.85,15.44,7.72,4.26-9,0-15.44S1531.06,485.87,1526.8,488Zm15.44-2.44c4.26-2.13,4.26-9,0-15.44s-11.18-9.85-15.44-7.72-4.27,9,0,15.44S1538,487.69,1542.24,485.56Zm10.16,15.24c-4.27,2.13-4.27,9.05,0,15.44s11.17,9.86,15.44,7.72,4.26-9,0-15.44S1556.66,498.67,1552.4,500.8Z",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#ffffff",
    opacity: 0.3,
    className: "colorffffff svgShape"
  }), _polygon351 || (_polygon351 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1651.6 408.58 1582.3 443.24 1512.99 408.58 1582.3 373.92 1651.6 408.58",
    className: "colorf5e48c svgShape"
  })), _polygon352 || (_polygon352 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1651.6 421.2 1582.3 455.86 1582.3 443.24 1651.6 408.58 1651.6 421.2",
    className: "colorf5c25b svgShape"
  })), _polygon353 || (_polygon353 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bo)",
    points: "1582.3 455.86 1512.99 421.2 1512.99 408.58 1582.3 443.24 1582.3 455.86"
  })), _polygon354 || (_polygon354 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1651.6 389.69 1582.3 424.35 1512.99 389.69 1582.3 355.02 1651.6 389.69",
    className: "colorf5e48c svgShape"
  })), _polygon355 || (_polygon355 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1651.6 402.3 1582.3 436.96 1582.3 424.35 1651.6 389.69 1651.6 402.3",
    className: "colorf5c25b svgShape"
  })), _polygon356 || (_polygon356 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bp)",
    points: "1582.3 436.96 1512.99 402.3 1512.99 389.69 1582.3 424.35 1582.3 436.96"
  })), _polygon357 || (_polygon357 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1651.6 370.79 1582.3 405.45 1512.99 370.79 1582.3 336.13 1651.6 370.79",
    className: "colorf5e48c svgShape"
  })), _polygon358 || (_polygon358 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1651.6 383.4 1582.3 418.06 1582.3 405.45 1651.6 370.79 1651.6 383.4",
    className: "colorf5c25b svgShape"
  })), _polygon359 || (_polygon359 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bq)",
    points: "1582.3 418.06 1512.99 383.4 1512.99 370.79 1582.3 405.45 1582.3 418.06"
  })), _polygon360 || (_polygon360 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1651.6 351.89 1582.3 386.55 1512.99 351.89 1582.3 317.23 1651.6 351.89",
    className: "colorfeeecc svgShape"
  })), _polygon361 || (_polygon361 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1651.6 364.5 1582.3 399.16 1582.3 386.55 1651.6 351.89 1651.6 364.5",
    className: "colorffbe2e svgShape"
  })), _polygon362 || (_polygon362 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1582.3 399.16 1512.99 364.5 1512.99 351.89 1582.3 386.55 1582.3 399.16",
    className: "colore69729 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "664 1363.88 665.5 1398.54 780.36 1398.54 780.36 1363.88 664 1363.88",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#br)",
    opacity: 0.5
  }), _polygon363 || (_polygon363 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "849.67 1294.57 780.36 1329.23 711.05 1294.57 780.36 1259.91 849.67 1294.57",
    className: "colorfeeecc svgShape"
  })), _polygon364 || (_polygon364 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "849.67 1363.88 780.36 1398.54 780.36 1329.23 849.67 1294.57 849.67 1363.88",
    className: "colorffbe2e svgShape"
  })), _polygon365 || (_polygon365 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "780.36 1398.54 711.05 1363.88 711.05 1294.57 780.36 1329.23 780.36 1398.54",
    className: "colore69729 svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M791.2 1339.26a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.45a.5.5 0 01.67.22.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1339.26zM791.2 1343.2a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.45a.5.5 0 01.67.22.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1343.2zM791.2 1347.14a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1347.14zM791.2 1351.08a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.45a.5.5 0 01.45.89l-6.9 3.45A.46.46 0 01791.2 1351.08zM791.2 1355a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1355zM791.2 1359a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1359zM791.2 1362.9a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1362.9zM791.2 1366.84a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1366.84zM791.2 1370.78a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1370.78zM791.2 1374.72a.5.5 0 01-.22-1l6.9-3.45a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1374.72zM791.2 1378.66a.5.5 0 01-.44-.27.49.49 0 01.22-.67l6.9-3.46a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01791.2 1378.66zM804.34 1332.7a.49.49 0 01-.45-.28.5.5 0 01.22-.67l9.53-4.77a.5.5 0 01.67.23.49.49 0 01-.22.67l-9.53 4.76A.46.46 0 01804.34 1332.7zM804.34 1336.64a.51.51 0 01-.45-.28.5.5 0 01.22-.67l9.53-4.77a.5.5 0 01.67.23.49.49 0 01-.22.67l-9.53 4.76A.46.46 0 01804.34 1336.64zM804.34 1340.58a.49.49 0 01-.45-.28.5.5 0 01.22-.67l6.91-3.45a.49.49 0 01.67.22.5.5 0 01-.23.67l-6.9 3.45A.46.46 0 01804.34 1340.58zM804.34 1344.52a.51.51 0 01-.45-.28.5.5 0 01.22-.67l3-1.48a.5.5 0 11.44.89l-3 1.48A.46.46 0 01804.34 1344.52zM804.34 1348.46a.51.51 0 01-.45-.28.5.5 0 01.22-.67l6.91-3.45a.5.5 0 11.44.89l-6.9 3.45A.46.46 0 01804.34 1348.46zM804.34 1352.4a.51.51 0 01-.45-.28.5.5 0 01.22-.67l3-1.48a.5.5 0 11.44.89l-3 1.48A.46.46 0 01804.34 1352.4zM804.34 1356.34a.51.51 0 01-.45-.28.5.5 0 01.22-.67l3-1.48a.49.49 0 01.67.22.5.5 0 01-.23.67l-3 1.48A.46.46 0 01804.34 1356.34zM804.34 1360.27a.5.5 0 01-.23-.94l12.16-6.08a.5.5 0 01.45.89l-12.16 6.08A.44.44 0 01804.34 1360.27zM804.34 1364.22a.51.51 0 01-.45-.28.5.5 0 01.22-.67l12.16-6.08a.5.5 0 01.67.22.5.5 0 01-.22.67l-12.16 6.08A.46.46 0 01804.34 1364.22zM804.34 1368.15a.5.5 0 01-.23-.94l8.22-4.11a.5.5 0 01.45.89l-8.22 4.11A.44.44 0 01804.34 1368.15zM804.34 1372.09a.5.5 0 01-.23-.94l16.1-8.05a.5.5 0 01.45.89l-16.1 8A.44.44 0 01804.34 1372.09zM816.16 1326.79a.51.51 0 01-.45-.28.5.5 0 01.23-.67l4.27-2.14a.51.51 0 01.67.22.52.52 0 01-.22.68l-4.28 2.13A.46.46 0 01816.16 1326.79zM816.16 1330.73a.51.51 0 01-.45-.28.5.5 0 01.22-.67l4.28-2.14a.5.5 0 01.45.89l-4.28 2.14A.46.46 0 01816.16 1330.73zM813.53 1336a.5.5 0 01-.22-1l10.84-5.42a.5.5 0 01.45.89l-10.84 5.43A.64.64 0 01813.53 1336zM809.59 1341.89a.5.5 0 01-.22-1l9.52-4.76a.5.5 0 11.45.89l-9.52 4.77A.64.64 0 01809.59 1341.89zM813.53 1343.86a.5.5 0 01-.22-.95l10.84-5.42a.5.5 0 01.45.89l-10.84 5.43A.64.64 0 01813.53 1343.86zM809.59 1349.77a.5.5 0 01-.22-1l10.84-5.42a.5.5 0 01.45.89l-10.84 5.43A.64.64 0 01809.59 1349.77zM809.59 1353.71a.5.5 0 01-.22-1l10.84-5.42a.5.5 0 01.45.89l-10.84 5.43A.64.64 0 01809.59 1353.71zM818.78 1353.05a.5.5 0 01-.22-1l6.9-3.45a.5.5 0 01.67.23.49.49 0 01-.22.67L819 1353A.59.59 0 01818.78 1353.05zM818.78 1357a.5.5 0 01-.22-1l6.9-3.45a.5.5 0 01.45.9l-6.9 3.45A.59.59 0 01818.78 1357zM814.84 1362.9a.48.48 0 01-.44-.28.49.49 0 01.22-.67l10.84-5.42a.5.5 0 01.45.9l-10.84 5.42A.59.59 0 01814.84 1362.9zM822.72 1362.9a.48.48 0 01-.44-.28.49.49 0 01.22-.67l3-1.48a.5.5 0 01.45.9l-3 1.48A.59.59 0 01822.72 1362.9zM822.72 1323.5a.5.5 0 01-.22-.94l4.27-2.14a.51.51 0 01.68.22.5.5 0 01-.23.67l-4.27 2.14A.46.46 0 01822.72 1323.5zM822.72 1327.44a.49.49 0 01-.44-.27.5.5 0 01.22-.68l4.27-2.13a.5.5 0 11.45.89l-4.27 2.14A.46.46 0 01822.72 1327.44zM826.66 1329.41a.49.49 0 01-.44-.27.5.5 0 01.22-.68l6.9-3.45a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.46.46 0 01826.66 1329.41zM821.41 1336a.5.5 0 01-.22-1l12.15-6.08a.5.5 0 01.67.23.49.49 0 01-.22.67l-12.16 6.08A.54.54 0 01821.41 1336zM826.66 1337.29a.48.48 0 01-.44-.28.49.49 0 01.22-.67l6.9-3.45a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.59.59 0 01826.66 1337.29zM822.72 1343.2a.48.48 0 01-.44-.28.49.49 0 01.22-.67l6.9-3.45a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.59.59 0 01822.72 1343.2zM822.72 1347.14a.48.48 0 01-.44-.28.49.49 0 01.22-.67l6.9-3.45a.5.5 0 01.67.23.49.49 0 01-.22.67l-6.9 3.45A.59.59 0 01822.72 1347.14zM828 1348.45a.5.5 0 01-.23-.94l6.9-3.46a.51.51 0 01.68.23.51.51 0 01-.23.67l-6.9 3.45A.44.44 0 01828 1348.45zM828 1352.39a.5.5 0 01-.23-.94l6.9-3.46a.51.51 0 01.68.23.51.51 0 01-.23.67l-6.9 3.45A.44.44 0 01828 1352.39zM828 1356.33a.5.5 0 01-.23-.94l4.28-2.14a.5.5 0 11.44.89l-4.27 2.14A.44.44 0 01828 1356.33zM828 1360.27a.5.5 0 01-.23-.94l4.28-2.14a.49.49 0 01.67.22.5.5 0 01-.22.67l-4.28 2.14A.44.44 0 01828 1360.27zM829.29 1320.22a.5.5 0 01-.22-1l9.52-4.76a.5.5 0 11.45.89l-9.52 4.77A.64.64 0 01829.29 1320.22zM829.29 1324.16a.5.5 0 01-.22-1l9.52-4.76a.5.5 0 11.45.89l-9.52 4.76A.49.49 0 01829.29 1324.16zM835.86 1324.81a.5.5 0 01-.23-.94l3-1.48a.5.5 0 11.45.89l-3 1.48A.44.44 0 01835.86 1324.81zM835.86 1328.75a.5.5 0 01-.23-.94l3-1.49a.51.51 0 01.68.23.5.5 0 01-.23.67l-3 1.48A.44.44 0 01835.86 1328.75zM835.86 1332.69a.5.5 0 01-.23-.94l3-1.48a.5.5 0 11.45.89l-3 1.48A.44.44 0 01835.86 1332.69zM831.92 1338.6a.5.5 0 01-.45-.27.5.5 0 01.22-.67l6.91-3.46a.51.51 0 01.67.23.5.5 0 01-.23.67l-6.9 3.45A.44.44 0 01831.92 1338.6zM831.92 1342.54a.5.5 0 01-.45-.27.5.5 0 01.22-.67l6.9-3.46a.51.51 0 01.68.23.51.51 0 01-.23.67l-6.9 3.45A.44.44 0 01831.92 1342.54zM837.17 1343.86a.52.52 0 01-.45-.28.5.5 0 01.23-.67l1.65-.83a.5.5 0 11.44.9l-1.65.82A.43.43 0 01837.17 1343.86zM837.17 1347.8a.52.52 0 01-.45-.28.5.5 0 01.23-.67l1.65-.83a.5.5 0 11.44.9l-1.65.82A.43.43 0 01837.17 1347.8zM834.54 1353.05a.48.48 0 01-.44-.28.49.49 0 01.22-.67l4.27-2.14a.51.51 0 01.68.23.51.51 0 01-.23.67l-4.27 2.14A.64.64 0 01834.54 1353.05zM834.54 1357a.48.48 0 01-.44-.28.49.49 0 01.22-.67l4.27-2.14a.51.51 0 01.68.23.51.51 0 01-.23.67l-4.27 2.14A.64.64 0 01834.54 1357z",
    className: "colorffffff svgShape"
  })), _polygon366 || (_polygon366 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bs)",
    points: "770.63 1243.38 740.78 1258.31 710.94 1243.38 740.78 1228.45 770.63 1243.38"
  })), _polygon367 || (_polygon367 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bt)",
    points: "770.63 1273.23 740.78 1288.15 740.78 1258.31 770.63 1243.38 770.63 1273.23"
  })), _polygon368 || (_polygon368 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bu)",
    points: "740.78 1288.15 710.94 1273.23 710.94 1243.38 740.78 1258.31 740.78 1288.15"
  })), _polygon369 || (_polygon369 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bv)",
    points: "852.36 1243.38 822.51 1258.31 792.66 1243.38 822.51 1228.45 852.36 1243.38"
  })), _polygon370 || (_polygon370 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bw)",
    points: "852.36 1273.23 822.51 1288.15 822.51 1258.31 852.36 1243.38 852.36 1273.23"
  })), _polygon371 || (_polygon371 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bx)",
    points: "822.51 1288.15 792.66 1273.23 792.66 1243.38 822.51 1258.31 822.51 1288.15"
  })), _polygon372 || (_polygon372 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#by)",
    points: "810.2 1264.46 780.36 1279.39 750.51 1264.46 780.36 1249.54 810.2 1264.46"
  })), _polygon373 || (_polygon373 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bz)",
    points: "810.2 1294.31 780.36 1309.23 780.36 1279.39 810.2 1264.46 810.2 1294.31"
  })), _polygon374 || (_polygon374 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bA)",
    points: "780.36 1309.23 750.51 1294.31 750.51 1264.46 780.36 1279.39 780.36 1309.23"
  })), _polygon375 || (_polygon375 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bB)",
    points: "810.2 1180.49 780.36 1195.42 750.51 1180.49 780.36 1165.57 810.2 1180.49"
  })), _polygon376 || (_polygon376 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bC)",
    points: "810.2 1210.34 780.36 1225.27 780.36 1195.42 810.2 1180.49 810.2 1210.34"
  })), _polygon377 || (_polygon377 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bD)",
    points: "780.36 1225.27 750.51 1210.34 750.51 1180.49 780.36 1195.42 780.36 1225.27"
  })), _polygon378 || (_polygon378 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bE)",
    points: "852.36 1201.4 822.51 1216.33 792.66 1201.4 822.51 1186.47 852.36 1201.4"
  })), _polygon379 || (_polygon379 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bF)",
    points: "852.36 1231.25 822.51 1246.17 822.51 1216.33 852.36 1201.4 852.36 1231.25"
  })), _polygon380 || (_polygon380 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bG)",
    points: "822.51 1246.17 792.66 1231.25 792.66 1201.4 822.51 1216.33 822.51 1246.17"
  })), _polygon381 || (_polygon381 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bH)",
    points: "770.63 1201.4 740.78 1216.33 710.94 1201.4 740.78 1186.47 770.63 1201.4"
  })), _polygon382 || (_polygon382 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bI)",
    points: "770.63 1231.25 740.78 1246.17 740.78 1216.33 770.63 1201.4 770.63 1231.25"
  })), _polygon383 || (_polygon383 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bJ)",
    points: "740.78 1246.17 710.94 1231.25 710.94 1201.4 740.78 1216.33 740.78 1246.17"
  })), _polygon384 || (_polygon384 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bK)",
    points: "810.2 1222.48 780.36 1237.41 750.51 1222.48 780.36 1207.56 810.2 1222.48"
  })), _polygon385 || (_polygon385 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bL)",
    points: "810.2 1252.33 780.36 1267.26 780.36 1237.41 810.2 1222.48 810.2 1252.33"
  })), _polygon386 || (_polygon386 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bM)",
    points: "780.36 1267.26 750.51 1252.33 750.51 1222.48 780.36 1237.41 780.36 1267.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "574.69 1408.55 576.2 1443.21 691.05 1443.21 691.05 1408.55 574.69 1408.55",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#bN)",
    opacity: 0.5
  }), _polygon387 || (_polygon387 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "760.36 1339.24 691.05 1373.9 621.74 1339.24 691.05 1304.58 760.36 1339.24",
    className: "colorf5e48c svgShape"
  })), _polygon388 || (_polygon388 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "760.36 1408.54 691.05 1443.21 691.05 1373.9 760.36 1339.24 760.36 1408.54",
    className: "colorffbe2e svgShape"
  })), _polygon389 || (_polygon389 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "691.05 1443.21 621.74 1408.54 621.74 1339.24 691.05 1373.9 691.05 1443.21",
    className: "colore69729 svgShape"
  })), _polygon390 || (_polygon390 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bO)",
    points: "691.05 1332.19 651.42 1354.28 691.05 1412.96 730.68 1354.28 691.05 1332.19"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bP)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "716.38 1356.69 691.05 1369.36 665.72 1356.69 691.05 1344.02 716.38 1356.69",
    className: "colorf5e48c svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bQ)",
    points: "716.38 1382.02 691.05 1394.69 691.05 1369.36 716.38 1356.69 716.38 1382.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bR)",
    points: "691.05 1394.69 665.72 1382.02 665.72 1356.69 691.05 1369.36 691.05 1394.69"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "1765.35 1432.34 1766.86 1467 1881.71 1467 1881.71 1432.34 1765.35 1432.34",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#bS)",
    opacity: 0.5
  }), _polygon391 || (_polygon391 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1951.02 1363.03 1881.71 1397.69 1812.4 1363.03 1881.71 1328.37 1951.02 1363.03",
    className: "colorf5e48c svgShape"
  })), _polygon392 || (_polygon392 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1951.02 1432.34 1881.71 1467 1881.71 1397.69 1951.02 1363.03 1951.02 1432.34",
    className: "colorffbe2e svgShape"
  })), _polygon393 || (_polygon393 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1881.71 1467 1812.4 1432.34 1812.4 1363.03 1881.71 1397.69 1881.71 1467",
    className: "colore69729 svgShape"
  })), _polygon394 || (_polygon394 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bT)",
    points: "1881.71 1355.98 1842.08 1378.07 1881.71 1436.75 1921.34 1378.07 1881.71 1355.98"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bU)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1907.05 1380.48 1881.71 1393.15 1856.38 1380.48 1881.71 1367.81 1907.05 1380.48",
    className: "colorf5e48c svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bV)",
    points: "1907.05 1405.82 1881.71 1418.48 1881.71 1393.15 1907.05 1380.48 1907.05 1405.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bW)",
    points: "1881.71 1418.48 1856.38 1405.82 1856.38 1380.48 1881.71 1393.15 1881.71 1418.48"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M1603.11,1034.94l13.9,7.45-10.61,17.07v49c0,6.65-5,14.73-11.22,18l-45.74,24.52-10.61,17.06-13.9-7.45c-2-1.08-3.29-3.42-3.29-6.74v-66.82c0-6.64,5-14.72,11.22-18l62.32-33.41C1598.28,1034,1601.08,1033.85,1603.11,1034.94Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "M1609.08,1134l-62.32,33.4c-6.2,3.33-11.22.63-11.22-6v-66.82c0-6.64,5-14.72,11.22-18l62.32-33.41c6.2-3.32,11.22-.63,11.22,6V1116C1620.3,1122.6,1615.28,1130.68,1609.08,1134Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1549.52,1106.28V1128c0,6.32,4.78,8.88,10.68,5.72l10.23-5.49,0,13.54,11.7-19.83,13.47-7.22c5.9-3.16,10.68-10.85,10.68-17.17v-21.72c0-6.32-4.78-8.88-10.68-5.72l-35.44,19C1554.3,1092.27,1549.52,1100,1549.52,1106.28Zm11.57,12a4.3,4.3,0,0,1,2.12-3.41l29.42-15.77c1.17-.63,2.12-.12,2.12,1.14a4.3,4.3,0,0,1-2.12,3.41l-29.42,15.77C1562,1120.07,1561.09,1119.56,1561.09,1118.3Zm0-8.52a4.31,4.31,0,0,1,2.12-3.41l29.42-15.76c1.17-.63,2.12-.12,2.12,1.13a4.32,4.32,0,0,1-2.12,3.42l-29.42,15.76C1562,1111.55,1561.09,1111,1561.09,1109.78Zm0-8.51a4.3,4.3,0,0,1,2.12-3.41l29.42-15.77c1.17-.63,2.12-.12,2.12,1.14a4.31,4.31,0,0,1-2.12,3.41l-29.42,15.77C1562,1103,1561.09,1102.52,1561.09,1101.27Z",
    className: "colorffffff svgShape"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "M1962.49,793.25l-13.9,7.45,10.61,17.07v49c0,6.64,5,14.72,11.22,18l45.75,24.53,10.61,17.06,13.9-7.45c2-1.09,3.28-3.42,3.28-6.74V845.43c0-6.64-5-14.72-11.23-18L1970.42,794C1967.33,792.32,1964.52,792.16,1962.49,793.25Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M1956.52,892.31l62.32,33.4c6.2,3.32,11.23.63,11.23-6V852.88c0-6.64-5-14.72-11.22-18l-62.32-33.41c-6.2-3.32-11.23-.63-11.23,6v66.81C1945.3,880.9,1950.33,889,1956.52,892.31Z",
    className: "colore69729 svgShape"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1987.68,896.52c-4.55-2.44-8.25-8.39-8.25-13.27s3.7-6.86,8.25-4.42,8.25,8.39,8.25,13.27S1992.23,899,1987.68,896.52Zm13.41-15.35a7.22,7.22,0,0,1-2.62-2.57A29.88,29.88,0,0,0,1987.68,868c-4.07-2.18-7.9-2.54-10.79-1a2.77,2.77,0,0,1-2.61-.24,7.22,7.22,0,0,1-2.62-2.57,6.57,6.57,0,0,1-1.08-3.38,2.37,2.37,0,0,1,1.08-2.23c4.28-2.29,10-1.77,16,1.48s11.75,8.82,16,15.7c1.44,2.33,1.44,4.84,0,5.61a2.74,2.74,0,0,1-2.61-.24Zm-35-27.47a7.22,7.22,0,0,1-2.62-2.57,6.57,6.57,0,0,1-1.08-3.38,2.37,2.37,0,0,1,1.08-2.23c6.46-3.46,15-2.67,24.17,2.22s17.72,13.31,24.17,23.69c1.45,2.32,1.45,4.84,0,5.61a2.74,2.74,0,0,1-2.61-.24,7.26,7.26,0,0,1-2.62-2.56c-5.06-8.13-11.78-14.73-18.94-18.56s-13.88-4.46-18.93-1.74A2.79,2.79,0,0,1,1966.13,853.7Zm51.25,18.74a7.27,7.27,0,0,1-2.61-2.57c-7.24-11.63-16.85-21.06-27.09-26.54s-19.85-6.37-27.08-2.5a2.76,2.76,0,0,1-2.62-.24,7.16,7.16,0,0,1-2.61-2.56c-1.45-2.32-1.45-4.84,0-5.61,8.62-4.63,20.1-3.57,32.31,3s23.69,17.8,32.32,31.68a6.57,6.57,0,0,1,1.08,3.38,2.37,2.37,0,0,1-1.08,2.23A2.79,2.79,0,0,1,2017.38,872.44Z",
    className: "colorffffff svgShape"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ca)",
    d: "M1241,425.62l-13.9,7.45,10.61,17.07v49c0,6.65,5,14.73,11.22,18.05l45.75,24.52,10.61,17.07,13.9-7.45c2-1.09,3.29-3.43,3.29-6.75V477.81c0-6.65-5-14.73-11.23-18.05l-62.32-33.41C1245.79,424.69,1243,424.54,1241,425.62Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M1235,524.68l62.32,33.41c6.2,3.32,11.23.63,11.23-6V485.26c0-6.65-5-14.73-11.22-18.05L1235,433.8c-6.2-3.32-11.23-.62-11.23,6v66.81C1223.76,513.28,1228.79,521.36,1235,524.68Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1262.74,496l5.62-20.95a36.48,36.48,0,0,0-5.62-3.76c-12.73-6.82-23-1.29-23,12.35s10.32,30.24,23,37.06,23,1.29,23-12.35a31.82,31.82,0,0,0-.7-6.41Zm12-25.58-.38,1.41-5.62,20.94,22.34,5.95,1.51.4C1290.4,488.5,1283.51,477.42,1274.75,470.37Z",
    className: "colorffffff svgShape"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "M743.05,940.74l-13.9,7.45,10.61,17.06v49c0,6.64,5,14.72,11.22,18l45.75,24.52,10.61,17.07,13.9-7.45c2-1.09,3.28-3.42,3.28-6.75V992.92c0-6.65-5-14.72-11.22-18L751,941.47C747.88,939.81,745.08,939.65,743.05,940.74Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#29d8e6",
    d: "M737.08,1039.79l62.32,33.41c6.2,3.32,11.22.63,11.22-6v-66.81c0-6.64-5-14.72-11.23-18l-62.32-33.4c-6.19-3.32-11.22-.63-11.22,6v66.82C725.86,1028.39,730.89,1036.47,737.08,1039.79Z",
    className: "colore69729 svgShape"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M768.24,977.62c-17.2-9.23-31.19-1.72-31.19,16.72s14,40.94,31.19,50.16,31.2,1.72,31.2-16.72S785.44,986.84,768.24,977.62Zm26.46,45.14-7.23-3.88a67.56,67.56,0,0,0-6.15-25.59C788.73,1001.78,793.93,1012.78,794.7,1022.76Zm-28.77-41v25.62l-12.27-6.58C754.26,988.25,759.46,980.35,765.93,981.72Zm0,30.58v25.62c-6.47-5.57-11.67-19.05-12.27-32.2Zm4.63,28.1v-25.62l12.27,6.58C782.23,1033.86,777,1041.77,770.56,1040.4Zm0-30.58V984.2c6.47,5.57,11.67,19,12.27,32.19Zm-15.39-30.55c-3.51,3.68-5.79,10.3-6.15,19l-7.23-3.88C742.56,985.25,747.76,979.81,755.17,979.27Zm-13.38,20.09,7.23,3.88a67.61,67.61,0,0,0,6.15,25.59C747.76,1020.34,742.56,1009.34,741.79,999.36Zm39.53,43.48c3.51-3.68,5.78-10.29,6.15-19l7.23,3.88C793.93,1036.87,788.73,1042.3,781.32,1042.84Z",
    className: "colorffffff svgShape"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M1548.87,130.79l-13.9,7.45,10.62,17.07v49c0,6.65,5,14.73,11.22,18.05l45.74,24.52L1613.16,264l13.9-7.46c2-1.08,3.29-3.42,3.29-6.74V183c0-6.64-5-14.72-11.22-18l-62.32-33.41C1553.71,129.86,1550.9,129.7,1548.87,130.79Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "M1542.91,229.85l62.32,33.41c6.2,3.32,11.22.62,11.22-6V190.43c0-6.65-5-14.73-11.22-18.05L1542.91,139c-6.2-3.32-11.22-.63-11.22,6V211.8C1531.69,218.45,1536.71,226.53,1542.91,229.85Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1585.22,200.53l3.72-3.32-3.74-6-5,1.33a36.8,36.8,0,0,0-6.94-6.79l-.87-7-5.3-2.84-.87,6.11a13.77,13.77,0,0,0-6.94-.64l-5-6.65-3.74,2,3.72,7.31a11.51,11.51,0,0,0-2.87,5.9l-6.14-2.36v5.68l6.14,4.23a33.61,33.61,0,0,0,2.87,9l-3.72,3.32,3.74,6,5-1.33a36.51,36.51,0,0,0,6.94,6.79l.87,7.06,5.3,2.84.87-6.12a13.89,13.89,0,0,0,6.94.65l5,6.64,3.74-2-3.72-7.3a11.58,11.58,0,0,0,2.87-5.91l6.14,2.36v-5.68l-6.14-4.23A33.84,33.84,0,0,0,1585.22,200.53Zm-8.32,8c-.46,3-2.94,4.34-6,3.21-4.87-1.81-9-8.47-8.26-13.29.46-3,2.94-4.34,6-3.21C1573.51,197,1577.65,203.69,1576.9,208.51Zm25.91-16.18v-2.84l-3.07-2.12a17.21,17.21,0,0,0-1.43-4.49l1.86-1.66-1.88-3-2.47.67a18.89,18.89,0,0,0-3.47-3.4l-.44-3.53-2.65-1.42-.44,3.06a6.88,6.88,0,0,0-3.47-.32l-2.47-3.32-1.88,1,1.86,3.65a5.81,5.81,0,0,0-1.43,3l-3.07-1.17v2.84l3.07,2.11a16.85,16.85,0,0,0,1.43,4.49l-1.86,1.66,1.87,3,2.48-.66a18.52,18.52,0,0,0,3.47,3.39l.44,3.53,2.65,1.42.44-3.06a6.88,6.88,0,0,0,3.47.32l2.47,3.33,1.88-1-1.86-3.65a5.85,5.85,0,0,0,1.43-2.95Zm-8.73-5.14a1.94,1.94,0,0,1-2.6,1.39c-2.68-.74-5-4.53-4.39-7.07a1.94,1.94,0,0,1,2.6-1.39C1592.37,180.87,1594.73,184.66,1594.08,187.19Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1702.72 1148.75 1704.23 1183.4 1819.08 1183.4 1819.08 1148.75 1702.72 1148.75",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#cf)",
    opacity: 0.5
  }), _polygon395 || (_polygon395 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cg)",
    points: "1888.39 1079.44 1819.08 1114.1 1749.78 1079.44 1819.08 1044.78 1888.39 1079.44"
  })), _polygon396 || (_polygon396 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ch)",
    points: "1888.39 1148.74 1819.08 1183.4 1819.08 1114.1 1888.39 1079.44 1888.39 1148.74"
  })), _polygon397 || (_polygon397 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ci)",
    points: "1819.08 1183.4 1749.78 1148.74 1749.78 1079.44 1819.08 1114.1 1819.08 1183.4"
  })), _polygon398 || (_polygon398 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1888.39 1046.52 1819.08 1081.18 1749.78 1046.52 1819.08 1011.86 1888.39 1046.52",
    className: "colorfeeecc svgShape"
  })), _polygon399 || (_polygon399 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1888.39 1061.41 1819.08 1096.07 1819.08 1081.18 1888.39 1046.52 1888.39 1061.41",
    className: "colorffbe2e svgShape"
  })), _polygon400 || (_polygon400 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 1096.07 1749.78 1061.41 1749.78 1046.52 1819.08 1081.18 1819.08 1096.07",
    className: "colore69729 svgShape"
  })), _polygon401 || (_polygon401 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 1076.23 1759.2 1046.28 1759.2 1033.41 1819.08 1063.36 1819.08 1076.23",
    className: "colore69729 svgShape"
  })), _polygon402 || (_polygon402 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1878.96 1046.28 1819.08 1076.23 1819.08 1063.36 1878.96 1033.41 1878.96 1046.28",
    className: "colorffbe2e svgShape"
  })), _polygon403 || (_polygon403 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1888.39 1019.31 1819.08 1053.97 1749.78 1019.31 1819.08 984.65 1888.39 1019.31",
    className: "colorfeeecc svgShape"
  })), _polygon404 || (_polygon404 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1888.39 1034.2 1819.08 1068.87 1819.08 1053.97 1888.39 1019.31 1888.39 1034.2",
    className: "colorffbe2e svgShape"
  })), _polygon405 || (_polygon405 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 1068.87 1749.78 1034.2 1749.78 1019.31 1819.08 1053.97 1819.08 1068.87",
    className: "colore69729 svgShape"
  })), _polygon406 || (_polygon406 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 1049.02 1759.2 1019.07 1759.2 1006.21 1819.08 1036.15 1819.08 1049.02",
    className: "colore69729 svgShape"
  })), _polygon407 || (_polygon407 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1878.96 1019.07 1819.08 1049.02 1819.08 1036.15 1878.96 1006.21 1878.96 1019.07",
    className: "colorffbe2e svgShape"
  })), _polygon408 || (_polygon408 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1888.39 992.1 1819.08 1026.77 1749.78 992.1 1819.08 957.44 1888.39 992.1",
    className: "colorfeeecc svgShape"
  })), _polygon409 || (_polygon409 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1888.39 1007 1819.08 1041.66 1819.08 1026.77 1888.39 992.1 1888.39 1007",
    className: "colorffbe2e svgShape"
  })), _polygon410 || (_polygon410 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 1041.66 1749.78 1007 1749.78 992.1 1819.08 1026.77 1819.08 1041.66",
    className: "colore69729 svgShape"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1819.08,
    cy: 992.1,
    fill: "#ffffff",
    rx: 23.35,
    ry: 11.68,
    className: "colorffffff svgShape"
  })), _polygon411 || (_polygon411 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1888.39 904.77 1819.08 939.43 1749.78 904.77 1819.08 870.11 1888.39 904.77",
    className: "colorfeeecc svgShape"
  })), _polygon412 || (_polygon412 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1888.39 974.08 1819.08 1008.74 1819.08 939.43 1888.39 904.77 1888.39 974.08",
    className: "colorffbe2e svgShape"
  })), _polygon413 || (_polygon413 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 1008.74 1749.78 974.08 1749.78 904.77 1819.08 939.43 1819.08 1008.74",
    className: "colore69729 svgShape"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1760.56,924.32a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l7,3.49a.44.44,0,0,0,.22,0,.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.67.22.49.49,0,0,0,.22.67l7,3.5a.59.59,0,0,0,.22,0,.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.45.89l7,3.49a.46.46,0,0,0,.22.06.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l7,3.49a.44.44,0,0,0,.22.05.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm0,4a.51.51,0,0,0-.67.22.5.5,0,0,0,.22.68l7,3.49a.59.59,0,0,0,.22.05.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.45.89l7,3.5a.59.59,0,0,0,.22.05.5.5,0,0,0,.22-1Zm0,4a.5.5,0,0,0-.45.89l7,3.49a.46.46,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm0,4a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l7,3.49a.44.44,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm0,4a.51.51,0,0,0-.67.22.49.49,0,0,0,.22.67l7,3.5a.59.59,0,0,0,.22,0,.5.5,0,0,0,.22-.95Zm0,4a.5.5,0,0,0-.45.89l7,3.5a.59.59,0,0,0,.22,0,.5.5,0,0,0,.22-.95Zm0,4a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l7,3.49a.46.46,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm22.49-27.5a.54.54,0,0,0,.22,0,.5.5,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-9.65-4.82a.5.5,0,0,0-.67.22.5.5,0,0,0,.22.67Zm0,4a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-9.65-4.82a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67Zm-2.66,2.66a.44.44,0,0,0,.22,0,.5.5,0,0,0,.23-.94l-7-3.5a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67Zm-4,2a.46.46,0,0,0,.22.06.49.49,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-3-1.5a.51.51,0,0,0-.67.22.52.52,0,0,0,.22.68Zm-3,2.49,7,3.5a.59.59,0,0,0,.22.05.49.49,0,0,0,.45-.28.51.51,0,0,0-.23-.67l-7-3.49a.49.49,0,0,0-.67.22A.5.5,0,0,0,1773.4,947.81Zm0,4,3,1.5a.44.44,0,0,0,.22.05.5.5,0,0,0,.45-.27.52.52,0,0,0-.22-.68l-3-1.49a.49.49,0,0,0-.67.22A.5.5,0,0,0,1773.4,951.8Zm0,4,3,1.5a.59.59,0,0,0,.22.05.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-3-1.5a.5.5,0,0,0-.67.23A.51.51,0,0,0,1773.4,955.79Zm12.75,9.24-12.3-6.15a.5.5,0,0,0-.45.89l12.31,6.16a.54.54,0,0,0,.22.05.5.5,0,0,0,.22-1Zm-12.3-2.16a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67l12.31,6.15a.43.43,0,0,0,.22.06.52.52,0,0,0,.45-.28.5.5,0,0,0-.23-.67Zm7.87,9a.54.54,0,0,0,.22.05.5.5,0,0,0,.22-1l-8.31-4.16a.5.5,0,0,0-.45.9Zm-7.87-1.07a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67l16.29,8.14a.46.46,0,0,0,.22.06.51.51,0,0,0,.45-.28.49.49,0,0,0-.22-.67ZM1789.69,940a.44.44,0,0,0,.22,0,.5.5,0,0,0,.23-.95l-4.33-2.16a.51.51,0,0,0-.67.22.52.52,0,0,0,.22.68Zm0,4a.59.59,0,0,0,.22,0,.5.5,0,0,0,.23-.95l-4.33-2.16a.49.49,0,0,0-.67.22.5.5,0,0,0,.22.67Zm4.21,6a.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-11-5.48a.5.5,0,1,0-.45.89l11,5.49A.59.59,0,0,0,1793.9,950Zm-15.4-4.22a.49.49,0,0,0,.22.67l9.64,4.83a.59.59,0,0,0,.23.05.48.48,0,0,0,.44-.28.49.49,0,0,0-.22-.67l-9.64-4.82A.5.5,0,0,0,1778.5,945.81Zm15.4,12.2a.51.51,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-11-5.49a.52.52,0,0,0-.68.22.51.51,0,0,0,.23.68l11,5.48A.46.46,0,0,0,1793.9,958Zm-3.76,1-11-5.49a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l11,5.49a.59.59,0,0,0,.22,0,.5.5,0,0,0,.23-1Zm-.23,4.94a.51.51,0,0,0,.45-.28.49.49,0,0,0-.22-.67l-11-5.49a.5.5,0,0,0-.45.9l11,5.48A.46.46,0,0,0,1789.91,964Zm-1.44,2.2a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67l7,3.49a.44.44,0,0,0,.22,0,.51.51,0,0,0,.45-.27.5.5,0,0,0-.22-.67Zm0,4a.5.5,0,0,0-.67.22.5.5,0,0,0,.22.67l7,3.5a.59.59,0,0,0,.22,0,.5.5,0,0,0,.45-.28.51.51,0,0,0-.22-.67Zm-4,2a.5.5,0,0,0-.44.9l11,5.48a.46.46,0,0,0,.22.06.5.5,0,0,0,.22-1Zm8,8a.5.5,0,0,0-.45.89l3,1.5a.44.44,0,0,0,.22.05.51.51,0,0,0,.45-.27.5.5,0,0,0-.23-.67Zm3.88-36.82a.46.46,0,0,0,.22.06.51.51,0,0,0,.45-.28.5.5,0,0,0-.23-.67l-4.32-2.17a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67Zm0,4a.44.44,0,0,0,.22,0,.49.49,0,0,0,.22-.94l-4.32-2.17a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67Zm7.09,6.42-7-3.5a.51.51,0,0,0-.68.23.51.51,0,0,0,.23.67l7,3.49a.46.46,0,0,0,.23,0,.5.5,0,0,0,.22-.94Zm0,4-12.3-6.15a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l12.3,6.15a.59.59,0,0,0,.23,0,.48.48,0,0,0,.44-.28A.49.49,0,0,0,1803.43,957.72Zm-.22,4.94a.48.48,0,0,0,.44-.28.49.49,0,0,0-.22-.67l-7-3.49a.5.5,0,1,0-.45.89l7,3.5A.59.59,0,0,0,1803.21,962.66Zm-10.75-2.45a.5.5,0,0,0-.67.23.49.49,0,0,0,.22.67l7,3.49a.42.42,0,0,0,.22,0,.5.5,0,0,0,.22-.95Zm6.76,8.43a.5.5,0,0,0,.22-.95l-7-3.49a.51.51,0,0,0-.67.22.49.49,0,0,0,.22.67l7,3.5A.54.54,0,0,0,1799.22,968.64Zm5.09,6.59a.46.46,0,0,0,.23.06.5.5,0,0,0,.44-.28.49.49,0,0,0-.22-.67l-7-3.5a.5.5,0,0,0-.44.9Zm0,4a.46.46,0,0,0,.23,0,.5.5,0,0,0,.22-.94l-7-3.5a.5.5,0,1,0-.44.9Zm-6.54-.4a.51.51,0,0,0-.67.22.5.5,0,0,0,.23.67l4.33,2.17a.54.54,0,0,0,.22,0,.5.5,0,0,0,.22-.95Zm0,4a.49.49,0,0,0-.67.22.5.5,0,0,0,.23.67l4.33,2.16a.43.43,0,0,0,.22.06.5.5,0,0,0,.22-.95Zm10.53-33.5a.46.46,0,0,0,.22.06.49.49,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-9.65-4.82a.49.49,0,0,0-.67.22.5.5,0,0,0,.23.67Zm-9.2-1.72a.49.49,0,0,0-.67.22.5.5,0,0,0,.23.67l9.64,4.82a.44.44,0,0,0,.22.05.5.5,0,0,0,.23-.94Zm9.2,9.7a.44.44,0,0,0,.22.05.5.5,0,0,0,.45-.27.52.52,0,0,0-.22-.68l-3-1.49a.5.5,0,0,0-.45.89Zm-3,2.49,3,1.5a.59.59,0,0,0,.22.05.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-3-1.5a.5.5,0,0,0-.67.23A.49.49,0,0,0,1805.3,959.78Zm0,4,3,1.49a.46.46,0,0,0,.22.06.49.49,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-3-1.5a.51.51,0,0,0-.67.22A.5.5,0,0,0,1805.3,963.77Zm-3.54,1.09a.5.5,0,0,0-.45.9l7,3.49a.44.44,0,0,0,.22,0,.5.5,0,0,0,.23-.94Zm0,4a.51.51,0,0,0-.67.22.52.52,0,0,0,.22.68l7,3.49a.59.59,0,0,0,.22,0,.5.5,0,0,0,.45-.27.52.52,0,0,0-.22-.68Zm6.54,8.38a.59.59,0,0,0,.22,0,.49.49,0,0,0,.45-.28.51.51,0,0,0-.22-.67l-1.67-.83a.5.5,0,0,0-.67.22.49.49,0,0,0,.22.67Zm-1.67,3.15,1.67.83a.46.46,0,0,0,.22.06.51.51,0,0,0,.45-.28.5.5,0,0,0-.22-.67l-1.67-.84a.5.5,0,0,0-.67.23A.49.49,0,0,0,1806.63,980.38Zm-2.21,1.76a.5.5,0,0,0-.67.23.51.51,0,0,0,.22.67l4.33,2.16a.44.44,0,0,0,.22,0,.5.5,0,0,0,.23-.94Zm0,4a.5.5,0,0,0-.45.89l4.33,2.17a.44.44,0,0,0,.22,0,.5.5,0,0,0,.45-.27.52.52,0,0,0-.22-.68Z",
    className: "colorffffff svgShape"
  })), _polygon414 || (_polygon414 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1888.39 817.44 1819.08 852.1 1749.78 817.44 1819.08 782.78 1888.39 817.44",
    className: "colorf5e48c svgShape"
  })), _polygon415 || (_polygon415 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1888.39 886.75 1819.08 921.41 1819.08 852.1 1888.39 817.44 1888.39 886.75",
    className: "colorf5c25b svgShape"
  })), _polygon416 || (_polygon416 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cj)",
    points: "1819.08 921.41 1749.78 886.75 1749.78 817.44 1819.08 852.1 1819.08 921.41"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1831.92,853.42c-2.82,1.41-5.09,4.83-5.09,7.64s2.27,4,5.09,2.55,5.09-4.83,5.09-7.64S1834.73,852,1831.92,853.42Zm0,14.55c-2.82,1.41-5.09,4.83-5.09,7.64s2.27,3.95,5.09,2.54,5.09-4.82,5.09-7.63S1834.73,866.56,1831.92,868Zm0,29.09c-2.82,1.41-5.09,4.83-5.09,7.64s2.27,3.95,5.09,2.55,5.09-4.83,5.09-7.64S1834.73,895.66,1831.92,897.06Zm0-14.54c-2.82,1.4-5.09,4.82-5.09,7.63s2.27,4,5.09,2.55,5.09-4.83,5.09-7.64S1834.73,881.11,1831.92,882.52Zm14.54-21.82c-2.81,1.4-5.09,4.82-5.09,7.63s2.28,3.95,5.09,2.55,5.09-4.83,5.09-7.64S1849.28,859.29,1846.46,860.7Zm0,29.09c-2.81,1.41-5.09,4.82-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.64S1849.28,888.38,1846.46,889.79Zm0-14.55c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.63S1849.28,873.84,1846.46,875.24Zm0-29.09c-2.81,1.4-5.09,4.82-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.64S1849.28,844.74,1846.46,846.15Zm14.55-7.28c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.55,5.09-4.83,5.09-7.64S1863.82,837.47,1861,838.87Zm0,14.55c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.63S1863.82,852,1861,853.42Zm0,29.09c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.55,5.09-4.83,5.09-7.64S1863.82,881.11,1861,882.51Zm0-14.54c-2.81,1.4-5.09,4.82-5.09,7.63s2.28,4,5.09,2.55,5.09-4.83,5.09-7.64S1863.82,866.56,1861,868Zm14.55-21.83c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,4,5.09,2.55,5.09-4.83,5.09-7.64S1878.37,844.74,1875.56,846.14Zm0-4.36c2.81-1.41,5.09-4.83,5.09-7.64s-2.28-3.95-5.09-2.54-5.09,4.82-5.09,7.64S1872.75,843.19,1875.56,841.78Zm0,18.91c-2.81,1.41-5.09,4.83-5.09,7.64s2.28,3.95,5.09,2.54,5.09-4.82,5.09-7.63S1878.37,859.29,1875.56,860.69Zm0,14.55c-2.81,1.41-5.09,4.82-5.09,7.64s2.28,4,5.09,2.54,5.09-4.82,5.09-7.64S1878.37,873.83,1875.56,875.24Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1801.16,856c0,2.81,2.28,6.23,5.09,7.64s5.09.26,5.09-2.55-2.28-6.23-5.09-7.64S1801.16,853.16,1801.16,856Zm0,14.55c0,2.81,2.28,6.23,5.09,7.63s5.09.27,5.09-2.54-2.28-6.23-5.09-7.64S1801.16,867.7,1801.16,870.52Zm0,29.09c0,2.81,2.28,6.23,5.09,7.64s5.09.26,5.09-2.55-2.28-6.23-5.09-7.64S1801.16,896.8,1801.16,899.61Zm0-14.55c0,2.81,2.28,6.23,5.09,7.64s5.09.27,5.09-2.55-2.28-6.23-5.09-7.63S1801.16,882.25,1801.16,885.06Zm-14.55-21.82c0,2.81,2.28,6.23,5.09,7.64s5.09.26,5.09-2.55-2.28-6.23-5.09-7.63S1786.61,860.43,1786.61,863.24Zm0,29.09c0,2.82,2.28,6.24,5.09,7.64s5.09.27,5.09-2.54-2.28-6.23-5.09-7.64S1786.61,889.52,1786.61,892.33Zm0-14.54c0,2.81,2.28,6.23,5.09,7.63s5.09.27,5.09-2.54-2.28-6.23-5.09-7.64S1786.61,875,1786.61,877.79Zm0-29.1c0,2.82,2.28,6.23,5.09,7.64s5.09.27,5.09-2.54-2.28-6.24-5.09-7.64S1786.61,845.88,1786.61,848.69Zm-14.55-7.27c0,2.81,2.28,6.23,5.1,7.64s5.09.26,5.09-2.55-2.28-6.23-5.09-7.64S1772.06,838.61,1772.06,841.42Zm0,14.55c0,2.81,2.28,6.23,5.1,7.63s5.09.27,5.09-2.54-2.28-6.23-5.09-7.64S1772.06,853.15,1772.06,856Zm0,29.09c0,2.81,2.28,6.23,5.1,7.64s5.09.26,5.09-2.55-2.28-6.23-5.09-7.64S1772.06,882.25,1772.06,885.06Zm0-14.55c0,2.81,2.28,6.23,5.1,7.64s5.09.27,5.09-2.55-2.28-6.23-5.09-7.63S1772.06,867.7,1772.06,870.51Zm-14.54-21.82c0,2.81,2.28,6.23,5.09,7.64s5.09.26,5.09-2.55-2.28-6.23-5.09-7.64S1757.52,845.88,1757.52,848.69Zm10.18-9.45c0-2.82-2.28-6.24-5.09-7.64s-5.09-.27-5.09,2.54,2.28,6.23,5.09,7.64S1767.7,842.05,1767.7,839.24Zm-10.18,24c0,2.81,2.28,6.23,5.09,7.63s5.09.27,5.09-2.54-2.28-6.23-5.09-7.64S1757.52,860.43,1757.52,863.24Zm0,14.54c0,2.82,2.28,6.24,5.09,7.64s5.09.27,5.09-2.54-2.28-6.23-5.09-7.64S1757.52,875,1757.52,877.78Z",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#ffffff",
    opacity: 0.3,
    className: "colorffffff svgShape"
  }), _polygon417 || (_polygon417 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1889.79 783.87 1819.08 819.23 1748.37 783.87 1819.08 748.51 1889.79 783.87",
    className: "colorf5e48c svgShape"
  })), _polygon418 || (_polygon418 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1889.79 796.74 1819.08 832.1 1819.08 819.23 1889.79 783.87 1889.79 796.74",
    className: "colore69729 svgShape"
  })), _polygon419 || (_polygon419 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1819.08 832.1 1748.37 796.74 1748.37 783.87 1819.08 819.23 1819.08 832.1",
    className: "colore69729 svgShape"
  })), _polygon420 || (_polygon420 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1944.87 704.76 1906.39 724 1867.91 704.76 1906.39 685.51 1944.87 704.76",
    className: "colorf5e48c svgShape"
  })), _polygon421 || (_polygon421 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1944.87 711.76 1906.39 731.01 1906.39 724 1944.87 704.76 1944.87 711.76",
    className: "colorf5c25b svgShape"
  })), _polygon422 || (_polygon422 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ck)",
    points: "1906.39 731.01 1867.91 711.76 1867.91 704.76 1906.39 724 1906.39 731.01"
  })), _polygon423 || (_polygon423 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1906.39 745.31 1835.68 780.67 1764.97 745.31 1835.68 709.95 1906.39 745.31",
    className: "colorf5e48c svgShape"
  })), _polygon424 || (_polygon424 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1906.39 758.18 1835.68 793.54 1835.68 780.67 1906.39 745.31 1906.39 758.18",
    className: "colorf5c25b svgShape"
  })), _polygon425 || (_polygon425 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cl)",
    points: "1835.68 793.54 1764.97 758.18 1764.97 745.31 1835.68 780.67 1835.68 793.54"
  })), _polygon426 || (_polygon426 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1866.69 672.9 1795.98 708.26 1725.27 672.9 1795.98 637.54 1866.69 672.9",
    className: "colorf5e48c svgShape"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1795.98,
    cy: 672.9,
    fill: "#ffffff",
    rx: 23.35,
    ry: 11.68,
    className: "colorffffff svgShape"
  })), _polygon427 || (_polygon427 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1866.69 685.77 1795.98 721.13 1795.98 708.26 1866.69 672.9 1866.69 685.77",
    className: "colore69729 svgShape"
  })), _polygon428 || (_polygon428 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1795.98 721.13 1725.27 685.77 1725.27 672.9 1795.98 708.26 1795.98 721.13",
    className: "colore69729 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1786.54 1188.26 1788.06 1222.92 1902.91 1222.92 1902.91 1188.26 1786.54 1188.26",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#cm)",
    opacity: 0.5
  }), _polygon429 || (_polygon429 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1972.21 1118.95 1902.91 1153.61 1833.6 1118.95 1902.91 1084.29 1972.21 1118.95",
    className: "colorfeeecc svgShape"
  })), _polygon430 || (_polygon430 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2ef0ff",
    points: "1972.21 1188.26 1902.91 1222.92 1902.91 1153.61 1972.21 1118.95 1972.21 1188.26",
    className: "colorffbe2e svgShape"
  })), _polygon431 || (_polygon431 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1954.89 1179.59 1920.23 1196.92 1920.23 1162.27 1954.89 1144.94 1954.89 1179.59",
    className: "colorf5e48c svgShape"
  })), _polygon432 || (_polygon432 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1902.91 1222.92 1833.6 1188.26 1833.6 1118.95 1902.91 1153.61 1902.91 1222.92",
    className: "colore69729 svgShape"
  })), _polygon433 || (_polygon433 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cn)",
    points: "1954.89 1179.59 1954.89 1144.94 1920.24 1162.27 1954.89 1179.59"
  })), _polygon434 || (_polygon434 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1850.93 1179.59 1885.58 1196.92 1885.58 1162.27 1850.93 1144.94 1850.93 1179.59",
    className: "colorf5e48c svgShape"
  })), _polygon435 || (_polygon435 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1850.93 1179.59 1850.93 1144.94 1885.57 1162.27 1850.93 1179.59",
    className: "colorf5c25b svgShape"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1946.22 1157.97 1928.93 1166.62 1911.64 1157.97 1928.93 1149.32 1946.22 1157.97",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1946.22 1175.26 1928.93 1183.91 1928.93 1166.62 1946.22 1157.97 1946.22 1175.26",
    className: "colore69729 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1928.93 1183.91 1911.64 1175.26 1911.64 1157.97 1928.93 1166.62 1928.93 1183.91",
    className: "colore69729 svgShape"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccfafe",
    points: "1859.59 1157.97 1876.88 1166.62 1894.17 1157.97 1876.88 1149.32 1859.59 1157.97",
    className: "colorfeeecc svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1859.59 1175.26 1876.88 1183.91 1876.88 1166.62 1859.59 1157.97 1859.59 1175.26",
    className: "colore69729 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29d8e6",
    points: "1876.88 1183.91 1894.17 1175.26 1894.17 1157.97 1876.88 1166.62 1876.88 1183.91",
    className: "colore69729 svgShape"
  }))), _polygon436 || (_polygon436 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8cedf5",
    points: "1972.21 1029.44 1902.91 1064.11 1833.6 1029.44 1902.91 994.78 1972.21 1029.44",
    className: "colorf5e48c svgShape"
  })), _polygon437 || (_polygon437 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5beaf5",
    points: "1972.21 1098.75 1902.91 1133.41 1902.91 1064.11 1972.21 1029.44 1972.21 1098.75",
    className: "colorf5c25b svgShape"
  })), _polygon438 || (_polygon438 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cq)",
    points: "1902.91 1133.41 1833.6 1098.75 1833.6 1029.44 1902.91 1064.11 1902.91 1133.41"
  })), _polygon439 || (_polygon439 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cr)",
    points: "1893.49 978.65 1864.19 993.31 1834.89 978.65 1864.19 964 1893.49 978.65"
  })), _polygon440 || (_polygon440 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cs)",
    points: "1893.49 1007.95 1864.19 1022.61 1864.19 993.31 1893.49 978.65 1893.49 1007.95"
  })), _polygon441 || (_polygon441 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ct)",
    points: "1864.19 1022.61 1834.89 1007.95 1834.89 978.65 1864.19 993.31 1864.19 1022.61"
  })), _polygon442 || (_polygon442 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cu)",
    points: "1973.73 978.65 1944.43 993.31 1915.13 978.65 1944.43 964 1973.73 978.65"
  })), _polygon443 || (_polygon443 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cv)",
    points: "1973.73 1007.95 1944.43 1022.61 1944.43 993.31 1973.73 978.65 1973.73 1007.95"
  })), _polygon444 || (_polygon444 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cw)",
    points: "1944.43 1022.61 1915.13 1007.95 1915.13 978.65 1944.43 993.31 1944.43 1022.61"
  })), _polygon445 || (_polygon445 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cx)",
    points: "1932.34 999.35 1903.04 1014 1873.74 999.35 1903.04 984.69 1932.34 999.35"
  })), _polygon446 || (_polygon446 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cy)",
    points: "1932.34 1028.65 1903.04 1043.3 1903.04 1014 1932.34 999.35 1932.34 1028.65"
  })), _polygon447 || (_polygon447 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cz)",
    points: "1903.04 1043.3 1873.74 1028.65 1873.74 999.35 1903.04 1014 1903.04 1043.3"
  })), _polygon448 || (_polygon448 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cA)",
    points: "1932.34 916.91 1903.04 931.57 1873.74 916.91 1903.04 902.26 1932.34 916.91"
  })), _polygon449 || (_polygon449 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cB)",
    points: "1932.34 946.21 1903.04 960.87 1903.04 931.57 1932.34 916.91 1932.34 946.21"
  })), _polygon450 || (_polygon450 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cC)",
    points: "1903.04 960.87 1873.74 946.21 1873.74 916.91 1903.04 931.57 1903.04 960.87"
  })), _polygon451 || (_polygon451 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cD)",
    points: "1893.49 937.44 1864.19 952.09 1834.89 937.44 1864.19 922.78 1893.49 937.44"
  })), _polygon452 || (_polygon452 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cE)",
    points: "1893.49 966.74 1864.19 981.39 1864.19 952.09 1893.49 937.44 1893.49 966.74"
  })), _polygon453 || (_polygon453 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cF)",
    points: "1864.19 981.39 1834.89 966.74 1834.89 937.44 1864.19 952.09 1864.19 981.39"
  })), _polygon454 || (_polygon454 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cG)",
    points: "1932.34 958.13 1903.04 972.79 1873.74 958.13 1903.04 943.48 1932.34 958.13"
  })), _polygon455 || (_polygon455 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cH)",
    points: "1932.34 987.44 1903.04 1002.09 1903.04 972.79 1932.34 958.13 1932.34 987.44"
  })), _polygon456 || (_polygon456 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cI)",
    points: "1903.04 1002.09 1873.74 987.44 1873.74 958.13 1903.04 972.79 1903.04 1002.09"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 178.06,
    height: 37.53,
    x: 825.49,
    y: 1089.44,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#cJ)",
    opacity: 0.5
  }), _polygon457 || (_polygon457 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#b3b3b3",
    points: "1054.97 1048.77 996.81 1019.28 985.4 1025.09 1043.56 1054.58 1054.97 1048.77",
    className: "colorb3b3b3 svgShape"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cK)",
    d: "M1054.91,1080c0,5.74-2.31,12.12-6,17.79a39.49,39.49,0,0,1-14.53,13.49L1003.55,1127l-58.16-29.49,0-11.58,30.8-15.67a17.78,17.78,0,0,0,6.44-6,15.13,15.13,0,0,0,2.69-7.9l.06-31.25,58.16,29.49,11.41-5.81Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL)",
    d: "M1048.87,1097.81c3.73-5.67,6-12,6-17.79l.06-31.25-11.41,5.81-.06,31.25a15.09,15.09,0,0,1-2.69,7.89,17.72,17.72,0,0,1-6.44,6l-30.8,15.67,0,11.58,30.79-15.67A39.49,39.49,0,0,0,1048.87,1097.81Z"
  })), _polygon458 || (_polygon458 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cM)",
    points: "1003.57 1115.39 945.41 1085.9 945.39 1097.48 1003.55 1126.97 1003.57 1115.39"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cN)",
    d: "M912.45,834.72l216.48,109.74c3.86,2,7,6.71,7,10.63v145.54a4.17,4.17,0,0,1-2,3.92l-11.59,5.88-209.92-116c-3.86-1.95-7-6.71-7-10.62L896.05,840.1l11.46-5.81A5.49,5.49,0,0,1,912.45,834.72Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cO)",
    d: "M900.93,840.56,1117.41,950.3c3.85,2,7,6.72,7,10.63v145.54c0,3.92-3.13,5.5-7,3.55L900.93,1000.27c-3.86-1.95-7-6.71-7-10.62V844.1C894,840.19,897.07,838.61,900.93,840.56Z"
  })), _polygon459 || (_polygon459 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cP)",
    points: "1115.17 1099.54 1115.17 958.52 903.16 851.04 903.16 992.06 1115.17 1099.54"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cQ)",
    d: "M1090.67,1053.77l-15,7.41L822.88,921.73l-15,.77,15-7.41,24.34-10.44c4.52-2.23,11.84,1.39,16.36,8.07s11.84,10.29,16.36,8.06l10-4.95c4.52-2.23,11.84,1.38,16.36,8.06l7.29,10.79c4.52,6.68,11.84,10.29,16.36,8.06l28.86-14.22c7.18-3.54,18.82,2.2,26,12.82l28.48,42.13c4.52,6.68,11.85,10.29,16.36,8.06l61-30.43Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#5beaf5",
    d: "M1075.64,1061.18l-267.79-132V922.5l24.34-10.44c4.52-2.22,11.84,1.39,16.36,8.07s11.84,10.29,16.35,8.06l10.06-5c4.51-2.23,11.84,1.39,16.35,8.07l7.3,10.78c4.51,6.68,11.84,10.29,16.35,8.07l28.87-14.23c7.18-3.54,18.82,2.2,26,12.82l28.48,42.13c4.52,6.68,11.84,10.29,16.36,8.07l61-30.44Z",
    className: "colorf5c25b svgShape"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cR)",
    d: "M1823.82,555.5a10.9,10.9,0,0,0-1.35.71c-3.45,2.2-5.61,6.6-5.66,12.68a37.11,37.11,0,0,0,5.43,18.47c3.4,5.77,8.11,10.71,13.34,13.44l66.89,35c4.56,2.38,8.7,2.39,11.72.48l15.17-9.62c3-1.91,4.9-5.74,4.94-11a32.35,32.35,0,0,0-4.74-16.1c-3-5-7.07-9.34-11.62-11.72a15.8,15.8,0,0,0-5.19-1.65,57.83,57.83,0,0,0-7.78-22.38c-5-8.51-11.94-15.78-19.65-19.81-6.08-3.18-13.74-4.7-19.85-.82l-10.41,6.6c-4.9-3.78-11.94-6.6-17.41-3.13l-15.18,9.62A10.9,10.9,0,0,1,1823.82,555.5Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cS)",
    d: "M1822.24,587.36a37.11,37.11,0,0,1-5.43-18.47c.09-12.17,8.64-17.59,19.11-12.11a29.53,29.53,0,0,1,7.36,5.58c3.67-11.32,14.33-15.35,26.86-8.8,7.71,4,14.65,11.3,19.66,19.82a57.77,57.77,0,0,1,7.77,22.37,15.85,15.85,0,0,1,5.2,1.65c4.55,2.39,8.66,6.69,11.62,11.73a32.38,32.38,0,0,1,4.74,16.09c-.09,10.6-7.54,15.32-16.66,10.56l-66.89-35C1830.35,598.07,1825.64,593.13,1822.24,587.36Z"
  })), _polygon460 || (_polygon460 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cT)",
    points: "1115.44 1436.55 1112.14 1416.9 1024.64 1404.65 1001.47 1421.3 1001.47 1569.9 1115.44 1569.9 1115.44 1436.55"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cU)",
    d: "M1142.11,1433l-26.67,3.57c-3.61-4.45-9-8.63-16.26-12.24-26.7-13.35-68.69-14.34-97.71-3l-19.6-9.8c39.88-16.68,99.33-15.68,136.8,3.06C1129.45,1420,1137.19,1426.26,1142.11,1433Z"
  })), _polygon461 || (_polygon461 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cV)",
    points: "1001.47 1421.3 981.87 1411.5 981.87 1569.9 1001.47 1569.9 1001.47 1421.3"
  })), _polygon462 || (_polygon462 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cW)",
    points: "1142.11 1432.98 1115.44 1436.55 1115.44 1569.9 1142.11 1569.9 1142.11 1432.98"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56.24,
    height: 119.44,
    x: 1018.76,
    y: 1450.46,
    fill: "url(#cX)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cY)",
    d: "M1027,1440.52c11-5.49,28.79-5.49,39.77,0s11,14.39,0,19.88-28.79,5.5-39.77,0S1016,1446,1027,1440.52Z"
  })), _polygon463 || (_polygon463 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cZ)",
    points: "988.58 1427.75 966.48 1438.05 966.48 1569.9 988.58 1569.9 988.58 1427.75"
  })), _polygon464 || (_polygon464 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#da)",
    points: "1011.93 1498.08 945.39 1450.59 945.39 1569.9 1011.93 1569.9 1011.93 1498.08"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#db)",
    d: "M975.1,1486.36c-37.47-18.74-39.48-48.47-6.12-68.41l19.6,9.8c-22.65,14.51-20.69,35.51,6,48.86a98.56,98.56,0,0,0,24.49,8.13l-7.15,13.34C998.5,1495.62,985.87,1491.75,975.1,1486.36Z"
  })), _polygon465 || (_polygon465 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dc)",
    points: "1019.08 1484.74 1011.93 1498.08 1011.93 1569.9 1019.08 1569.9 1019.08 1484.74"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dd)",
    d: "M1148.33,1450.12a27.11,27.11,0,0,0-1.49-8.34l-26.78,3.59c3.06,11.09-3.84,22.72-20.88,31.24s-40.31,12-62.47,10.45l-7.17,13.39v69.45h118.79Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#de)",
    d: "M1118.67,1486.36c-24.25,12.13-57.72,16.8-89.13,14.09l7.17-13.39c22.16,1.53,45.43-1.93,62.47-10.45s23.94-20.15,20.88-31.24l26.78-3.59C1152.26,1457.49,1142.93,1474.23,1118.67,1486.36Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1680.55 1320.12 1671.89 1315.11 1604.34 1315 1604.34 1327.17 1650.34 1327.17 1680.55 1320.12",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#df)",
    opacity: 0.5
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1682.92 1317.54a2 2 0 00-1.24-1.65l-8.2-2.51a1 1 0 00-1.13.45c-.28.46-.12 1.07-.5 1.35l7.89 5.15c2 .68 3.29.12 3.29-.68zM1654.22 1156.61l-1.65 5.39s18.78 11.08 28.42 15.29l3.49-11.9-28.09-9.33z",
    className: "color5388dc svgShape"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1656.39,1156.06l-19.1-25.12-2.33,1.46c1.18,6.71,10.41,24.16,17.61,29.6Z",
    className: "color5388dc svgShape"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1635,1132.4l-.8-1a3.1,3.1,0,0,1-1.12-3.94l.8-1.7-2.12-3.91.49-1,5.39,6.39,0,4.19Z",
    className: "colorf4acc8 svgShape"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1650.48,1327.16l-10.74-1.44a1,1,0,0,1,0-2l11.1-1.26a1,1,0,0,1,1.09,1.11l-.36,2.7A1,1,0,0,1,1650.48,1327.16Z",
    className: "color5388dc svgShape"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1659.59,1157.76c-.72,1.38,2.27,4.57,5.41,4.3l4.06-1.3,5.34-6.18-1-6.24-8.56-1.89Z",
    className: "colorf4acc8 svgShape"
  })), _polygon466 || (_polygon466 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aceff4",
    points: "1664.63 1161.49 1663.42 1171.47 1671.44 1170.88 1670.35 1158.68 1664.63 1161.49",
    className: "colorf4acc8 svgShape"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1664 1146l1.37 4a4.49 4.49 0 01-.16 3.34l-.49 1.09a4.56 4.56 0 00-.18 3.29l.12.36a4.52 4.52 0 008.07 1.06l1.79-2.73a4.53 4.53 0 00.59-3.65l-.9-3.37a4.54 4.54 0 00-3.13-3.17l-5.65-1.62-2-1zM1666.87 1269.61l13 47.44c.43 1.43 3 1.7 3 .23-.63-20.78.92-40.66-4.52-53.17z",
    className: "color3b609c svgShape"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1678.31 1265.34c2.07-14.78 4.58-32 2.27-45.3l-18.06 1.43 4.35 47.82 1 3.4zM1650.68 1267.85l-1.62 55.14c.12 1.49 2.58 2.32 2.87.88 3.89-20.43 13.77-45.51 11.17-58.89z",
    className: "color3b609c svgShape"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1662.78,1266.16a86.06,86.06,0,0,0,8-43.14l-17.74-3.34-2.28,47.85.27,3.55Z",
    className: "color3b609c svgShape"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1652.12,1206.27l.36,17.63c3,6.48,27.46,2.33,28.1-3.86l-2.72-22.28Z",
    className: "color5388dc svgShape"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1678.28,1201.2c3.15-9,8.69-32.07,6.2-35.81-7.16-2.9-25.71,3.28-35.08,10.79l2.72,30.09Z",
    className: "color5388dc svgShape"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1639.24,1204.64c1.91,1.45,3.71,2.16,5.34,1.77a209.27,209.27,0,0,0,11.81-20.94c.73-4.13-.85-11.66-7-9.29l-10.66,26.28Z",
    className: "color5388dc svgShape"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1643.41,1199l-17.49-26.25-2.42,1.3c.76,6.78,8.89,24.77,15.74,30.64Z",
    className: "color5388dc svgShape"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1623.5,1174l-.44-5.92-1.51-4.55,2,.19a3.18,3.18,0,0,1,2.61,1.9l.83,1.9-.8,5.53Z",
    className: "colorf4acc8 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1002.64 1181.29 898.85 1181.29 898.85 1158.49 1006.41 1158.61 1028.49 1168.32 1002.64 1181.29",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#dg)",
    opacity: 0.5
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1002.64 1181.29l-9.41-.94a2.31 2.31 0 111-4.46l8.84 3.36a1.07 1.07 0 01.65 1.23A1 1 0 011002.64 1181.29zM1031.6 1155.65l-34.61-16-11.34 2.48-11.33-2.48-34.61 16c-5.1 2.41-6.61 9.58-.39 11.92 10.07-1 21.9-2 32.32-4.11a70 70 0 0128 0c10.41 2.13 22.24 3.07 32.31 4.11C1038.21 1165.23 1036.69 1158.06 1031.6 1155.65zM968.67 1181.29l9.4-.94a2.31 2.31 0 10-1.05-4.46l-8.84 3.36a1.06 1.06 0 00.49 2z",
    className: "color3b609c svgShape"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M939.32,1167.57l53.4,11.46c1.53.31,3-1.93,1.69-2.63-19.4-9.67-37.69-20.9-51.85-22.07C934.91,1155.92,932.22,1165.13,939.32,1167.57Z",
    className: "color3b609c svgShape"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1032,1167.57,978.58,1179c-1.52.31-3.05-1.93-1.68-2.63,19.39-9.67,37.68-20.9,51.85-22.07C1036.4,1155.92,1039.09,1165.13,1032,1167.57Z",
    className: "color3b609c svgShape"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M973.19,1128.67l-1.46,11.63c.34,3.24,7,4.58,14.24,4.58s13.91-1.34,14.25-4.58l-1.46-11.63Z",
    className: "color5388dc svgShape"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1005.44,1094c-3.74-2.19-11.6-3.7-19.47-3.7s-15.73,1.51-19.46,3.7c-2.55,3.53,5,27.72,6.5,36.16h25.93C1000.43,1121.67,1008,1097.48,1005.44,1094Z",
    className: "color5388dc svgShape"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M949.26,1129.38S960.37,1103,966.5,1094c2.34,2.29,5.7,9.56,6.58,14.29l-11.44,17.68Z",
    className: "color5388dc svgShape"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M961.08,1125.37l-11.82,4c4,5.27,17,11.76,25.81,13.17l.95-2.86Z",
    className: "color5388dc svgShape"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M975.07,1142.55l4.76,1.47,3,2.3.32-2c.19-2.11-.57-4.19-2.94-4.46l-4.22-.14Z",
    className: "colorf4acc8 svgShape"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1022.69,1129.38s-11.11-26.34-17.24-35.43c-2.34,2.29-5.7,9.56-6.58,14.29l11.43,17.68Z",
    className: "color5388dc svgShape"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1010.87,1125.37l11.82,4c-4,5.27-17,11.76-25.81,13.17l-1-2.86Z",
    className: "color5388dc svgShape"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M996.88,1142.55l-4.76,1.47-3,2.3-.32-2c-.19-2.11.57-4.19,2.94-4.46l4.22-.14Z",
    className: "colorf4acc8 svgShape"
  })), _polygon467 || (_polygon467 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aceff4",
    points: "988.83 1084.79 984.11 1084.79 982.41 1095.44 990.54 1095.44 988.83 1084.79",
    className: "colorf4acc8 svgShape"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M984.61,1075.7l-1.12.66a3.66,3.66,0,0,0-1.8,3.16v6.75a3.69,3.69,0,0,0,.71,2.18l1.12,1.51a3.66,3.66,0,0,0,5.91,0l1.11-1.51a3.63,3.63,0,0,0,.72-2.18v-6.75a3.67,3.67,0,0,0-1.81-3.16l-1.11-.66A3.67,3.67,0,0,0,984.61,1075.7Z",
    className: "colorf4acc8 svgShape"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M989.34,1072.64H983.6c-2.53,0-4,1.53-3.53,4.19l1.62,9.15v-6.67l4.74.69c.09,0,4.83-.69,4.83-.69V1086l1.62-9.15C993.33,1074.17,991.87,1072.64,989.34,1072.64Z",
    className: "color3b609c svgShape"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6f5fa",
    d: "M1010.5,1125.37h-49a2.07,2.07,0,0,0-2,2.47l4.53,23.32a2.07,2.07,0,0,0,2,1.68h40a2.07,2.07,0,0,0,2-1.68l4.53-23.32A2.07,2.07,0,0,0,1010.5,1125.37Z",
    className: "colorb6d1fa svgShape"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M990.33,1139.11c0,1.92-2,3.48-4.36,3.48s-4.35-1.56-4.35-3.48,2-3.49,4.35-3.49S990.33,1137.18,990.33,1139.11Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1231.18 904.43 1144.86 904.43 1144.86 891.82 1225.58 891.82 1232.64 892.17 1231.18 904.43",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#dh)",
    opacity: 0.5
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1222.87 895.19a2 2 0 011.23-1.63l8.13-2.49a1 1 0 01.78 1.79l-7.51 5c-1.1.68-2.49.28-2.49-.51zM1231.63 904.4l10.41-2.69a1 1 0 00-.25-1.93l-11.09.07a1.08 1.08 0 00-1.12 1.22V903C1229.58 904.2 1231.11 904.53 1231.63 904.4z",
    className: "color5388dc svgShape"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1233.44,738.72c.32,1.52-3.41,3.75-6.33,2.63l-3.52-2.34-3.4-7.36,2.62-5.68,8.69.53Z",
    className: "colorf4acc8 svgShape"
  })), _polygon468 || (_polygon468 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aceff4",
    points: "1228.17 740.32 1229.37 750.22 1221.41 749.63 1222.49 737.54 1228.17 740.32",
    className: "colorf4acc8 svgShape"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1228.86,844.85,1225.74,894c-.16,1.47-2.62,2.23-2.87.79-3.31-20.36-6.25-38.06-5.64-52.63Z",
    className: "colorf4acc8 svgShape"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1212.73,777.73l-5.15-2.14s3.4-18.68,6.28-28.7l9.16,2.31-8.5,27.22Z",
    className: "color5388dc svgShape"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1214.52,776.42l7.13,30.48-2.59.86c-4.39-5.14-11.89-23.23-11.48-32.17Z",
    className: "color5388dc svgShape"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1221.65,806.9l2.89,3.76,3.06,1.94-1.7,1a3.16,3.16,0,0,1-3.21-.06l-1.75-1.08-1.88-4.66Z",
    className: "colorf4acc8 svgShape"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1217.28 843.35c-2-14.67-4.54-31.79-2.25-44.94l17.92 1.41-4.31 47.44-1 3.38zM1248.65 848.25l-16 52.38c-.47 1.4-3 1.59-3 .13 1.33-20.59 2-44.79 7.7-58.35z",
    className: "colorf4acc8 svgShape"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1215.43,839.81c0-12.69-7.87-35.72-2.83-48.37l30.07,4.4c5.1,11,6,29.71,6.49,49.13l-.51,3.28C1233.66,847.23,1218.23,846.41,1215.43,839.81Z",
    className: "color3b609c svgShape"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1241.17,779.7l1.88,17c-3,6.43-29.82.87-30.45-5.27l7.41-11.72Z",
    className: "color5388dc svgShape"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1220,779.72c-3.13-8.89-8.63-29.12-6.15-32.83,7.1-2.89,17.43.55,26.73,8l.69,29.85Z",
    className: "color5388dc svgShape"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1261.62,745.81l1.82,5.28s-13.25,7.94-22.65,12.45l-7.42-5.68,26.09-12.52Z",
    className: "color5388dc svgShape"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d2dc",
    d: "M1259.46,745.34l18.06-25.57,2.36,1.37c-.93,6.7-9.48,24.32-16.44,30Z",
    className: "color5388dc svgShape"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#aceff4",
    d: "M1277.52,719.77l.89-4.65-.58-3.58,1.85.64a3.13,3.13,0,0,1,2.08,2.44l.36,2-2.24,4.5Z",
    className: "colorf4acc8 svgShape"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1212.73,746.86l3.54-2.73a4,4,0,0,0,1.43-4.21l-.47-1.81a4.06,4.06,0,0,1,.66-3.41l.45-.61a4,4,0,0,1,1.15-1,4.46,4.46,0,0,1,.49-3.33l1.78-3a4.48,4.48,0,0,1,3.85-2.17h5.83l2.17-.42-1.19,2.16-2.39,3.42c-1.67,2.89.64,16.41.64,16.41a5.41,5.41,0,0,0,.47,2.21,4,4,0,0,1-1.29,5.35,11.19,11.19,0,0,1-7,1.81l-6.7-.54a5.48,5.48,0,0,1-4.65-3.46A4,4,0,0,1,1212.73,746.86Z",
    className: "color3b609c svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainNetwork);
export default __webpack_public_path__ + "static/media/blockchain-network.5b83f79372a72a6fe469ce5fe1eddd60.svg";
export { ForwardRef as ReactComponent };